import type { Namespace } from '@govard/i18n-core';

export const featuresEn: Namespace = {
  'features.task_detail.complete': 'Mark complete',
  'features.task_detail.reopen': 'Reopen',
  'features.task_detail.add_note': 'Add note',
  'features.task_detail.action_error': 'Action failed',
  'features.task_detail.status': 'Status',
  'features.task_detail.row_status': 'Task status: {title}',
  'features.task_detail.priority': 'Priority',
  'features.task_detail.unassigned': 'Unassigned',
  'features.task_detail.links': 'Links',
  'features.task_detail.author': 'Author',
  'features.task_detail.updated': 'Updated',
  'features.task_detail.completed': 'Completed',
  'features.task_detail.related': 'Related tasks',
  'features.task_detail.last_notes': 'Latest notes',
  'features.task_detail.last_activity': 'Latest activity',
  'features.task_detail.group_by': 'Group by',
  'features.task_detail.count': { one: 'task', other: 'tasks' },
  'features.columns.company': 'Company',
  'features.columns.industry': 'Industry',
  'features.columns.contacts': 'Contacts',
  'features.columns.deals': 'Deals',
  'features.columns.tasks': 'Tasks',
  'features.columns.created_at': 'Created',
  'features.columns.title': 'Title',
  'features.columns.type': 'Type',
  'features.columns.status': 'Status',
  'features.columns.amount': 'Amount',
  'features.columns.client_deal': 'Client / Deal',
  'features.columns.template': 'Template',
  'features.columns.channel': 'Channel',
  'features.columns.variables': 'Variables',
  'features.columns.usage_count': 'Uses',
  'features.columns.note': 'Note',
  'features.columns.links': 'Links',
  'features.columns.author': 'Author',
  'features.columns.priority': 'Priority',
  'features.columns.due_at': 'Due date',
  'features.columns.assignee': 'Assignee',
  'features.columns.deal': 'Deal',
  'features.columns.contact': 'Contact',
  'features.task.status.todo': 'To do',
  'features.task.status.in_progress': 'In progress',
  'features.task.status.blocked': 'Blocked',
  'features.task.status.done': 'Done',
  'features.task.status.cancelled': 'Cancelled',
  'features.task.priority.low': 'Low',
  'features.task.priority.medium': 'Medium',
  'features.task.priority.high': 'High',
  'features.task.priority.urgent': 'Urgent',

  // Project statuses (roadmap F3-4).
  'features.project.status.planned': 'Planned',
  'features.project.status.active': 'Active',
  'features.project.status.on_hold': 'On hold',
  'features.project.status.completed': 'Completed',
  'features.project.status.cancelled': 'Cancelled',
  'features.meeting.status.scheduled': 'Scheduled',
  'features.meeting.status.completed': 'Completed',
  'features.meeting.status.cancelled': 'Cancelled',
  'features.document.type.contract': 'Contract',
  'features.document.type.invoice': 'Invoice',
  'features.document.type.act': 'Act',
  'features.document.status.draft': 'Draft',
  'features.document.status.sent': 'Sent',
  'features.document.status.signed': 'Signed',
  'features.document.status.cancelled': 'Cancelled',
  'features.features.activity.components.entityhistorybutton.история': 'History',
  'features.features.activity.components.entityhistorybutton.история_2': 'History',
  'features.features.activity.components.entityhistorybutton.не_удалось_загрузить_историю':
    'Failed to load history',
  'features.features.activity.components.entityhistorybutton.событий_пока_нет':
    'There are no events yet',
  'features.features.activity.lib.describeactivity.запись': 'record',
  'features.features.activity.lib.describeactivity.срок_прошел': 'The deadline has passed',
  'features.features.ai.chat.components.agentcapabilitiescard.nedostupno': 'Not available',
  'features.features.ai.chat.components.agentcapabilitiescard.s_podtverzhdeniem':
    'Requires confirmation',
  'features.features.ai.chat.components.agentcapabilitiescard.agentnaya_logika': 'Agent logic',
  'features.features.ai.chat.components.agentcapabilitiescard.zhivoy_katalog_tools_iz_backend_chtenie_vypo':
    'Live tools directory from the backend: reading is performed immediately, actions occur through confirmation.',
  'features.features.ai.chat.components.agentcapabilitiescard.dlya_tekushchikh_prav_net_dostupnykh_agent_tools':
    'There are no agent tools available with your current permissions.',
  'features.features.ai.chat.components.antdesignxchatsurface.vyzov_instrumenta': 'Calling a tool',
  'features.features.ai.chat.components.antdesignxchatsurface.istochniki': 'Sources',
  'features.features.ai.chat.components.antdesignxchatsurface.otvet_formiruetsya':
    'Generating a response',
  'features.features.ai.chat.components.antdesignxchatsurface.ostanovit': 'Stop',
  'features.features.ai.chat.components.antdesignxchatsurface.povtorit': 'Retry',
  'features.features.ai.chat.components.boundedmarkdownrenderer.blok_slishkom_bolshoy_dlya_bezopasnogo_rende':
    'The block is too large to render safely.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.json_slishkom_glubokiy_dlya_bezopasnogo_rend':
    'JSON is too deep to render securely.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.json_soderzhit_slishkom_mnogo_uzlov_dlya_bezo':
    'JSON contains too many nodes to render safely.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.blok_soderzhit_nebezopasnye_ssylki_ili_call':
    'The block contains unsafe links or callbacks.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.render_mermaid_prevysil_bezopasnyy_limit_v':
    'Mermaid render exceeded safe time limit.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.mermaid_ne_smog_bezopasno_otrenderit_diag':
    'Mermaid was unable to render the chart safely.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.blok_ne_raspoznan_kak_bezopasnyy_format':
    'The block is not recognized as a safe format.',
  'features.features.ai.chat.components.boundedmarkdownrenderer.soobshchenie_slishkom_bolshoe_dlya_bezopasnogo_':
    'The message is too large to be safely rendered by Markdown.',
  'features.features.ai.chat.components.chatpanel.izmenit_vysotu_ai_chata': 'Change AI chat height',
  'features.features.ai.chat.components.chatpanel.potyanite_chtoby_izmenit_vysotu_chata':
    'Drag to resize the chat',
  'features.features.ai.chat.components.chatpanel.ne_udalos_izmenit_ai_shlyuz':
    'Failed to change AI gateway',
  'features.features.ai.chat.components.chatpanel.ne_udalos_izmenit_ai_shlyuz_2':
    'Failed to change AI gateway',
  'features.features.ai.chat.components.conversationswitcher.dialog': 'Conversation',
  'features.features.ai.chat.components.conversationswitcher.vybrat': 'Choose',
  'features.features.ai.chat.components.conversationswitcher.perepiska_udalitsya_bezvozvratno':
    'The conversation will be deleted permanently.',
  'features.features.ai.chat.components.conversationswitcher.udalit': 'Delete',
  'features.features.ai.chat.components.conversationswitcher.otmena': 'Cancel',
  'features.features.ai.chat.components.conversationswitcher.ne_udalos_udalit_dialogi':
    'Failed to delete conversations',
  'features.features.ai.chat.components.conversationswitcher.otmena_2': 'Cancel',
  'features.features.ai.chat.components.conversationswitcher.vybor_dialogov_na_udalenie':
    'Selecting conversations to delete',
  'features.features.ai.chat.components.conversationswitcher.dialog_2': 'Conversation',
  'features.features.ai.chat.components.conversationswitcher.novyy_dialog': 'New conversation',
  'features.features.ai.chat.components.dealchatcrudactions.verni_confirmation_card_i_ne_sokhranyay_zame':
    'Return the confirmation card and do not save the note without user confirmation.',
  'features.features.ai.chat.components.dealchatcrudactions.verni_approval_card_i_ne_menyay_stadiyu_bez_':
    'Return the approval card and do not change the stage without user confirmation.',
  'features.features.ai.chat.components.gatewayprofileselector.marshrut_modeli_zakreplen_za_tekushchim_dialog':
    'The model route is assigned to the current dialog',
  'features.features.ai.chat.components.gatewayprofileselector.ai_shlyuz': 'AI gateway',
  'features.features.ai.chat.components.openroutermodelselector.model_sokhranyaetsya_tolko_v_etom_brauzere':
    'The model is saved only in this browser',
  'features.features.ai.chat.components.openroutermodelselector.model_openrouter':
    'OpenRouter model',
  'features.features.ai.chat.components.reasoningmodeswitch.model_obdumyvaet_otvet_pered_tem_kak_ego_':
    'The model thinks about the answer before giving it: more accurate with tools, but slower - thinking is not shown and looks like a pause',
  'features.features.ai.chat.components.reasoningmodeswitch.model_otvechaet_srazu_bez_razmyshleniya_byst':
    'The model answers immediately, without thinking: much faster, but on multi-step questions it may make mistakes in choosing tools',
  'features.features.ai.chat.components.reasoningmodeswitch.razmyshlenie_modeli': 'Model reasoning',
  'features.features.ai.chat.components.reasoningmodeswitch.razmyshlenie': 'Reasoning',
  'features.features.ai.chat.components.reasoningmodeswitch.vkl': 'on',
  'features.features.ai.chat.components.reasoningmodeswitch.vykl': 'off',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.dobavit_zametku':
    'Add a note?',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.sdelka': 'Deal',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.zametka_dobavlena':
    'Note added',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.ne_udalos_dobavit_zametku_poprobuyte_eshche':
    'The action failed. The note was not added.',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.rezultat_proveryaetsya':
    'Result pending verification',
  'features.features.ai.chat.components.snippets.adddealnoteconfirmationsnippet.podtverzhdenie_sokhraneno_rezultat_proveryaetsya':
    'The approval was saved. The result is being verified.',
  'features.features.ai.chat.components.snippets.dealactionplansnippet.vybrano': 'Selected:',
  'features.features.ai.chat.components.snippets.dealactionplansnippet.iz': 'from',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.podgotovka_k_razgovoru':
    'Preparing for the conversation',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.otkrytye_zadachi':
    'Open tasks',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.poslednie_zametki':
    'Latest notes',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.chto_sprosit_klientu':
    'What to ask the client',
  'features.features.ai.chat.components.snippets.dealcallpreparationsnippet.eto_tolko_podgotovka_dannye_crm_ne_izmenya':
    'This is just preparation. CRM data has not been changed.',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.nizkiy': 'Short',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.sredniy': 'Average',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.vysokiy': 'High',
  'features.features.ai.chat.components.snippets.dealcockpitsnippet.srochnyy': 'Urgent',
  'features.features.ai.chat.components.snippets.dealrisksnippet.naydeno_signalov': 'Signals found',
  'features.features.ai.chat.components.snippets.dealsummarysnippet.sobytiya': 'Events',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.chto_trebuet_vnimaniya_segodnya':
    'What needs attention today?',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.obzor_na_segodnya':
    'Review for today',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.goryachie_sdelki':
    'Hot deals',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.prosrochennye_zadachi':
    'Overdue tasks',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.sdelki_s_riskom':
    'Deals with risk',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.srochnykh_signalov_na_segodnya_ne_naydeno':
    'No urgent signals found for today.',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.goryachie_sdelki_2':
    'Hot deals',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.prosrochennye_zadachi_2':
    'Overdue tasks',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.sdelki_s_riskom_2':
    'Deals with risk',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.prioritety': 'Priorities',
  'features.features.ai.chat.components.snippets.managerbriefingsnippet.eto_tolko_obzor_sdelki_zadachi_i_pisma_ne':
    'This is just a review. Deals, tasks and emails have not been changed.',
  'features.features.ai.chat.components.snippets.memorysnippet.pamyat': 'Memory',
  'features.features.ai.chat.components.snippets.viewsnippet.zakrepit': 'Pin',
  'features.features.ai.chat.components.snippets.viewsnippet.otkryt_zakreplennoe_predstavlenie':
    'Open pinned view',
  'features.features.ai.chat.components.snippets.viewsnippet.otkryt_na_dasborde':
    'Open on dashboard',
  'features.features.ai.chat.components.snippets.viewsnippet.po_zapisannym_primeram':
    'from recorded examples',
  'features.features.ai.chat.hooks.useentitychat.ne_udalos_poluchit_otvet_ot_llm_provayder':
    'Failed to receive a response from the LLM provider. Try again.',
  'features.features.approvals.lib.approvalsummary.удалить_контакт': 'Delete contact',
  'features.features.approvals.lib.approvalsummary.удалить_сделку': 'Delete deal',
  'features.features.approvals.lib.approvalsummary.сценарий': 'Scenario',
  'features.features.approvals.lib.approvalsummary.шаг': 'Step',
  'features.features.approvals.lib.approvalsummary.выполнить_шаг_сценария': 'Run scenario step',
  'features.features.approvals.lib.approvalsummary.новая_стадия': 'New stage',
  'features.features.approvals.lib.approvalsummary.причина': 'Reason',
  'features.features.approvals.lib.approvalsummary.сменить_стадию_сделки': 'Change deal stage',
  'features.features.approvals.lib.approvalsummary.дополнить_данные_контакта':
    'Add contact details',
  'features.features.approvals.lib.approvalsummary.кому': 'To whom',
  'features.features.approvals.lib.approvalsummary.тема': 'Subject',
  'features.features.approvals.lib.approvalsummary.текст': 'Text',
  'features.features.approvals.lib.approvalsummary.отправить_письмо': 'Send an email',
  'features.features.approvals.lib.approvalsummary.сценарий_2': 'Scenario',
  'features.features.approvals.lib.approvalsummary.запустить_сценарий': 'Run scenario',
  'features.features.approvals.lib.approvalsummary.уровень': 'Level',
  'features.features.approvals.lib.approvalsummary.ключ': 'Key',
  'features.features.approvals.lib.approvalsummary.значение': 'Value',
  'features.features.approvals.lib.approvalsummary.записать_в_память': 'Save to memory',
  'features.features.approvals.pages.approvalspage.действие': 'Action',
  'features.features.approvals.pages.approvalspage.объект': 'Object',
  'features.features.approvals.pages.approvalspage.создано': 'Created',
  'features.features.approvals.pages.approvalspage.истекает': 'Expires',
  'features.features.approvals.pages.approvalspage.срок_подтверждения_истек':
    'Confirmation period has expired',
  'features.features.approvals.pages.approvalspage.статус': 'Status',
  'features.features.approvals.pages.approvalspage.действия': 'Actions',
  'features.features.approvals.pages.approvalspage.подтвердить': 'Confirm',
  'features.features.approvals.pages.approvalspage.выполнить_действие': 'Run this action?',
  'features.features.approvals.pages.approvalspage.выполнить': 'Run',
  'features.features.approvals.pages.approvalspage.отмена': 'Cancel',
  'features.features.approvals.pages.approvalspage.подтвердить_2': 'Confirm',
  'features.features.approvals.pages.approvalspage.отклонить': 'Reject',
  'features.features.approvals.pages.approvalspage.отклонить_запрос': 'Decline the request?',
  'features.features.approvals.pages.approvalspage.отклонить_2': 'Reject',
  'features.features.approvals.pages.approvalspage.отмена_2': 'Cancel',
  'features.features.approvals.pages.approvalspage.отклонить_3': 'Reject',
  'features.features.approvals.pages.approvalspage.подтверждения': 'Confirmations',
  'features.features.approvals.pages.approvalspage.действия_ассистента_которые_не_выполняются':
    'Assistant actions that are not performed without your decision.',
  'features.features.approvals.pages.approvalspage.обновить': 'Update',
  'features.features.approvals.pages.approvalspage.обновить_2': 'Update',
  'features.features.approvals.pages.approvalspage.фильтр_по_статусу': 'Filter by status',
  'features.features.approvals.pages.approvalspage.не_удалось_применить_решение':
    'Failed to apply solution',
  'features.features.approvals.pages.approvalspage.действие_не_выполнено':
    'Action was not completed',
  'features.features.approvals.pages.approvalspage.подтверждение_сохранено_но_исполнение_завершилось_ошибкой':
    'The approval was saved, but execution failed. The action was not retried.',
  'features.features.approvals.pages.approvalspage.не_удалось_загрузить_подтверждения':
    'Failed to load confirmations',
  'features.features.approvals.pages.approvalspage.нет_запросов_ожидающих_решения':
    'No requests pending',
  'features.features.approvals.pages.approvalspage.записей_нет': 'No entries',
  'features.features.attachments.api.attachments.client.не_удалось_загрузить_файл':
    'Failed to upload file',
  'features.features.attachments.components.entityattachmentspanel.файлы': 'Files',
  'features.features.attachments.components.entityattachmentspanel.не_удалось_открыть_файл':
    'Failed to open file',
  'features.features.attachments.components.entityattachmentspanel.загрузить_файл': 'Upload file',
  'features.features.attachments.components.entityattachmentspanel.ошибка_операции_с_файлом':
    'File operation error',
  'features.features.attachments.components.entityattachmentspanel.не_удалось_загрузить_файлы':
    'Failed to upload files',
  'features.features.attachments.components.entityattachmentspanel.файлов_пока_нет': 'No files yet',
  'features.features.attachments.components.entityattachmentspanel.удалить_файл': 'Delete file',
  'features.features.attachments.components.entityattachmentspanel.удалить_файл_2':
    'Delete the file?',
  'features.features.attachments.components.entityattachmentspanel.файл_пропадет_из_карточки_запись_об_этом_о':
    'The file will disappear from the card; a record of this will remain in history.',
  'features.features.companies.components.companyformmodal.редактировать_компанию': 'Edit company',
  'features.features.companies.components.companyformmodal.новая_компания': 'New company',
  'features.features.companies.components.companyformmodal.сохранить': 'Save',
  'features.features.companies.components.companyformmodal.создать': 'Create',
  'features.features.companies.components.companyformmodal.отмена': 'Cancel',
  'features.features.companies.components.companyformmodal.не_удалось_сохранить_компанию':
    'Failed to save company',
  'features.features.companies.components.companyformmodal.название': 'Name',
  'features.features.companies.components.companyformmodal.введите_название_компании':
    'Enter company name',
  'features.features.companies.components.companyformmodal.ооо_ромашка': 'LLC "Romashka"',
  'features.features.companies.components.companyformmodal.отрасль': 'Industry',
  'features.features.companies.components.companyformmodal.услуги_ритейл': 'Services, retail…',
  'features.features.companies.components.companyformmodal.телефон': 'Phone',
  'features.features.companies.components.companyformmodal.домен': 'Domain',
  'features.features.companies.components.companyformmodal.сайт': 'Website',
  'features.features.companies.components.companyformmodal.описание': 'Description',
  'features.features.companies.components.companyformmodal.чем_занимается_компания':
    'What does the company do?',
  'features.features.companies.pages.companiespage.компания': 'Company',
  'features.features.companies.pages.companiespage.отрасль': 'Industry',
  'features.features.companies.pages.companiespage.контакты': 'Contacts',
  'features.features.companies.pages.companiespage.сделки': 'Deals',
  'features.features.companies.pages.companiespage.задачи': 'Tasks',
  'features.features.companies.pages.companiespage.дата_создания': 'Created',
  'features.features.companies.pages.companiespage.действия': 'Actions',
  'features.features.companies.pages.companiespage.редактировать': 'Edit',
  'features.features.companies.pages.companiespage.история_компании': 'Company history',
  'features.features.companies.pages.companiespage.удалить_компанию': 'Delete company',
  'features.features.companies.pages.companiespage.удалить_компанию_2': 'Delete company?',
  'features.features.companies.pages.companiespage.контакты_сделки_и_задачи_останутся_но_поте':
    'Contacts, deals and tasks will remain, but will lose their connection to the company.',
  'features.features.companies.pages.companiespage.компании': 'Companies',
  'features.features.companies.pages.companiespage.компания_хаб_к_ней_привязываются_контакты_':
    'The company is a hub: contacts, tasks and deals are attached to it.',
  'features.features.companies.pages.companiespage.новая_компания': 'New company',
  'features.companies_list.search_label': 'Search companies',
  'features.companies_list.select_row': 'Select company {name}',
  'features.companies_list.empty_filtered': 'No companies match the current filters',
  'features.features.companies.pages.companiespage.поиск_по_названию_или_отрасли':
    'Search by name or industry...',
  'features.features.companies.pages.companiespage.не_удалось_загрузить_компании':
    'Failed to load companies',
  'features.features.companies.pages.companiespage.компаний_пока_нет': 'No companies yet',
  'features.features.companies.pages.companydetailpage.компания_не_найдена': 'Company not found',
  'features.features.companies.pages.companydetailpage.к_компании_пока_не_привязан_ни_один_контак':
    'There are no contacts associated with the company yet',
  'features.features.companies.pages.companydetailpage.у_компании_и_ее_контактов_пока_нет_сделок':
    'The company and its contacts have no deals yet',
  'features.features.companies.pages.companydetailpage.к_компаниям': 'Back to companies',
  'features.features.companies.pages.companydetailpage.удалить': 'Delete',
  'features.features.companies.pages.companydetailpage.удалить_компанию': 'Delete company?',
  'features.features.companies.pages.companydetailpage.связанные_контакты_сделки_задачи_и_докумен':
    'Related contacts, deals, tasks and documents will remain, but will no longer be associated with this company.',
  'features.company_detail.summary': 'Summary',
  'features.company_detail.details': 'Details',
  'features.company_detail.contacts': 'Contacts',
  'features.company_detail.open_deals': 'Open deals',
  'features.company_detail.activity': 'Activity',
  'features.company_detail.tasks': 'Tasks',
  'features.company_detail.tasks_hint':
    'Open / overdue. Includes tasks of the company’s contacts, deals and documents',
  'features.company_detail.updated': 'Updated',
  'features.company_detail.industry': 'Industry',
  'features.company_detail.domain': 'Domain',
  'features.company_detail.website': 'Website',
  'features.company_detail.phone': 'Phone',
  'features.company_detail.description': 'Description',
  'features.company_detail.all': 'All →',
  'features.company_detail.open_tasks': 'Open tasks ({count})',
  'features.company_detail.recent_notes': 'Recent notes',
  'features.company_detail.empty_open_deals': 'No open deals',
  'features.company_detail.empty_open_tasks': 'No open tasks',
  'features.company_detail.deals_count': 'Deals: {count}',
  'features.company_detail.next_contact_at': 'Next contact: {date}',
  'features.company_detail.search_contacts': 'Search by name',
  'features.company_detail.sort_name': 'By name',
  'features.company_detail.sort_direction': 'Sort direction',
  'features.company_detail.sort_ascend': 'Ascending',
  'features.company_detail.sort_descend': 'Descending',
  'features.company_detail.sort_original': 'Original order',
  'features.company_detail.sort_created': 'By creation date',
  'features.company_detail.sort_deals': 'By deal count',
  'features.company_detail.sort_next_contact': 'By next contact',
  'features.company_detail.history_all': 'All',
  'features.company_detail.history_deals': 'Deals',
  'features.company_detail.history_contacts': 'Contacts',
  'features.company_detail.history_tasks': 'Tasks',
  'features.company_detail.history_notes': 'Notes',
  'features.company_detail.event_company': 'Company',
  'features.company_detail.event_deal': 'Deal',
  'features.company_detail.event_contact': 'Contact',
  'features.company_detail.event_task': 'Task',
  'features.company_detail.event_note': 'Note',
  'features.company_detail.event_meeting': 'Meeting',
  'features.company_detail.event_document': 'Document',
  'features.company_detail.event_file': 'File',
  'features.company_detail.event_other': 'Activity',
  'features.company_detail.retry': 'Retry',
  'features.features.contacts.components.contactformmodal.редактировать_контакт': 'Edit contact',
  'features.features.contacts.components.contactformmodal.сохранить': 'Save',
  'features.features.contacts.components.contactformmodal.отмена': 'Cancel',
  'features.features.contacts.components.contactformmodal.не_удалось_сохранить_контакт':
    'Failed to save contact',
  'features.features.contacts.components.contactformmodal.не_удалось_создать_контакт':
    'Failed to create contact',
  'features.features.contacts.components.contactformmodal.введите_имя': 'Enter name',
  'features.features.contacts.components.contactformmodal.иван': 'Ivan',
  'features.features.contacts.components.contactformmodal.петров': 'Petrov',
  'features.features.contacts.components.contactformmodal.похоже_это_не_email':
    "Looks like it's not an email",
  'features.features.contacts.components.contactformmodal.компания': 'Company',
  'features.features.contacts.components.contactformmodal.без_компании': 'No company',
  'features.features.contacts.components.contactinteractionspanel.история_взаимодействий':
    'Interaction history',
  'features.features.contacts.components.contactinteractionspanel.тип': 'Type',
  'features.features.contacts.components.contactinteractionspanel.тема': 'Subject',
  'features.features.contacts.components.contactinteractionspanel.канал': 'Channel',
  'features.features.contacts.components.contactinteractionspanel.когда': 'When',
  'features.features.contacts.components.contactinteractionspanel.действия': 'Actions',
  'features.features.contacts.components.contactinteractionspanel.редактировать': 'Edit',
  'features.features.contacts.components.contactinteractionspanel.редактировать_взаимодействие':
    'Edit interaction',
  'features.features.contacts.components.contactinteractionspanel.удалить_запись': 'Delete entry',
  'features.features.contacts.components.contactinteractionspanel.удалить_запись_2':
    'Delete entry?',
  'features.features.contacts.components.contactinteractionspanel.запись_пропадет_из_журнала_в_истории_конта':
    'The entry will disappear from the journal; A trace of deletion will remain in the contact history.',
  'features.features.contacts.components.contactinteractionspanel.записать': 'Write down',
  'features.features.contacts.components.contactinteractionspanel.не_удалось_загрузить_взаимодействия':
    'Failed to load interactions',
  'features.features.contacts.components.contactinteractionspanel.пока_ничего_не_записано':
    'No interactions yet',
  'features.features.contacts.components.contactinteractionspanel.редактировать_взаимодействие_2':
    'Edit interaction',
  'features.features.contacts.components.contactinteractionspanel.записать_состоявшееся_взаимодействие':
    'Record the interaction that took place',
  'features.features.contacts.components.contactinteractionspanel.сохранить': 'Save',
  'features.features.contacts.components.contactinteractionspanel.отмена': 'Cancel',
  'features.features.contacts.components.contactinteractionspanel.не_удалось_сохранить':
    'Failed to save',
  'features.features.contacts.components.contactinteractionspanel.тип_2': 'Type',
  'features.features.contacts.components.contactinteractionspanel.выберите_тип': 'Select type',
  'features.features.contacts.components.contactinteractionspanel.фиксируется_уже_состоявшееся_общение_назна':
    'Communication that has already taken place is recorded. Schedule a meeting with participants and invitation - in the “Meetings” tab.',
  'features.features.contacts.components.contactinteractionspanel.тема_2': 'Subject',
  'features.features.contacts.components.contactinteractionspanel.обсудили_условия':
    'Discussed the due dates',
  'features.features.contacts.components.contactinteractionspanel.детали': 'Details',
  'features.features.contacts.components.contactinteractionspanel.канал_2': 'Channel',
  'features.features.contacts.components.contactinteractionspanel.телефон_whatsapp_почта':
    'Phone, WhatsApp, mail...',
  'features.features.contacts.components.contactinteractionspanel.когда_2': 'When',
  'features.features.contacts.pages.contactdetailpage.загрузка_контакта': 'Loading contact...',
  'features.features.contacts.pages.contactdetailpage.контакт_не_найден': 'Contact not found',
  'features.features.contacts.pages.contactdetailpage.попробуйте_открыть_карточку_еще_раз':
    'Try opening the contact again.',
  'features.features.contacts.pages.contactdetailpage.повторить': 'Repeat',
  'features.features.contacts.pages.contactdetailpage.информация': 'Information',
  'features.features.contacts.pages.contactdetailpage.контактная_информация': 'Contact information',
  'features.features.contacts.pages.contactdetailpage.источник': 'Source',
  'features.features.contacts.pages.contactdetailpage.не_указан': 'Not set',
  'features.features.contacts.pages.contactdetailpage.компания': 'Company',
  'features.features.contacts.pages.contactdetailpage.частное_лицо_без_компании':
    'Individual (no company)',
  'features.features.contacts.pages.contactdetailpage.открыть_карточку_компании':
    'Open company card →',
  'features.features.contacts.pages.contactdetailpage.контакт_числится_частным_лицом':
    'The contact is listed as a private person',
  'features.features.contacts.pages.contactdetailpage.теги': 'Tags',
  'features.features.contacts.pages.contactdetailpage.нет_тегов': 'No tags',
  'features.features.contacts.pages.contactdetailpage.заметки': 'Notes',
  'features.features.contacts.pages.contactdetailpage.заметок_пока_нет': 'No notes yet.',
  'features.features.contacts.pages.contactdetailpage.сделки_контакта': 'Contact deals',
  'features.features.contacts.pages.contactdetailpage.нет_привязанных_сделок':
    'There are no linked deals.',
  'features.features.contacts.pages.contactdetailpage.сделка': 'Deal',
  'features.features.contacts.pages.contactdetailpage.стадия': 'Stage',
  'features.features.contacts.pages.contactdetailpage.сумма': 'Amount',
  'features.features.contacts.pages.contactdetailpage.заметки_по_контакту': 'Notes on contact',
  'features.features.contacts.pages.contactdetailpage.задачи_контакта': 'Contact tasks',
  'features.features.contacts.pages.contactdetailpage.встречи_с_контактом':
    'Meeting with a contact',
  'features.features.contacts.pages.contactdetailpage.документы_контакта': 'Contact documents',
  'features.features.contacts.pages.contactdetailpage.файлы': 'Files',
  'features.features.contacts.pages.contactdetailpage.история_взаимодействий':
    'Interaction history',
  'features.features.contacts.pages.contactdetailpage.история_взаимодействий_2':
    'Interaction history',
  'features.features.contacts.pages.contactdetailpage.к_контактам': 'Back to contacts',
  'features.features.contacts.pages.contactdetailpage.к_контактам_2': 'Back to contacts',
  'features.features.contacts.pages.contactdetailpage.канал_связи_не_указан':
    'Communication channel not set',
  'features.features.contacts.pages.contactdetailpage.написать': 'Write',
  'features.features.contacts.pages.contactdetailpage.позвонить': 'Call',
  'features.features.contacts.pages.contactdetailpage.редактировать': 'Edit',
  'features.features.contacts.pages.contactdetailpage.история_контакта': 'Contact history',
  'features.features.contacts.pages.contactdetailpage.удалить_контакт': 'Delete contact',
  'features.features.contacts.pages.contactdetailpage.удалить_контакт_2': 'Delete contact?',
  'features.features.contacts.pages.contactdetailpage.сделки_задачи_и_заметки_контакта_останутся':
    "The contact's deals, tasks, and notes will remain, but will no longer be linked.",
  'features.features.contacts.pages.contactdetailpage.активные_сделки': 'Active deals',
  'features.features.contacts.pages.contactdetailpage.последняя_активность': 'Last activity',
  'features.features.contacts.pages.contactspage.контакт': 'Contact',
  'features.features.contacts.pages.contactspage.компания': 'Company',
  'features.features.contacts.pages.contactspage.частное_лицо': 'Private person',
  'features.features.contacts.pages.contactspage.сделки': 'Deals',
  'features.features.contacts.pages.contactspage.дата_создания': 'Created',
  'features.features.contacts.pages.contactspage.теги': 'Tags',
  'features.features.contacts.pages.contactspage.действия': 'Actions',
  'features.features.contacts.pages.contactspage.нет_email': 'No email',
  'features.features.contacts.pages.contactspage.нет_телефона': 'No phone',
  'features.features.contacts.pages.contactspage.создать_задачу_по_контакту':
    'Create a task for a contact',
  'features.features.contacts.pages.contactspage.редактировать': 'Edit',
  'features.features.contacts.pages.contactspage.история_контакта': 'Contact history',
  'features.features.contacts.pages.contactspage.удалить_контакт': 'Delete contact',
  'features.features.contacts.pages.contactspage.удалить_контакт_2': 'Delete contact?',
  'features.features.contacts.pages.contactspage.сделки_задачи_и_заметки_контакта_останутся':
    "The contact's deals, tasks, and notes will remain, but will no longer be linked.",
  'features.features.contacts.pages.contactspage.контактов_по_фильтру': 'contacts by filter',
  'features.features.contacts.pages.contactspage.контактов_единая_клиентская_база':
    'contacts · unified customer base',
  'features.features.contacts.pages.contactspage.канбан': 'Kanban',
  'features.features.contacts.pages.contactspage.канбан_2': 'Kanban',
  'features.features.contacts.pages.contactspage.список': 'List',
  'features.features.contacts.pages.contactspage.список_2': 'List',
  'features.features.contacts.pages.contactspage.карточки': 'Cards',
  'features.features.contacts.pages.contactspage.карточки_2': 'Cards',
  'features.features.contacts.pages.contactspage.новый_контакт': 'New contact',
  'features.features.contacts.pages.contactspage.новый_контакт_2': 'New contact',
  'features.features.contacts.pages.contactspage.обновить': 'Update',
  'features.features.contacts.pages.contactspage.обновить_контакты': 'Update contacts',
  'features.features.contacts.pages.contactspage.поиск_по_контакту_или_телефону':
    'Search by contact or phone',
  'features.features.contacts.pages.contactspage.фильтр_контактов': 'Contact filter',
  'features.features.contacts.pages.contactspage.все_контакты': 'All contacts',
  'features.features.contacts.pages.contactspage.со_сделками': 'With deals',
  'features.features.contacts.pages.contactspage.с_email': 'From email',
  'features.features.contacts.pages.contactspage.фильтр_по_тегу': 'Filter by tag',
  'features.features.contacts.pages.contactspage.все_теги': 'All tags',
  'features.features.contacts.pages.contactspage.всего_контактов': 'Total contacts',
  'features.features.contacts.pages.contactspage.со_сделками_2': 'With deals',
  'features.features.contacts.pages.contactspage.с_email_2': 'From email',
  'features.features.contacts.pages.contactspage.нет_контактов_по_текущим_фильтрам':
    'There are no contacts for the current filters.',
  'features.features.dashboard.dashboard.vm.онлайн_записи': 'ONLINE RECORDINGS',
  'features.features.dashboard.dashboard.vm.свободные_окна': 'VACANT WINDOWS',
  'features.features.dashboard.dashboard.vm.новые_клиенты': 'NEW CLIENTS',
  'features.features.dashboard.dashboard.vm.возвратность': 'RETENTION',
  'features.features.dashboard.dashboard.vm.отмены': 'CANCELLATIONS',
  'features.features.dashboard.dashboard.vm.выручка_смена': 'REVENUE (SHIFT)',
  'features.features.dashboard.dashboard.vm.требует_внимания': 'Needs attention',
  'features.features.dashboard.dashboard.vm.напоминание_о_визите': 'Visit Reminder',
  'features.features.dashboard.dashboard.vm.сбор_отзыва_whatsapp': 'Collecting feedback (WhatsApp)',
  'features.features.dashboard.dashboard.vm.реактивация_спящих': 'Reactivation of sleepers',
  'features.features.dashboard.dashboard.vm.перенос_записи_конфликт': 'Transfer record (conflict)',
  'features.features.dashboard.dashboard.vm.новая_запись': 'New entry',
  'features.features.dashboard.dashboard.vm.требует_подтверждения': 'Requires confirmation',
  'features.features.dashboard.dashboard.vm.переговоры': 'Negotiation',
  'features.features.dashboard.dashboard.vm.услуга_оказана': 'Service provided',
  'features.features.deals.components.dealcard.следующий_шаг': 'Next contact',
  'features.features.deals.components.dealcard.контакт_просрочен': 'Contact overdue',
  'features.features.deals.components.dealcard.нужен_следующий_шаг': 'Needs next contact',
  'features.features.deals.components.dealcard.последний_контакт': 'Last contact',
  'features.features.deals.components.dealformmodal.редактировать_сделку': 'Edit deal',
  'features.features.deals.components.dealformmodal.новая_сделка': 'New deal',
  'features.features.deals.components.dealformmodal.сохранить': 'Save',
  'features.features.deals.components.dealformmodal.создать': 'Create',
  'features.features.deals.components.dealformmodal.отмена': 'Cancel',
  'features.features.deals.components.dealformmodal.не_удалось_сохранить_сделку':
    'Failed to save deal',
  'features.features.deals.components.dealformmodal.не_удалось_создать_сделку':
    'Failed to create deal',
  'features.features.deals.components.dealformmodal.обязательно_только_название_контакт_и_комп':
    'Only the name is required. You can select a contact and company later—or specify a company without a contact.',
  'features.features.deals.components.dealformmodal.название': 'Name',
  'features.features.deals.components.dealformmodal.введите_название_сделки':
    'Enter the name of the deal',
  'features.features.deals.components.dealformmodal.о_чем_сделка': "What's the deal?",
  'features.features.deals.components.dealformmodal.сумма': 'Amount',
  'features.features.deals.components.dealformmodal.сумма_не_может_быть_отрицательной':
    'The amount cannot be negative',
  'features.features.deals.components.dealformmodal.стадия': 'Stage',
  'features.features.deals.components.dealformmodal.источник': 'Source',
  'features.features.deals.components.dealformmodal.не_указан': 'Not set',
  'features.features.deals.components.dealformmodal.следующий_шаг': 'Next contact',
  'features.features.deals.components.deallistview.контакт_не_указан': 'Contact not set',
  'features.features.deals.components.deallistview.сделка': 'Deal',
  'features.features.deals.components.deallistview.компания': 'Company',
  'features.features.deals.components.deallistview.без_компании': 'No company',
  'features.features.deals.components.deallistview.контакт': 'Contact',
  'features.features.deals.components.deallistview.стадия': 'Stage',
  'features.features.deals.components.deallistview.сумма': 'Amount',
  'features.features.deals.components.deallistview.следующий_шаг': 'Next contact',
  'features.features.deals.components.deallistview.срок_следующего_шага_прошел':
    'Next contact is overdue',
  'features.features.deals.components.deallistview.дата_создания': 'Created',
  'features.features.deals.components.deallistview.действие': 'Action',
  'features.features.deals.components.deallistview.финальная': 'Final',
  'features.features.deals.components.deallistview.действия': 'Actions',
  'features.features.deals.components.deallistview.редактировать': 'Edit',
  'features.features.deals.components.deallistview.история_сделки': 'Deal history',
  'features.features.deals.components.deallistview.удалить_сделку': 'Delete deal',
  'features.features.deals.components.deallistview.удалить_сделку_2': 'Delete the deal?',
  'features.features.deals.components.deallistview.задачи_заметки_и_встречи_сделки_останутся_':
    'Tasks, notes, and deal meetings will remain, but will no longer be linked.',
  'features.features.deals.components.dealstagehistorypanel.история_стадий': 'History of stages',
  'features.features.deals.components.dealstagehistorypanel.не_удалось_загрузить_историю_стадий':
    'Failed to load stage history',
  'features.features.deals.components.dealstagehistorypanel.стадия_еще_не_менялась':
    'The stage has not changed yet',
  'features.features.deals.components.kanbanboard.без_шага': 'No contact:',
  'features.features.deals.components.kanbanboard.в_этой_стадии_пока_нет_сделок':
    'There are no deals at this stage yet.',
  'features.features.deals.lib.kanban.контакт_не_указан': 'Contact not set',
  'features.features.deals.pages.dealcardpage.редактировать': 'Edit',
  'features.features.deals.pages.dealcardpage.компания': 'Company',
  'features.features.deals.pages.dealcardpage.без_компании': 'No company',
  'features.features.deals.pages.dealcardpage.срок_следующего_шага_прошел':
    'Next contact is overdue',
  'features.features.deals.pages.dealcardpage.файлы': 'Files',
  'features.features.deals.pages.dealcardpage.стадии': 'Stages',
  'features.features.deals.pages.dealcardpage.история_стадий_сделки': 'History of deal stages',
  'features.features.deals.pages.dealcardpage.задачи_сделки': 'Deal tasks',
  'features.features.deals.pages.dealcardpage.встречи_по_сделке': 'Deal meetings',
  'features.features.deals.pages.dealcardpage.документы_сделки': 'Deal documents',
  'features.features.deals.pages.dealcardpage.история_сделки': 'Deal history',
  'features.features.deals.pages.dealcardpage.удалить_сделку': 'Delete deal',
  'features.features.deals.pages.dealcardpage.удалить_сделку_2': 'Delete the deal?',
  'features.features.deals.pages.dealcardpage.задачи_встречи_и_документы_останутся_но_по':
    'Tasks, meetings and documents will remain, but will no longer be linked to the deal.',
  'features.features.deals.pages.dealcardpage.срок_следующего_шага_прошел_2':
    'Next contact is overdue',
  'features.features.deals.pages.dealcardpage.готов': 'Ready',
  'features.features.deals.pages.dealcardpage.готов_2': 'Ready',
  'features.features.deals.pages.dealkanbanpage.загрузка_сделок': 'Loading deals...',
  'features.features.deals.pages.dealkanbanpage.не_удалось_загрузить_сделки':
    'Failed to load deals',
  'features.features.deals.pages.dealkanbanpage.сделки': 'Deals',
  'features.features.deals.pages.dealkanbanpage.сделок_по_фильтру': {
    one: '{count} deal by filter',
    other: '{count} deals by filter',
  },
  'features.features.deals.pages.dealkanbanpage.сделок_кросс_проектный_вид': {
    one: '{count} deal · cross-project view',
    other: '{count} deals · cross-project view',
  },
  'features.features.deals.pages.dealkanbanpage.канбан': 'Kanban',
  'features.features.deals.pages.dealkanbanpage.канбан_2': 'Kanban',
  'features.features.deals.pages.dealkanbanpage.список': 'List',
  'features.features.deals.pages.dealkanbanpage.список_2': 'List',
  'features.features.deals.pages.dealkanbanpage.карточки': 'Cards',
  'features.features.deals.pages.dealkanbanpage.карточки_2': 'Cards',
  'features.features.deals.pages.dealkanbanpage.новая_сделка': 'New deal',
  'features.features.deals.pages.dealkanbanpage.обновить_сделки': 'Refresh deals',
  'features.features.deals.pages.dealkanbanpage.поиск_сделок': 'Find deals',
  'features.features.deals.pages.dealkanbanpage.поиск_по_сделке_или_контакту':
    'Search by deal or contact',
  'features.features.deals.pages.dealkanbanpage.фильтр_по_стадии': 'Filter by stage',
  'features.features.deals.pages.dealkanbanpage.все_стадии': 'All stages',
  'features.features.deals.pages.dealkanbanpage.фильтр_по_активности': 'Filter by activity',
  'features.features.deals.pages.dealkanbanpage.все_активности': 'All activities',
  'features.features.deals.pages.dealkanbanpage.есть_следующий_шаг': 'Has next contact',
  'features.features.deals.pages.dealkanbanpage.без_следующего_шага': 'No next contact',
  'features.features.deals.pages.dealkanbanpage.сбросить_фильтры': 'Reset filters',
  'features.features.deals.pages.dealkanbanpage.всего_сделок': 'Total deals',
  'features.features.deals.pages.dealkanbanpage.активные': 'Active',
  'features.features.deals.pages.dealkanbanpage.требуют_внимания': 'Need attention',
  'features.features.deals.pages.dealkanbanpage.выбрано': 'selected',
  'features.features.deals.pages.dealkanbanpage.переместить_выбранные_сделки':
    'Move selected deals',
  'features.features.deals.pages.dealkanbanpage.переместить': 'Move',
  'features.features.deals.pages.dealkanbanpage.отменить': 'Cancel',
  'features.features.documents.components.documentformmodal.редактировать_документ':
    'Edit document',
  'features.features.documents.components.documentformmodal.новый_документ': 'New document',
  'features.features.documents.components.documentformmodal.сохранить': 'Save',
  'features.features.documents.components.documentformmodal.создать': 'Create',
  'features.features.documents.components.documentformmodal.отмена': 'Cancel',
  'features.features.documents.components.documentformmodal.не_удалось_сохранить_документ':
    'Failed to save document',
  'features.features.documents.components.documentformmodal.не_удалось_создать_документ':
    'Failed to create document',
  'features.features.documents.components.documentformmodal.название_документа': 'Document title',
  'features.features.documents.components.documentformmodal.введите_название_документа':
    'Enter document title',
  'features.features.documents.components.documentformmodal.договор': 'Contract No....',
  'features.features.documents.components.documentformmodal.тип': 'Type',
  'features.features.documents.components.documentformmodal.выберите_тип_документа':
    'Select document type',
  'features.features.documents.components.documentformmodal.статус': 'Status',
  'features.features.documents.components.documentformmodal.сумма': 'Amount',
  'features.features.documents.components.documentformmodal.файлы_документа': 'Document files',
  'features.features.documents.components.documentformmodal.файлы_можно_будет_прикрепить_сразу_после_с':
    'Files can be attached immediately after creation - in the same form or on the document card.',
  'features.features.documents.components.entitydocumentspanel.документы': 'Documents',
  'features.features.documents.components.entitydocumentspanel.документ': 'Document',
  'features.features.documents.components.entitydocumentspanel.тип': 'Type',
  'features.features.documents.components.entitydocumentspanel.статус': 'Status',
  'features.features.documents.components.entitydocumentspanel.сумма': 'Amount',
  'features.features.documents.components.entitydocumentspanel.создан': 'Created',
  'features.features.documents.components.entitydocumentspanel.не_удалось_загрузить_документы':
    'Failed to upload documents',
  'features.features.documents.components.entitydocumentspanel.документов_пока_нет':
    'No documents yet',
  'features.features.documents.pages.documentcardpage.загрузка_документа': 'Loading document...',
  'features.features.documents.pages.documentcardpage.ошибка_загрузки': 'Loading error',
  'features.features.documents.pages.documentcardpage.не_удалось_загрузить_документ':
    'Failed to load document',
  'features.features.documents.pages.documentcardpage.повторить': 'Try again',
  'features.features.documents.pages.documentcardpage.договор': 'Contract',
  'features.features.documents.pages.documentcardpage.счет': 'Invoice',
  'features.features.documents.pages.documentcardpage.акт': 'Act',
  'features.features.documents.pages.documentcardpage.черновик': 'Draft',
  'features.features.documents.pages.documentcardpage.отправлен': 'Sent',
  'features.features.documents.pages.documentcardpage.подписан': 'Signed',
  'features.features.documents.pages.documentcardpage.отменен': 'Canceled',
  'features.features.documents.pages.documentcardpage.к_списку_документов':
    'To the list of documents',
  'features.features.documents.pages.documentcardpage.сделка': 'Deal:',
  'features.features.documents.pages.documentcardpage.сохранить': 'Save',
  'features.features.documents.pages.documentcardpage.ошибка_сохранения':
    'Failed to save the document',
  'features.features.documents.pages.documentcardpage.история_документа': 'Document history',
  'features.features.documents.pages.documentcardpage.удалить_документ': 'Delete document',
  'features.features.documents.pages.documentcardpage.удалить_документ_2': 'Delete the document?',
  'features.features.documents.pages.documentcardpage.документ_пропадет_из_списков_связанные_сде':
    'The document will disappear from the lists; the related deal and contact will remain.',
  'features.features.documents.pages.documentcardpage.детали': 'Details',
  'features.features.documents.pages.documentcardpage.редактировать': 'Edit',
  'features.features.documents.pages.documentcardpage.тип': 'Type',
  'features.features.documents.pages.documentcardpage.статус': 'Status',
  'features.features.documents.pages.documentcardpage.сумма': 'Amount',
  'features.features.documents.pages.documentcardpage.компания': 'Company',
  'features.features.documents.pages.documentcardpage.без_компании': 'No company',
  'features.features.documents.pages.documentcardpage.контакт': 'Contact',
  'features.features.documents.pages.documentcardpage.без_контакта': 'No contact',
  'features.features.documents.pages.documentcardpage.сделка_2': 'Deal',
  'features.features.documents.pages.documentcardpage.без_сделки': 'No deal',
  'features.features.documents.pages.documentcardpage.текст_документа': 'Document text',
  'features.features.documents.pages.documentcardpage.начните_писать_текст_документа_или_попроси':
    'Start writing the text of the document or ask AI to generate it...',
  'features.features.documents.pages.documentcardpage.заметки_по_документу':
    'Notes on the document',
  'features.features.documents.pages.documentcardpage.задачи_по_документу': 'Document tasks',
  'features.features.documents.pages.documentcardpage.встречи_по_документу':
    'Meetings on the document',
  'features.features.documents.pages.documentcardpage.файлы': 'Files',
  'features.features.documents.pages.documentcardpage.файлы_документа': 'Document files',
  'features.features.documents.pages.documentcardpage.ai_помощник': 'AI Assistant',
  'features.features.documents.pages.documentcardpage.готов': 'Ready',
  'features.features.documents.pages.documentcardpage.документ_не_привязан_к_сделке_ассистенту_н':
    'This document is not linked to a deal, so the assistant has no deal context. Select a deal on the left to enable chat.',
  'features.features.documents.pages.documentspage.название': 'Name',
  'features.features.documents.pages.documentspage.тип': 'Type',
  'features.features.documents.pages.documentspage.договор': 'Contract',
  'features.features.documents.pages.documentspage.счет': 'Invoice',
  'features.features.documents.pages.documentspage.акт': 'Act',
  'features.features.documents.pages.documentspage.статус': 'Status',
  'features.features.documents.pages.documentspage.черновик': 'Draft',
  'features.features.documents.pages.documentspage.отправлен': 'Sent',
  'features.features.documents.pages.documentspage.подписан': 'Signed',
  'features.features.documents.pages.documentspage.отменен': 'Canceled',
  'features.features.documents.pages.documentspage.сумма': 'Amount',
  'features.features.documents.pages.documentspage.клиент_сделка': 'Client / Deal',
  'features.features.documents.pages.documentspage.дата_создания': 'Created',
  'features.features.documents.pages.documentspage.действия': 'Actions',
  'features.features.documents.pages.documentspage.редактировать': 'Edit',
  'features.features.documents.pages.documentspage.история_документа': 'Document history',
  'features.features.documents.pages.documentspage.удалить_документ': 'Delete document',
  'features.features.documents.pages.documentspage.удалить_документ_2': 'Delete the document?',
  'features.features.documents.pages.documentspage.документ_пропадет_из_списков_связанные_сде':
    'The document will disappear from the lists; the related deal and contact will remain.',
  'features.features.documents.pages.documentspage.документы': 'Documents',
  'features.features.documents.pages.documentspage.документов': 'documents',
  'features.features.documents.pages.documentspage.создать_документ': 'Create document',
  'features.features.documents.pages.documentspage.обновить': 'Update',
  'features.features.documents.pages.documentspage.поиск_по_документам': 'Search by documents',
  'features.features.documents.pages.documentspage.поиск_по_названию': 'Search by name...',
  'features.features.documents.pages.documentspage.фильтр_по_типу': 'Filter by type',
  'features.features.documents.pages.documentspage.все_типы': 'All types',
  'features.features.documents.pages.documentspage.договор_2': 'Contract',
  'features.features.documents.pages.documentspage.счет_2': 'Invoice',
  'features.features.documents.pages.documentspage.акт_2': 'Act',
  'features.features.documents.pages.documentspage.фильтр_по_статусу': 'Filter by status',
  'features.features.documents.pages.documentspage.все_статусы': 'All statuses',
  'features.features.documents.pages.documentspage.черновик_2': 'Draft',
  'features.features.documents.pages.documentspage.отправлен_2': 'Sent',
  'features.features.documents.pages.documentspage.подписан_2': 'Signed',
  'features.features.documents.pages.documentspage.отменен_2': 'Canceled',
  'features.features.documents.pages.documentspage.нет_документов': 'No documents.',
  'features.features.entity.links.entitylinkfields.компания': 'Company',
  'features.features.entity.links.entitylinkfields.без_компании': 'No company',
  'features.features.entity.links.entitylinkfields.другая': 'other',
  'features.features.entity.links.entitylinkfields.контакт': 'Contact',
  'features.features.entity.links.entitylinkfields.без_контакта': 'No contact',
  'features.features.entity.links.entitylinkfields.сделка': 'Deal',
  'features.features.entity.links.entitylinkfields.подходящих_сделок_нет':
    'There are no suitable deals',
  'features.features.entity.links.entitylinkfields.без_сделки': 'No deal',
  'features.features.entity.links.useentitylinkcascade.выбор_компании_оставит_в_списке_контактов_':
    'Selecting a company will leave only its employees in the contact list',
  'features.features.entity.links.useentitylinkcascade.компании_помеченные_другая_не_связаны_с_вы':
    'Companies marked "other" are not associated with the selected contact - selecting this will clear the contact',
  'features.features.entity.links.useentitylinkcascade.показаны_сделки_выбранного_контакта':
    'Shows deals of the selected contact',
  'features.features.entity.links.useentitylinkcascade.показаны_сделки_компании_и_ее_контактов':
    'Shows deals of the company and its contacts',
  'features.features.hot.leads.pages.hotleadspage.сумма': 'Amount',
  'features.features.hot.leads.pages.hotleadspage.скор': 'Score',
  'features.features.hot.leads.pages.hotleadspage.открыть': 'Open',
  'features.features.hot.leads.pages.hotleadspage.из': 'from',
  'features.features.hot.leads.pages.hotleadspage.сделок_приоритетный_список':
    'deals · priority list',
  'features.features.hot.leads.pages.hotleadspage.канбан': 'Kanban',
  'features.features.hot.leads.pages.hotleadspage.канбан_2': 'Kanban',
  'features.features.hot.leads.pages.hotleadspage.список': 'List',
  'features.features.hot.leads.pages.hotleadspage.список_2': 'List',
  'features.features.hot.leads.pages.hotleadspage.обновить': 'Update',
  'features.features.hot.leads.pages.hotleadspage.обновить_горячие_лиды': 'Update hot leads',
  'features.features.hot.leads.pages.hotleadspage.поиск_горячих_лидов': 'Finding Hot Leads',
  'features.features.hot.leads.pages.hotleadspage.поиск_по_сделке_или_контакту':
    'Search by deal or contact',
  'features.features.hot.leads.pages.hotleadspage.фильтр_по_причине': 'Filter by reason',
  'features.features.hot.leads.pages.hotleadspage.фильтр_по_стадии': 'Filter by stage',
  'features.features.hot.leads.pages.hotleadspage.все_стадии': 'All stages',
  'features.features.hot.leads.pages.hotleadspage.нет_горячих_лидов_по_текущим_фильтрам':
    'No hot leads based on current filters',
  'features.features.meetings.components.entitymeetingspanel.встречи': 'Meetings',
  'features.features.meetings.components.entitymeetingspanel.тема': 'Subject',
  'features.features.meetings.components.entitymeetingspanel.начало': 'Start',
  'features.features.meetings.components.entitymeetingspanel.встреча_уже_прошла_но_не_закрыта':
    'The meeting has already passed, but is not closed',
  'features.features.meetings.components.entitymeetingspanel.участники': 'Participants',
  'features.features.meetings.components.entitymeetingspanel.гость': 'guest',
  'features.features.meetings.components.entitymeetingspanel.еще': 'more',
  'features.features.meetings.components.entitymeetingspanel.действия': 'Actions',
  'features.features.meetings.components.entitymeetingspanel.редактировать': 'Edit',
  'features.features.meetings.components.entitymeetingspanel.редактировать_встречу': 'Edit meeting',
  'features.features.meetings.components.entitymeetingspanel.скачать_ics': 'Download .ics',
  'features.features.meetings.components.entitymeetingspanel.скачать_приглашение':
    'Download invitation',
  'features.features.meetings.components.entitymeetingspanel.встреча': '+ Meeting',
  'features.features.meetings.components.entitymeetingspanel.не_удалось_загрузить_встречи':
    'Failed to load appointments',
  'features.features.meetings.components.entitymeetingspanel.встреч_пока_нет': 'No meetings yet',
  'features.features.meetings.components.meetingformmodal.сотрудники': 'Employees',
  'features.features.meetings.components.meetingformmodal.контакты': 'Contacts',
  'features.features.meetings.components.meetingformmodal.редактировать_встречу': 'Edit meeting',
  'features.features.meetings.components.meetingformmodal.новая_встреча': 'New meeting',
  'features.features.meetings.components.meetingformmodal.сохранить': 'Save',
  'features.features.meetings.components.meetingformmodal.назначить': 'Assign',
  'features.features.meetings.components.meetingformmodal.отмена': 'Cancel',
  'features.features.meetings.components.meetingformmodal.не_удалось_сохранить_встречу':
    'Failed to save meeting',
  'features.features.meetings.components.meetingformmodal.тема': 'Subject',
  'features.features.meetings.components.meetingformmodal.введите_тему_встречи':
    'Enter the topic of the meeting',
  'features.features.meetings.components.meetingformmodal.о_чем_встреча':
    'What is the meeting about?',
  'features.features.meetings.components.meetingformmodal.начало': 'Start',
  'features.features.meetings.components.meetingformmodal.укажите_начало': 'Specify the beginning',
  'features.features.meetings.components.meetingformmodal.окончание': 'End',
  'features.features.meetings.components.meetingformmodal.укажите_окончание':
    'Please indicate ending',
  'features.features.meetings.components.meetingformmodal.окончание_должно_быть_позже_начала':
    'The end must be later than the start',
  'features.features.meetings.components.meetingformmodal.часовой_пояс': 'Time zone',
  'features.features.meetings.components.meetingformmodal.место_ссылка': 'Location/link',
  'features.features.meetings.components.meetingformmodal.адрес_или_ссылка_на_созвон':
    'Address or link to call',
  'features.features.meetings.components.meetingformmodal.участники': 'Participants',
  'features.features.meetings.components.meetingformmodal.сотрудники_и_контакты_из_списка_внешнего_г':
    'Employees and contacts - from the list; add an external guest by entering email and pressing Enter',
  'features.features.meetings.components.meetingformmodal.кого_приглашаем': 'Who are we inviting?',
  'features.features.meetings.components.meetingformmodal.описание': 'Description',
  'features.features.meetings.components.meetingformmodal.повестка_необязательно':
    'Agenda (optional)',
  'features.features.meetings.pages.meetingcardpage.встреча_не_найдена': 'Meeting not found',
  'features.features.meetings.pages.meetingcardpage.файлы': 'Files',
  'features.features.meetings.pages.meetingcardpage.заметки_по_встрече': 'Meeting notes',
  'features.features.meetings.pages.meetingcardpage.к_встречам': 'Back to meetings',
  'features.features.meetings.pages.meetingcardpage.редактировать': 'Edit',
  'features.features.meetings.pages.meetingcardpage.история_встречи': 'History of the meeting',
  'features.features.meetings.pages.meetingcardpage.отменить': 'Cancel',
  'features.features.meetings.pages.meetingcardpage.отменить_встречу': 'Cancel meeting',
  'features.features.meetings.pages.meetingcardpage.отменить_встречу_2': 'Cancel the meeting?',
  'features.features.meetings.pages.meetingcardpage.встреча_останется_в_списках_со_статусом_от':
    'The meeting will remain in the lists with the status “Canceled”.',
  'features.features.meetings.pages.meetingcardpage.не_удалось_отменить_встречу':
    'Failed to cancel meeting',
  'features.features.meetings.pages.meetingcardpage.начало': 'Start',
  'features.features.meetings.pages.meetingcardpage.встреча_уже_прошла_но_не_закрыта':
    'The meeting has already passed, but is not closed',
  'features.features.meetings.pages.meetingcardpage.окончание': 'End',
  'features.features.meetings.pages.meetingcardpage.статус': 'Status',
  'features.features.meetings.pages.meetingcardpage.место': 'Location',
  'features.features.meetings.pages.meetingcardpage.прошла_дней_назад': 'Ended {count} days ago',
  'features.features.meetings.pages.meetingcardpage.часовой_пояс': 'Time zone',
  'features.features.meetings.pages.meetingcardpage.сделка': 'Deal',
  'features.features.meetings.pages.meetingcardpage.контакт': 'Contact',
  'features.features.meetings.pages.meetingcardpage.компания': 'Company',
  'features.features.meetings.pages.meetingcardpage.задача': 'Task',
  'features.features.meetings.pages.meetingcardpage.документ': 'Document',
  'features.features.meetings.pages.meetingcardpage.участники': 'Participants',
  'features.features.meetings.pages.meetingcardpage.участников_пока_нет': 'No participants yet',
  'features.features.meetings.pages.meetingcardpage.гость': 'guest',
  'features.features.meetings.pages.meetingcardpage.описание': 'Description',
  'features.features.meetings.pages.meetingspage.гость': 'guest',
  'features.features.meetings.pages.meetingspage.тема': 'Subject',
  'features.features.meetings.pages.meetingspage.начало': 'Start',
  'features.features.meetings.pages.meetingspage.встреча_уже_прошла_но_не_закрыта':
    'The meeting has already passed, but is not closed',
  'features.features.meetings.pages.meetingspage.окончание': 'End',
  'features.features.meetings.pages.meetingspage.статус': 'Status',
  'features.features.meetings.pages.meetingspage.участники': 'Participants',
  'features.features.meetings.pages.meetingspage.еще': 'more',
  'features.features.meetings.pages.meetingspage.место': 'Place',
  'features.features.meetings.pages.meetingspage.дата_создания': 'Created',
  'features.features.meetings.pages.meetingspage.привязка': 'Link',
  'features.features.meetings.pages.meetingspage.действия': 'Actions',
  'features.features.meetings.pages.meetingspage.редактировать': 'Edit',
  'features.features.meetings.pages.meetingspage.редактировать_встречу': 'Edit meeting',
  'features.features.meetings.pages.meetingspage.скачать_ics_файл_для_календаря_участника':
    'Download .ics - file for the participant’s calendar',
  'features.features.meetings.pages.meetingspage.скачать_приглашение': 'Download invitation',
  'features.features.meetings.pages.meetingspage.история_встречи': 'History of the meeting',
  'features.features.meetings.pages.meetingspage.отменить_встречу': 'Cancel meeting',
  'features.features.meetings.pages.meetingspage.отменить_встречу_2': 'Cancel the meeting?',
  'features.features.meetings.pages.meetingspage.встреча_будет_отменена_и_скрыта_из_списка':
    'The meeting will be canceled and hidden from the list.',
  'features.features.meetings.pages.meetingspage.отменить': 'Cancel',
  'features.features.meetings.pages.meetingspage.встречи': 'Meetings',
  'features.features.meetings.pages.meetingspage.назначайте_встречи_добавляйте_участников_и':
    'Make appointments, add participants, and download .ics for your calendar. Sending invitations by mail will appear after connecting the mail transport.',
  'features.features.meetings.pages.meetingspage.новая_встреча': 'New meeting',
  'features.features.meetings.pages.meetingspage.поиск_по_теме_описанию_месту':
    'Search by topic, description, location...',
  'features.features.meetings.pages.meetingspage.все_статусы': 'All statuses',
  'features.features.meetings.pages.meetingspage.запланирована': 'Planned',
  'features.features.meetings.pages.meetingspage.прошла': 'Passed',
  'features.features.meetings.pages.meetingspage.отменена': 'Canceled',
  'features.features.meetings.pages.meetingspage.список': 'List',
  'features.features.meetings.pages.meetingspage.календарь': 'Calendar',
  'features.features.meetings.pages.meetingspage.не_удалось_отменить_встречу':
    'Failed to cancel meeting',
  'features.features.meetings.pages.meetingspage.не_удалось_загрузить_встречи':
    'Failed to load appointments',
  'features.features.meetings.pages.meetingspage.встреч_пока_нет_назначьте_первую_кнопкой_н':
    'No meetings yet. Assign the first one with the “New Meeting” button.',
  'features.features.notes.components.entitynotespanel.заметки': 'Notes',
  'features.features.notes.components.entitynotespanel.ошибка_операции_с_заметкой':
    'Note operation error',
  'features.features.notes.components.entitynotespanel.новая_заметка': 'New note...',
  'features.features.notes.components.entitynotespanel.добавить': 'Add',
  'features.features.notes.components.entitynotespanel.ctrl_enter_быстро_сохранить':
    'Ctrl+Enter - quickly save',
  'features.features.notes.components.entitynotespanel.не_прикреплять': 'Do not attach',
  'features.features.notes.components.entitynotespanel.прикрепить_существующую': 'Attach existing',
  'features.features.notes.components.entitynotespanel.найти_заметку_по_тексту':
    'Find a note by text...',
  'features.features.notes.components.entitynotespanel.ничего_не_нашлось': 'Nothing was found',
  'features.features.notes.components.entitynotespanel.не_удалось_загрузить_заметки':
    'Failed to load notes',
  'features.features.notes.components.entitynotespanel.заметок_пока_нет': 'No notes yet',
  'features.features.notes.components.entitynotespanel.неизвестный_автор': 'Unknown author',
  'features.features.notes.components.entitynotespanel.изменить': 'Change',
  'features.features.notes.components.entitynotespanel.поделиться': 'Share',
  'features.features.notes.components.entitynotespanel.извлечь_задачи': 'Extract tasks',
  'features.features.notes.components.entitynotespanel.извлечь_задачи_в_план':
    'Extract tasks into AI action plan',
  'features.features.notes.components.entitynotespanel.удалить_заметку': 'Delete note',
  'features.features.notes.components.entitynotespanel.удалить_заметку_2': 'Delete a note?',
  'features.features.notes.components.entitynotespanel.заметка_пропадет_из_списка_и_со_всех_карто':
    'The note will disappear from the list and from all cards to which it is attached.',
  'features.features.notes.components.noteformmodal.редактировать_заметку': 'Edit note',
  'features.features.notes.components.noteformmodal.сохранить': 'Save',
  'features.features.notes.components.noteformmodal.отмена': 'Cancel',
  'features.features.notes.components.noteformmodal.не_удалось_сохранить_заметку':
    'Failed to save note',
  'features.features.notes.components.noteformmodal.текст': 'Text',
  'features.features.notes.components.noteformmodal.заметка_не_может_быть_пустой':
    'Note cannot be empty',
  'features.features.notes.components.notesharemodal.поделиться_заметкой': 'Share note',
  'features.features.notes.components.notesharemodal.видимость': 'Visibility',
  'features.features.notes.components.notesharemodal.кто_видит': 'Who can see this note?',
  'features.features.notes.components.notesharemodal.всем_в_пространстве': 'Everyone in workspace',
  'features.features.notes.components.notesharemodal.только_я': 'Only me',
  'features.features.notes.components.notesharemodal.выбранные_участники': 'Selected members',
  'features.features.notes.components.notesharemodal.участники': 'Members',
  'features.features.notes.components.notesharemodal.выберите_участников': 'Select members…',
  'features.features.notes.components.notesharemodal.сохранить': 'Save',
  'features.features.notes.components.notesharemodal.отмена': 'Cancel',
  'features.features.notes.components.notesharemodal.не_удалось_сохранить_доступ':
    'Failed to save access',
  'features.features.notes.components.notesharemodal.метка_всем': 'Everyone',
  'features.features.notes.components.notesharemodal.метка_личное': 'Private',
  'features.features.notes.components.notesharemodal.метка_доступ': 'Shared',
  'features.features.notes.components.notesharemodal.подсказка_всем':
    'Visible to everyone in the workspace',
  'features.features.notes.components.notesharemodal.подсказка_личное':
    'Visible only to the author',
  'features.features.notes.components.notesharemodal.подсказка_доступ':
    'Visible to the author and selected members',
  'features.features.notes.components.notesharemodal.не_ваша_заметка':
    'Only the note author can change visibility and access',
  'features.features.notes.components.quicknotebutton.быстрая_заметка': 'Quick note',
  'features.features.notes.components.quicknotebutton.заметка': 'Note',
  'features.features.notes.components.quicknotebutton.быстрая_заметка_2': 'Quick note',
  'features.features.notes.components.quicknotebutton.сохранить': 'Save',
  'features.features.notes.components.quicknotebutton.отмена': 'Cancel',
  'features.features.notes.components.quicknotebutton.не_удалось_сохранить_заметку':
    'Failed to save note',
  'features.features.notes.components.quicknotebutton.что_записать': 'What to write down?',
  'features.features.notes.components.quicknotebutton.привязать_к': 'Snap to',
  'features.features.notes.components.quicknotebutton.привязать_к_выбранным': 'Snap to selected (',
  'features.features.notes.components.quicknotebutton.одна_заметка_на_все':
    ') - one note for everything',
  'features.features.notes.components.quicknotebutton.еще': 'more',
  'features.features.notes.components.quicknotebutton.ничего_не_открыто_и_не_выбрано_заметка_сох':
    'Nothing is open or selected—the note will be saved without being associated. Mark the rows in the list to link to',
  'features.features.notes.components.quicknotebutton.записям': 'records',
  'features.features.notes.pages.notespage.заметка': 'Note',
  'features.features.notes.pages.notespage.привязки': 'Links',
  'features.features.notes.pages.notespage.без_привязки': 'No link',
  'features.features.notes.pages.notespage.снять_эту_привязку': 'Remove this link',
  'features.features.notes.pages.notespage.автор': 'Author',
  'features.features.notes.pages.notespage.дата_создания': 'Created',
  'features.features.notes.pages.notespage.действия': 'Actions',
  'features.features.notes.pages.notespage.изменить': 'Change',
  'features.features.notes.pages.notespage.изменить_заметку': 'Edit note',
  'features.features.notes.pages.notespage.извлечь_задачи_в_план': 'Extract tasks into action plan',
  'features.features.notes.pages.notespage.снять_все_привязки': 'Remove all links',
  'features.features.notes.pages.notespage.привязок_нет': 'No links',
  'features.features.notes.pages.notespage.снять_все_привязки_2': 'Remove all links?',
  'features.features.notes.pages.notespage.текст_заметки_останется_она_станет_без_при':
    'The text of the note will remain, it will become unlinked.',
  'features.features.notes.pages.notespage.снять': 'Take off',
  'features.features.notes.pages.notespage.отмена': 'Cancel',
  'features.features.notes.pages.notespage.снять_все_привязки_3': 'Remove all links',
  'features.features.notes.pages.notespage.история_заметки': 'Note history',
  'features.features.notes.pages.notespage.удалить_заметку': 'Delete note',
  'features.features.notes.pages.notespage.удалить_заметку_2': 'Delete a note?',
  'features.features.notes.pages.notespage.заметка_пропадет_из_списка_и_со_всех_карто':
    'The note will disappear from the list and from all cards to which it is attached.',
  'features.features.notes.pages.notespage.заметки': 'Notes',
  'features.features.notes.pages.notespage.быстрые_записи_по_сделкам_контактам_и_комп':
    'Quick entries on deals, contacts and companies. A new one can be added with the button in the corner of the screen or with the N key.',
  'features.features.notes.pages.notespage.поиск_по_тексту_заметки': 'Search by note text...',
  'features.features.notes.pages.notespage.ошибка_операции': 'Operation error',
  'features.features.notes.pages.notespage.не_удалось_загрузить_заметки': 'Failed to load notes',
  'features.features.notes.pages.notespage.заметок_пока_нет': 'No notes yet',
  'features.features.settings.components.activesessionspanel.неизвестное_устройство':
    'Unknown device',
  'features.features.settings.components.activesessionspanel.неизвестное_устройство_2':
    'Unknown device',
  'features.features.settings.components.activesessionspanel.устройство': 'Device',
  'features.features.settings.components.activesessionspanel.текущая': 'Current',
  'features.features.settings.components.activesessionspanel.последняя_активность': 'Last activity',
  'features.features.settings.components.activesessionspanel.вход': 'Entrance',
  'features.features.settings.components.activesessionspanel.действия': 'Actions',
  'features.features.settings.components.activesessionspanel.закрыть_эту_сессию':
    'Close this session?',
  'features.features.settings.components.activesessionspanel.устройство_сразу_попадет_на_экран_входа':
    'The device will immediately be taken to the login screen.',
  'features.features.settings.components.activesessionspanel.закрыть': 'Close',
  'features.features.settings.components.activesessionspanel.отмена': 'Cancel',
  'features.features.settings.components.activesessionspanel.закрыть_2': 'Close',
  'features.features.settings.components.activesessionspanel.активные_сессии': 'Active sessions',
  'features.features.settings.components.activesessionspanel.устройства_на_которых_выполнен_вход_закрой':
    "Devices you are signed in to. Close those you don't recognize.",
  'features.features.settings.components.activesessionspanel.выйти_на_всех_остальных_устройствах':
    'Log out on all other devices?',
  'features.features.settings.components.activesessionspanel.текущая_сессия_останется_активной':
    'The current session will remain active.',
  'features.features.settings.components.activesessionspanel.выйти_везде': 'Go out everywhere',
  'features.features.settings.components.activesessionspanel.отмена_2': 'Cancel',
  'features.features.settings.components.activesessionspanel.выйти_на_других_устройствах':
    'Sign out on other devices',
  'features.features.settings.components.activesessionspanel.не_удалось_закрыть_сессию':
    'Failed to close session',
  'features.features.settings.components.activesessionspanel.других_активных_сессий_не_было':
    'There were no other active sessions',
  'features.features.settings.components.activesessionspanel.не_удалось_загрузить_сессии':
    'Failed to load sessions',
  'features.features.settings.components.activesessionspanel.активных_сессий_нет':
    'There are no active sessions',
  'features.features.tasks.components.entitytaskspanel.задачи': 'Tasks',
  'features.features.tasks.components.entitytaskspanel.задача': '+ Task',
  'features.features.tasks.components.entitytaskspanel.не_удалось_загрузить_задачи':
    'Failed to load tasks',
  'features.features.tasks.components.entitytaskspanel.здесь_пока_нет_задач':
    'There are no tasks here yet',
  'features.features.tasks.components.relatedtaskspanel.не_удалось_загрузить_связанные_задачи':
    'Failed to load related tasks',
  'features.features.tasks.components.relatedtaskspanel.связанных_задач_пока_нет':
    'There are no related tasks yet',
  'features.features.tasks.components.relatedtaskspanel.у_задачи_пока_нет_связей_привяжите_сделку_':
    'The task has no connections yet - link a deal, contact, company or document',
  'features.features.tasks.components.taskactivitytimeline.задача_создана': 'Task created',
  'features.features.tasks.components.taskactivitytimeline.задача_обновлена': 'Task updated',
  'features.features.tasks.components.taskactivitytimeline.задача_удалена': 'Task deleted',
  'features.features.tasks.components.taskactivitytimeline.пока_нет_записей_истории':
    'No history records yet',
  'features.features.tasks.components.taskdescriptionsection.содержание': 'Content',
  'features.features.tasks.components.taskdescriptionsection.изменить': 'Change',
  'features.features.tasks.components.taskdescriptionsection.добавить': 'Add',
  'features.features.tasks.components.taskdescriptionsection.не_удалось_сохранить_содержание':
    'Failed to save content',
  'features.features.tasks.components.taskdescriptionsection.опишите_содержание_задачи_в_markdown':
    'Describe the content of the task in Markdown...',
  'features.features.tasks.components.taskdescriptionsection.превью_пусто': 'Preview is empty',
  'features.features.tasks.components.taskdescriptionsection.сохранить': 'Save',
  'features.features.tasks.components.taskdescriptionsection.отмена': 'Cancel',
  'features.features.tasks.components.taskdescriptionsection.сохранение': 'Saving…',
  'features.features.tasks.components.taskdescriptionsection.содержание_еще_не_добавлено':
    'No content added yet',
  'features.features.tasks.components.taskformmodal.редактировать_задачу': 'Edit task',
  'features.features.tasks.components.taskformmodal.новая_задача': 'New task',
  'features.features.tasks.components.taskformmodal.сохранить': 'Save',
  'features.features.tasks.components.taskformmodal.создать': 'Create',
  'features.features.tasks.components.taskformmodal.отмена': 'Cancel',
  'features.features.tasks.components.taskformmodal.не_удалось_сохранить_задачу':
    'Failed to save task',
  'features.features.tasks.components.taskformmodal.название': 'Name',
  'features.features.tasks.components.taskformmodal.введите_название_задачи': 'Enter a task name',
  'features.features.tasks.components.taskformmodal.что_нужно_сделать': 'What needs to be done?',
  'features.features.tasks.components.taskformmodal.описание': 'Description',
  'features.features.tasks.components.taskformmodal.детали_задачи_необязательно':
    'Task details (optional)',
  'features.features.tasks.components.taskformmodal.статус': 'Status',
  'features.features.tasks.components.taskformmodal.приоритет': 'Priority',
  'features.features.tasks.components.taskformmodal.срок': 'Due date',
  'features.features.tasks.components.taskformmodal.срок_не_может_быть_в_прошлом':
    'The deadline cannot be in the past',
  'features.features.tasks.components.taskformmodal.исполнитель': 'Assignee',
  'features.features.tasks.components.taskformmodal.не_назначен': 'Not assigned',
  'features.features.tasks.components.taskkanbanboard.в_этом_статусе_пока_нет_задач':
    'There are no tasks in this status yet.',
  'features.features.tasks.components.taskkanbancard.срок': 'Due date:',
  'features.features.tasks.components.taskkanbancard.просрочено': 'Overdue',
  'features.features.tasks.components.tasksgrid.название': 'Name',
  'features.features.tasks.components.tasksgrid.статус': 'Status',
  'features.features.tasks.components.tasksgrid.приоритет': 'Priority',
  'features.features.tasks.components.tasksgrid.срок': 'Due date',
  'features.features.tasks.components.tasksgrid.исполнитель': 'Assignee',
  'features.features.tasks.components.tasksgrid.сделка': 'Deal',
  'features.features.tasks.components.tasksgrid.компания': 'Company',
  'features.features.tasks.components.tasksgrid.контакт': 'Contact',
  'features.features.tasks.components.tasksgrid.дата_создания': 'Created',
  'features.features.tasks.components.tasksgrid.действия': 'Actions',
  'features.features.tasks.components.tasksgrid.редактировать': 'Edit',
  'features.features.tasks.components.tasksgrid.редактировать_2': 'Edit',
  'features.features.tasks.components.tasksgrid.история_задачи': 'Problem history',
  'features.features.tasks.components.tasksgrid.удалить_задачу': 'Delete task',
  'features.features.tasks.components.tasksgrid.удалить_задачу_2': 'Delete task?',
  'features.features.tasks.components.tasksgrid.задачу_можно_будет_восстановить_только_из_':
    'The task can only be restored from the database.',
  'features.features.tasks.pages.taskcardpage.задача_не_найдена': 'Task not found',
  'features.features.tasks.pages.taskcardpage.файлы': 'Files',
  'features.features.tasks.pages.taskcardpage.заметки_по_задаче': 'Notes on the task',
  'features.features.tasks.pages.taskcardpage.встречи_по_задаче': 'Meetings on a task',
  'features.features.tasks.pages.taskcardpage.к_задачам': 'Back to tasks',
  'features.features.tasks.pages.taskcardpage.редактировать': 'Edit',
  'features.features.tasks.pages.taskcardpage.история_задачи': 'Task history',
  'features.features.tasks.pages.taskcardpage.удалить': 'Delete',
  'features.features.tasks.pages.taskcardpage.удалить_задачу': 'Delete task?',
  'features.features.tasks.pages.taskcardpage.задача_пропадет_из_списков_заметки_по_ней_':
    'The task will disappear from the lists; notes on it will remain unlinked.',
  'features.features.tasks.pages.taskcardpage.не_удалось_удалить_задачу': 'Failed to delete task',
  'features.features.tasks.pages.taskcardpage.срок': 'Due date',
  'features.features.tasks.pages.taskcardpage.срок_задачи_прошел': 'The task deadline has passed',
  'features.features.tasks.pages.taskcardpage.исполнитель': 'Assignee',
  'features.features.tasks.pages.taskcardpage.не_назначен': 'not assigned',
  'features.features.tasks.pages.taskcardpage.сделка': 'Deal',
  'features.features.tasks.pages.taskcardpage.контакт': 'Contact',
  'features.features.tasks.pages.taskcardpage.компания': 'Company',
  'features.features.tasks.pages.taskcardpage.документ': 'Document',
  'features.features.tasks.pages.taskcardpage.создана': 'Created',
  'features.features.tasks.pages.taskcardpage.касание_сделано': 'Touch done',
  'features.features.tasks.pages.taskcardpage.касание_зафиксировано':
    'Touch recorded: the interaction is logged in the contact history',
  'features.features.tasks.pages.taskcardpage.не_удалось_зафиксировать_касание':
    'Failed to record the touch',
  'features.features.tasks.pages.taskspage.без_контакта': 'No contact',
  'features.features.tasks.pages.taskspage.без_сделки': 'No deal',
  'features.features.tasks.pages.taskspage.без_компании': 'No company',
  'features.features.tasks.pages.taskspage.задачи': 'Tasks',
  'features.features.tasks.pages.taskspage.создавайте_и_ведите_задачи_все_в_пределах_':
    'Create and manage tasks. Everything is within the current workspace.',
  'features.features.tasks.pages.taskspage.канбан': 'Kanban',
  'features.features.tasks.pages.taskspage.канбан_2': 'Kanban',
  'features.features.tasks.pages.taskspage.список': 'List',
  'features.features.tasks.pages.taskspage.список_2': 'List',
  'features.features.tasks.pages.taskspage.новая_задача': 'New task',
  'features.features.tasks.pages.taskspage.поиск_по_названию': 'Search by name...',
  'features.features.tasks.pages.taskspage.все_статусы': 'All statuses',
  'features.features.tasks.pages.taskspage.любой_исполнитель': 'Any assignee',
  'features.features.tasks.pages.taskspage.группировка': 'Grouping:',
  'features.features.tasks.pages.taskspage.без_группировки': 'No grouping',
  'features.features.tasks.pages.taskspage.по_статусу': 'By status',
  'features.features.tasks.pages.taskspage.по_сделке': 'By deal',
  'features.features.tasks.pages.taskspage.по_компании': 'By company',
  'features.features.tasks.pages.taskspage.по_контакту': 'By contact',
  'features.features.tasks.pages.taskspage.статус': 'Status',
  'features.features.tasks.pages.taskspage.срок': 'Deadline:',
  'features.features.tasks.pages.taskspage.все_сроки': 'All deadlines',
  'features.features.tasks.pages.taskspage.просрочено': 'Overdue',
  'features.features.tasks.pages.taskspage.сегодня': 'Today',
  'features.features.tasks.pages.taskspage.7_дней': '7 days',
  'features.features.tasks.pages.taskspage.ошибка_операции': 'Operation error',
  'features.features.tasks.pages.taskspage.не_удалось_загрузить_задачи': 'Failed to load tasks',
  'features.features.tasks.pages.taskspage.задач_нет_создайте_первую_кнопкой_новая_за':
    'There are no tasks. Create the first one using the “New task” button.',
  'features.features.team.components.teampanel.участник': 'Participant',
  'features.features.team.components.teampanel.это_вы': "it's you",
  'features.features.team.components.teampanel.роль': 'Role',
  'features.features.team.components.teampanel.статус': 'Status',
  'features.features.team.components.teampanel.действия': 'Actions',
  'features.features.team.components.teampanel.отключить': 'Disable',
  'features.features.team.components.teampanel.отключить_2': 'Disable',
  'features.features.team.components.teampanel.отключить_участника': 'Disable member?',
  'features.features.team.components.teampanel.человек_перестанет_попадать_в_пространство':
    'This person will lose access to the workspace. The records he created will remain.',
  'features.features.team.components.teampanel.вернуть': 'Restore',
  'features.features.team.components.teampanel.адрес': 'Email address',
  'features.features.team.components.teampanel.статус_2': 'Status',
  'features.features.team.components.teampanel.просрочено': 'Overdue',
  'features.features.team.components.teampanel.действует_до': 'Valid until',
  'features.features.team.components.teampanel.действия_2': 'Actions',
  'features.features.team.components.teampanel.отозвать': 'Revoke',
  'features.features.team.components.teampanel.отозвать_2': 'Revoke',
  'features.features.team.components.teampanel.отозвать_приглашение': 'Revoke the invitation?',
  'features.features.team.components.teampanel.ссылка_перестанет_работать':
    'The link will no longer work.',
  'features.features.team.components.teampanel.команда': 'Team',
  'features.features.team.components.teampanel.кто_состоит_в_пространстве_и_кого_позвали_':
    'Who is in the space and who has been invited. The role dedue dateines what a person can do: the observer only watches, members can work with records, the administrator also manages the composition.',
  'features.features.team.components.teampanel.пригласить': 'Invite',
  'features.features.team.components.teampanel.приглашения_недоступны':
    'Invitations are not available',
  'features.features.team.components.teampanel.не_получилось': 'Something went wrong',
  'features.features.team.components.teampanel.приглашение_создано': 'Invitation created',
  'features.features.team.components.teampanel.письмо_поставлено_в_очередь_ссылку_можно_п':
    'The email has been queued. You can also send the link directly:',
  'features.features.team.components.teampanel.не_удалось_загрузить_участников':
    'Failed to load members',
  'features.features.team.components.teampanel.приглашения': 'Invitations',
  'features.features.team.components.teampanel.не_удалось_загрузить_приглашения':
    'Failed to load invitations',
  'features.features.team.components.teampanel.никого_не_приглашали': 'No one was invited',
  'features.features.team.components.teampanel.пригласить_в_пространство': 'Invite to workspace',
  'features.features.team.components.teampanel.отправить_приглашение': 'Send an invitation',
  'features.features.team.components.teampanel.отмена': 'Cancel',
  'features.features.team.components.teampanel.не_удалось_пригласить': 'Failed to invite',
  'features.features.team.components.teampanel.укажите_адрес': 'Enter an email address',
  'features.features.team.components.teampanel.похоже_это_не_адрес_почты':
    'This does not appear to be an email address',
  'features.features.team.components.teampanel.принять_приглашение_можно_только_под_этим_':
    'You can only accept an invitation using this address.',
  'features.features.team.components.teampanel.роль_2': 'Role',
  'features.features.templates.pages.templatespage.не_удалось_сохранить_шаблон_проверьте_изме':
    'Failed to save template. Invoice the changes and try again.',
  'features.features.templates.pages.templatespage.удалить_шаблон': 'Delete template',
  'features.features.templates.pages.templatespage.удалить_шаблон_2': 'Delete template?',
  'features.features.templates.pages.templatespage.отправленные_по_нему_письма_останутся_шабл':
    'Emails sent using it will remain, the template will disappear from the list.',
  'features.features.templates.pages.templatespage.не_удалось_создать_шаблон_проверьте_поля_и':
    'Failed to create template. Invoice the fields and try again.',
  'features.features.templates.pages.templatespage.дата_создания': 'Created',
  'features.features.templates.pages.templatespage.история_шаблона': 'Template history',
  'features.features.templates.pages.templatespage.удалить_шаблон_3': 'Delete template',
  'features.features.templates.pages.templatespage.удалить_шаблон_4': 'Delete template?',
  'features.features.templates.pages.templatespage.отправленные_по_нему_письма_останутся_шабл_2':
    'Emails sent using it will remain, the template will disappear from the list.',
  'features.features.templates.pages.templatespage.из': 'from',
  'features.features.templates.pages.templatespage.введите_название_шаблона': 'Enter template name',
  'features.features.templates.pages.templatespage.введите_текст_шаблона': 'Enter template text',
  'features.features.views.components.dashboardsavedviews.не_удалось_собрать_это_представление':
    'Failed to build this view',
  'features.features.views.components.dashboardsavedviews.мои_представления': 'My views',
  'features.features.views.components.dashboardsavedviews.пока_ничего_не_закреплено_соберите_вид_в_р':
    'Nothing is pinned yet. Build a view in section',
  'features.features.views.components.dashboardsavedviews.представления': '"Views"',
  'features.features.views.components.dashboardsavedviews.и_отметьте_плиткой_на_дашборде':
    'and mark "Tile on Dashboard".',
  'features.features.views.components.saveviewmodal.закрепить_представление': 'Pin a view',
  'features.features.views.components.saveviewmodal.настройки_представления': 'View Settings',
  'features.features.views.components.saveviewmodal.сохранить': 'Save',
  'features.features.views.components.saveviewmodal.отмена': 'Cancel',
  'features.features.views.components.saveviewmodal.название': 'Name',
  'features.features.views.components.saveviewmodal.где_показывать': 'Where to show',
  'features.features.views.components.saveviewmodal.пунктом_в_боковом_меню': 'Sidebar item',
  'features.features.views.components.saveviewmodal.плиткой_на_дашборде': 'Dashboard tile',
  'features.features.views.components.saveviewmodal.кому_видно': 'Who can see',
  'features.features.views.components.saveviewmodal.только_мне': 'Only me',
  'features.features.views.components.saveviewmodal.выбранным_участникам': 'Selected members',
  'features.features.views.components.saveviewmodal.всем_в_пространстве':
    'Everyone in the workspace',
  'features.features.views.components.saveviewmodal.кому_открыть_доступ': 'Who should have access',
  'features.features.views.components.saveviewmodal.данные_останутся_под_правами_того_кто_смот':
    'The data will remain under the rights of the person viewing it',
  'features.features.views.components.saveviewmodal.представление_показывает_только_те_записи_':
    'The view shows only those records that are already available to the person.',
  'features.features.views.components.saveviewmodal.не_удалось_сохранить': 'Failed to save',
  'features.features.views.components.viewcellvalue.да': 'Yes',
  'features.features.views.components.viewcellvalue.нет': 'No',
  'features.features.views.components.viewrenderer.ничего_не_найдено': 'Nothing found',
  'features.features.views.components.viewrenderer.количество': 'Count',
  'features.features.views.components.viewrenderer.сумма': 'Amount',
  'features.features.views.components.viewrenderer.среднее': 'Average',
  'features.features.views.components.viewrenderer.ничего_не_найдено_2': 'Nothing found',
  'features.features.views.components.viewrenderer.записей_больше_чем_разрез_успевает_пройти_':
    'The result set is too large to process completely. Counts and ordering may be incomplete; narrow the date range or filters.',
  'features.features.views.pages.savedviewpage.представление_не_найдено': 'View not found',
  'features.features.views.pages.savedviewpage.его_удалили_или_доступ_к_нему_закрыли':
    'It may have been deleted or you may no longer have access.',
  'features.features.views.pages.savedviewpage.видно_всем': 'Visible to everyone',
  'features.features.views.pages.savedviewpage.настроить': 'Configure',
  'features.features.views.pages.savedviewpage.убрать_представление': 'Remove this view?',
  'features.features.views.pages.savedviewpage.убрать': 'Remove',
  'features.features.views.pages.savedviewpage.отмена': 'Cancel',
  'features.features.views.pages.savedviewpage.убрать_2': 'Remove',
  'features.features.views.pages.savedviewpage.не_удалось_собрать_представление':
    'Failed to build view',
  'features.features.views.pages.savedviewpage.описание_не_содержит_ни_одного_блока':
    'The description does not contain any blocks.',
  'features.features.views.pages.viewspage.агент_представлений': 'View Agent',
  'features.features.views.pages.viewspage.опишите_словами_что_хотите_видеть_агент_св':
    'Describe in words what you want to see. The agent will check the dictionary of entities, build a view definition and show the result - no one has written a screen for such a request.',
  'features.features.views.pages.viewspage.показать': 'Show',
  'features.features.views.pages.viewspage.например_три_последних_договора_сумма_фирм':
    'For example: the last three contracts - amount, company and date',
  'features.features.views.pages.viewspage.примеры': 'Examples:',
  'features.features.views.pages.viewspage.агент_не_ответил': 'The agent did not answer',
  'features.features.views.pages.viewspage.по_записанным_примерам': 'from recorded examples',
  'features.features.views.pages.viewspage.описание_не_удалось_разобрать':
    'Description could not be parsed',
  'features.features.views.pages.viewspage.закрепить': 'Pin',
  'features.features.views.pages.viewspage.закрепленные_представления': 'Pinned Views',
  'features.features.views.pages.viewspage.описание_которое_собрал_агент':
    'View definition generated by the agent',
  'features.pages.chatpage.переписка_удалится_безвозвратно':
    'The conversation will be deleted permanently.',
  'features.pages.chatpage.удалить': 'Delete',
  'features.pages.chatpage.отмена': 'Cancel',
  'features.pages.chatpage.не_удалось_удалить_сессии': 'Failed to delete sessions',
  'features.pages.chatpage.отмена_2': 'Cancel',
  'features.pages.chatpage.выбрать': 'Choose',
  'features.pages.chatpage.не_удалось_изменить_ai_шлюз': 'Failed to change AI gateway',
  'features.pages.settingspage.не_подтвержден': 'not confirmed',
  'features.pages.settingspage.имя': 'Name',
  'features.pages.settingspage.роль': 'Role',
  'features.pages.settingspage.адрес_не_подтвержден': 'Address not confirmed',
  'features.pages.settingspage.подтверждение_нужно_чтобы_восстановить_пар':
    'Confirmation is required to recover your password and receive emails about meetings.',
  'features.pages.settingspage.письмо_отправлено_проверьте_почту':
    'The email has been sent - check your email.',
  'features.pages.settingspage.отправить_письмо': 'Send an email',
  'features.pages.settingspage.включен_в_карточке_сделки': 'Included in the deal card',
  'features.pages.settingspage.биллинг': 'Billing',
  'features.pages.settingspage.включен': 'Enabled',
  'features.pages.settingspage.выключен': 'Off',
  'features.activity.field.title': 'Name',
  'features.activity.field.description': 'description',
  'features.activity.field.body': 'text',
  'features.activity.field.priority': 'priority',
  'features.activity.field.status': 'status',
  'features.activity.field.assignee': 'assignee',
  'features.activity.field.owner': 'owner',
  'features.activity.field.deal': 'deal',
  'features.activity.field.company': 'company',
  'features.activity.field.contact': 'contact',
  'features.activity.field.task': 'task',
  'features.activity.field.due_at': 'due date',
  'features.activity.field.completed_at': 'due date',
  'features.activity.field.amount': 'amount',
  'features.activity.field.currency': 'currency',
  'features.activity.field.source': 'source',
  'features.activity.field.role': 'job title',
  'features.activity.field.phone': 'phone',
  'features.activity.field.tags': 'tags',
  'features.activity.field.notes': 'notes',
  'features.activity.field.first_name': 'Name',
  'features.activity.field.last_name': 'surname',
  'features.activity.field.domain': 'domain',
  'features.activity.field.website': 'website',
  'features.activity.field.industry': 'industry',
  'features.activity.field.type': 'type',
  'features.activity.field.subject': 'topic',
  'features.activity.field.variables': 'variables',
  'features.activity.field.is_active': 'activity',
  'features.activity.field.location': 'place',
  'features.activity.field.timezone': 'time zone',
  'features.activity.field.next_step': 'next step',
  'features.activity.field.links': 'links',
  'features.activity.field.starts_at': 'start',
  'features.activity.field.ends_at': 'ending',
  'features.activity.field.participants': 'participants',
  'features.activity.event.todo': 'To be completed',
  'features.activity.event.in_progress': 'In progress',
  'features.activity.event.done': 'Completed',
  'features.activity.event.cancelled': 'Canceled',
  'features.activity.event.deal_created': 'Deal created',
  'features.activity.event.deal_deleted': 'Deal deleted',
  'features.activity.event.contact_created': 'Contact created',
  'features.activity.event.contact_deleted': 'Contact deleted',
  'features.activity.event.company_created': 'Company created',
  'features.activity.event.company_deleted': 'Company deleted',
  'features.activity.event.task_created': 'Task created',
  'features.activity.event.task_deleted': 'Task deleted',
  'features.activity.event.note_added': 'Note added',
  'features.activity.event.note_deleted': 'Note deleted',
  'features.activity.event.meeting_scheduled': 'Meeting scheduled',
  'features.activity.event.meeting_cancelled': 'Meeting cancelled',
  'features.activity.event.document_created': 'Document created',
  'features.activity.event.document_deleted': 'Document deleted',
  'features.activity.event.template_created': 'Template created',
  'features.activity.event.template_deleted': 'Template deleted',
  'features.activity.event.interaction_logged': 'Interaction recorded',
  'features.activity.event.email_sent': 'Email sent',
  'features.activity.event.email_opened': 'Email opened',
  'features.activity.event.email_clicked': 'Link clicked in email',
  'features.activity.event.call_made': 'Call made',
  'features.activity.event.ai_tool_invoked': 'Assistant action completed',
  'features.activity.event.scenario_started': 'Scenario started',
  'features.activity.event.scenario_completed': 'Scenario completed',
  'features.activity.actor.system': 'System',
  'features.activity.event.task_due_reminder': 'Task deadline reminder: {p0}',
  'features.activity.event.task_due_reminder_plain': 'Task deadline reminder',
  'features.activity.event.deal_updated': 'Deal updated',
  'features.activity.event.contact_updated': 'Contact updated',
  'features.activity.event.company_updated': 'Company updated',
  'features.activity.event.task_updated': 'Task updated',
  'features.activity.event.note_updated': 'Note updated',
  'features.activity.event.meeting_updated': 'Meeting updated',
  'features.activity.event.document_updated': 'Document updated',
  'features.activity.event.template_updated': 'Template updated',
  'features.dynamic.features.activity.lib.describeactivity.1': 'Link added: {p0}',
  'features.dynamic.features.activity.lib.describeactivity.2': 'Link removed: {p0}',
  'features.dynamic.features.activity.lib.describeactivity.3': 'Status: {p0} → {p1}',
  'features.dynamic.features.activity.lib.describeactivity.4': 'Stage: {p0} → {p1}',
  'features.dynamic.features.activity.lib.describeactivity.5': 'Changed: {p0}',
  'features.dynamic.features.ai.chat.components.antdesignxchatsurface.6': 'Parameters: {p0}',
  'features.dynamic.features.ai.chat.components.chatpanel.7':
    'Prepare a brief summary of contact {p0} and suggest next step.',
  'features.dynamic.features.ai.chat.components.chatpanel.8':
    'Suggest the next step for deal {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.9': 'Assess the risks of the deal {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.10':
    'Suggest next step for contact {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.11':
    'Assess risks and important signals for contact {p0}.',
  'features.dynamic.features.ai.chat.components.chatpanel.12':
    'Send a prepared follow-up for deal {p0}. Call send_email only with dealId {p1}; take the subject and body unchanged from the last draft_email, do not rewrite them manually. Create approval and do not send the email without my confirmation.',
  'features.dynamic.features.ai.chat.components.chatpanel.13':
    'Prepare a follow-up letter for deal {p0}. Call draft_email with dealId {p1} and tone warm. This is only a draft: do not create approval, do not send an email, do not change the stage of the deal and do not create tasks.',
  'features.dynamic.features.ai.chat.components.chatpanel.14':
    'I confirm the creation of the selected tasks according to the deal plan {p0}. Call create_deal_tasks with dealId {p1} and the following actions: {p2}. First create approval; Do not create tasks directly and do not change the stage of the deal without separate confirmation.',
  'features.dynamic.features.ai.chat.components.conversationswitcher.15': 'Conversation {p0}',
  'features.dynamic.features.ai.chat.components.conversationswitcher.16': '{p0} general',
  'features.dynamic.features.ai.chat.components.conversationswitcher.17':
    'Delete conversations ({p0})?',
  'features.dynamic.features.ai.chat.components.conversationswitcher.18': 'Delete ({p0})',
  'features.dynamic.features.ai.chat.components.dealchatcrudactions.19':
    'Prepare to add a note to the deal {p0} using the add_deal_note tool.',
  'features.dynamic.features.ai.chat.components.dealchatcrudactions.20':
    'Note text as user data: {p0}',
  'features.dynamic.features.ai.chat.components.dealchatcrudactions.21':
    'Prepare to change the deal stage {p0} using tool update_deal_stage to {p1}.',
  'features.dynamic.features.ai.chat.hooks.useentitychat.22': 'Deal {p0}',
  'features.dynamic.features.ai.chat.hooks.useentitychat.23': 'Contact {p0}',
  'features.dynamic.features.ai.chat.hooks.useentitychat.24':
    'Failed to receive a response from the LLM provider.\n\n{p0}{p1}',
  'features.dynamic.features.approvals.lib.approvalsummary.25': 'Tool "{p0}"',
  'features.dynamic.features.attachments.api.attachments.client.26':
    'The storage rejected the file (HTTP {p0})',
  'features.dynamic.features.attachments.components.entityattachmentspanel.27': '{p0} B',
  'features.dynamic.features.attachments.components.entityattachmentspanel.28': '{p0} KB',
  'features.dynamic.features.attachments.components.entityattachmentspanel.29': '{p0} MB',
  'features.dynamic.features.attachments.components.entityattachmentspanel.30': 'Download {p0}',
  'features.dynamic.features.companies.pages.companiespage.31': 'Edit company {p0}',
  'features.dynamic.features.contacts.pages.contactdetailpage.38': 'Deals ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.39': 'Notes ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.40': 'Tasks ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.41': 'Meetings ({p0})',
  'features.dynamic.features.contacts.pages.contactdetailpage.42': 'Documents ({p0})',
  'features.dynamic.features.contacts.pages.contactspage.43': 'Write: {p0}',
  'features.dynamic.features.contacts.pages.contactspage.44': 'Write {p0}',
  'features.dynamic.features.contacts.pages.contactspage.45': 'Call: {p0}',
  'features.dynamic.features.contacts.pages.contactspage.46': 'Call {p0}',
  'features.dynamic.features.contacts.pages.contactspage.47': 'Create task: {p0}',
  'features.dynamic.features.contacts.pages.contactspage.48': 'Edit contact {p0}',
  'features.dynamic.features.contacts.pages.contactspage.49': 'Select contact {p0}',
  'features.dynamic.features.contacts.pages.contactspage.50': 'Select contact {p0}',
  'features.dynamic.features.deals.components.dealcard.51': 'Select deal {p0}',
  'features.dynamic.features.deals.components.dealcard.52': 'Next contact is overdue: {p0}',
  'features.dynamic.features.deals.components.dealcard.53': 'Next contact: {p0}',
  'features.dynamic.features.deals.components.dealcard.54': 'Move to stage “{p0}”',
  'features.dynamic.features.deals.components.deallistview.54': 'Next stage for {p0}',
  'features.dynamic.features.deals.components.deallistview.55': 'Edit deal {p0}',
  'features.dynamic.features.deals.components.deallistview.56': 'Select deal {p0}',
  'features.dynamic.features.deals.components.deallistview.57': 'Select deal {p0}',
  'features.dynamic.features.deals.components.kanbanboard.58': 'Create deal at {p0}',
  'features.dynamic.features.deals.pages.dealcardpage.59': 'Meetings ({p0})',
  'features.dynamic.features.deals.pages.dealcardpage.60': 'Documents ({p0})',
  'features.dynamic.features.deals.pages.dealkanbanpage.61': '{p0} deals not moved',
  'features.dynamic.features.documents.pages.documentcardpage.62': 'Notes ({p0})',
  'features.dynamic.features.documents.pages.documentcardpage.63': 'Tasks ({p0})',
  'features.dynamic.features.documents.pages.documentcardpage.64': 'Meetings ({p0})',
  'features.dynamic.features.documents.pages.documentspage.65':
    '{p0}: the document itself does not have a client specified',
  'features.dynamic.features.documents.pages.documentspage.66': 'Edit document {p0}',
  'features.dynamic.features.meetings.pages.meetingcardpage.67': 'Notes ({p0})',
  'features.dynamic.features.notes.components.quicknotebutton.68': 'Note on {p0}',
  'features.dynamic.features.notes.components.quicknotebutton.69': 'Note to selected ({p0})',
  'features.dynamic.features.notes.components.quicknotebutton.70': '{p0} · N key',
  'features.dynamic.features.notes.pages.notespage.71': 'Unbind: {p0}',
  'features.dynamic.features.settings.components.activesessionspanel.72': 'Closed sessions: {p0}',
  'features.dynamic.features.tasks.components.taskactivitytimeline.73': 'Status: {p0} → {p1}',
  'features.dynamic.features.tasks.components.taskactivitytimeline.74': 'Changed: {p0}',
  'features.dynamic.features.tasks.components.taskdescriptionsection.75':
    'Formatting will exceed the limit of {p0} characters',
  'features.dynamic.features.tasks.components.taskkanbanboard.76': 'Create a task with status {p0}',
  'features.dynamic.features.tasks.pages.taskcardpage.77': 'Notes ({p0})',
  'features.dynamic.features.tasks.pages.taskcardpage.78': 'Meetings ({p0})',
  'features.dynamic.features.tasks.pages.taskcardpage.79': 'Related tasks ({p0})',
  'features.dynamic.features.views.components.viewcellvalue.80':
    'Connection {p0}: the entry itself does not have it marked',
  'features.dynamic.features.views.components.viewrenderer.81':
    'Calculated from {p0} records from {p1}',
  'features.dynamic.features.views.components.viewrenderer.82':
    'The block "{p0}" is not supported by this version of the interface',
  'features.dynamic.features.views.pages.savedviewpage.83': 'Shared by: {p0}',
  'features.dynamic.features.views.pages.savedviewpage.84': 'Open: {p0}',
  'features.dynamic.pages.chatpage.85': 'Delete sessions ({p0})?',
  'features.dynamic.pages.chatpage.86': 'Delete ({p0})',
  'features.map.features.ai.chat.components.dealchatcrudactions.1': 'New',
  'features.map.features.ai.chat.components.dealchatcrudactions.2': 'Contact',
  'features.map.features.ai.chat.components.dealchatcrudactions.3': 'Negotiation',
  'features.map.features.ai.chat.components.gatewayprofileselector.4': 'NeuralDeep · RF',
  'features.map.features.ai.chat.components.gatewayprofileselector.5': 'OpenRouter',
  'features.map.features.approvals.lib.approvalsummary.6': 'Assistant action',
  'features.map.features.approvals.lib.approvalsummary.7': 'Scenario step',
  'features.map.features.approvals.lib.approvalsummary.8': 'Delete a contact',
  'features.map.features.approvals.lib.approvalsummary.9': 'Deleting a deal',
  'features.map.features.approvals.pages.approvalspage.10': 'Pending',
  'features.map.features.approvals.pages.approvalspage.11': 'Confirmed',
  'features.map.features.approvals.pages.approvalspage.12': 'Rejected',
  'features.map.features.approvals.pages.approvalspage.13': 'Expired',
  'features.map.features.approvals.pages.approvalspage.14': 'All',
  'features.map.features.approvals.pages.approvalspage.15': 'Pending',
  'features.map.features.approvals.pages.approvalspage.16': 'Confirmed',
  'features.map.features.approvals.pages.approvalspage.17': 'Rejected',
  'features.map.features.approvals.pages.approvalspage.18': 'Expired',
  'features.map.features.approvals.pages.approvalspage.19': 'Cancelled',
  'features.map.features.approvals.pages.approvalspage.20': 'Cancelled',
  'features.map.features.contacts.components.contactinteractionspanel.19': 'Call',
  'features.map.features.contacts.components.contactinteractionspanel.20': 'Email',
  'features.map.features.contacts.components.contactinteractionspanel.21': 'In-person meeting',
  'features.map.features.contacts.components.contactinteractionspanel.22': 'Note',
  'features.map.features.contacts.components.contactinteractionspanel.23': 'In the app',
  'features.map.features.contacts.components.contactinteractionspanel.24': 'Call',
  'features.map.features.contacts.components.contactinteractionspanel.25': 'Email',
  'features.map.features.contacts.components.contactinteractionspanel.26':
    'In-person meeting (held)',
  'features.map.features.contacts.components.contactinteractionspanel.27': 'In the app',
  'features.map.features.contacts.pages.contactspage.28': 'Contact',
  'features.map.features.contacts.pages.contactspage.29': 'Email/phone',
  'features.map.features.contacts.pages.contactspage.30': 'Company',
  'features.map.features.contacts.pages.contactspage.31': 'Deals',
  'features.map.features.contacts.pages.contactspage.32': 'Tags',
  'features.map.features.contacts.pages.contactspage.33': 'Created',
  'features.map.features.deals.components.dealformmodal.34': 'New entry',
  'features.map.features.deals.components.dealformmodal.35': 'Requires confirmation',
  'features.map.features.deals.components.dealformmodal.36': 'Negotiation',
  'features.map.features.deals.components.dealformmodal.37': 'Service provided',
  'features.map.features.deals.components.dealformmodal.38': 'Canceled',
  'features.map.features.deals.components.deallistview.39': 'Deal',
  'features.map.features.deals.components.deallistview.40': 'Company',
  'features.map.features.deals.components.deallistview.41': 'Contact',
  'features.map.features.deals.components.deallistview.42': 'Stage',
  'features.map.features.deals.components.deallistview.43': 'Amount',
  'features.map.features.deals.components.deallistview.44': 'Next step',
  'features.map.features.deals.components.deallistview.45': 'Next stage',
  'features.map.features.deals.components.deallistview.46': 'Created',
  'features.map.features.documents.components.documentformmodal.47': 'Contract',
  'features.map.features.documents.components.documentformmodal.48': 'Invoice',
  'features.map.features.documents.components.documentformmodal.49': 'Act',
  'features.map.features.documents.components.documentformmodal.50': 'Draft',
  'features.map.features.documents.components.documentformmodal.51': 'Sent',
  'features.map.features.documents.components.documentformmodal.52': 'Signed',
  'features.map.features.documents.components.documentformmodal.53': 'Canceled',
  'features.map.features.meetings.pages.meetingspage.54': 'Subject',
  'features.map.features.meetings.pages.meetingspage.55': 'Start',
  'features.map.features.meetings.pages.meetingspage.56': 'End',
  'features.map.features.meetings.pages.meetingspage.57': 'Status',
  'features.map.features.meetings.pages.meetingspage.58': 'Participants',
  'features.map.features.meetings.pages.meetingspage.59': 'Place',
  'features.map.features.meetings.pages.meetingspage.60': 'Link',
  'features.map.features.meetings.pages.meetingspage.61': 'Created',
  'features.map.features.notes.components.quicknotebutton.62': 'deal',
  'features.map.features.notes.components.quicknotebutton.63': 'contact',
  'features.map.features.notes.components.quicknotebutton.64': 'companies',
  'features.map.features.notes.components.quicknotebutton.65': 'task',
  'features.map.features.notes.components.quicknotebutton.66': 'meeting',
  'features.map.features.notes.components.quicknotebutton.67': 'document',
  'features.map.features.notes.components.quicknotebutton.68': 'template',
  'features.map.features.notes.hooks.usecurrententitycontext.69': 'deal',
  'features.map.features.notes.hooks.usecurrententitycontext.70': 'contact',
  'features.map.features.notes.hooks.usecurrententitycontext.71': 'companies',
  'features.map.features.tasks.components.relatedtaskspanel.72': 'Name',
  'features.map.features.tasks.components.relatedtaskspanel.73': 'Status',
  'features.map.features.tasks.components.relatedtaskspanel.74': 'Priority',
  'features.map.features.tasks.components.relatedtaskspanel.75': 'Due date',
  'features.map.features.tasks.components.relatedtaskspanel.76': 'Assignee',
  'features.map.features.tasks.components.taskactivitytimeline.77': 'Name',
  'features.map.features.tasks.components.taskactivitytimeline.78': 'description',
  'features.map.features.tasks.components.taskactivitytimeline.79': 'priority',
  'features.map.features.tasks.components.taskactivitytimeline.80': 'assignee',
  'features.map.features.tasks.components.taskactivitytimeline.81': 'deal',
  'features.map.features.tasks.components.taskactivitytimeline.82': 'company',
  'features.map.features.tasks.components.taskactivitytimeline.83': 'contact',
  'features.map.features.tasks.components.taskactivitytimeline.84': 'due date',
  'features.map.features.tasks.components.taskdescriptionsection.85': 'Bold',
  'features.map.features.tasks.components.taskdescriptionsection.86': 'Italic',
  'features.map.features.tasks.components.taskdescriptionsection.87': 'Strikethrough',
  'features.map.features.tasks.components.taskdescriptionsection.88': 'Code',
  'features.map.features.tasks.components.taskdescriptionsection.89': 'Heading',
  'features.map.features.tasks.components.taskdescriptionsection.90': 'Bulleted list',
  'features.map.features.tasks.components.taskdescriptionsection.91': 'Numbered list',
  'features.map.features.tasks.components.taskdescriptionsection.92': 'Quote',
  'features.map.features.tasks.components.taskdescriptionsection.93': 'Editor',
  'features.map.features.tasks.components.taskdescriptionsection.94': 'Preview',
  'features.map.features.tasks.lib.markdownformat.95': 'bold text',
  'features.map.features.tasks.lib.markdownformat.96': 'italic text',
  'features.map.features.tasks.lib.markdownformat.97': 'strikethrough text',
  'features.map.features.tasks.lib.markdownformat.98': 'code',
  'ai_ui.add_note.confirm': 'Add note',
  'ai_ui.tool.action_plan_draft.name': 'Prepare action plan',
  'ai_ui.tool.action_plan_draft.description': 'Prepare a safe draft of related actions.',
  'ai_ui.tool.action_plan_start.name': 'Start action plan',
  'ai_ui.tool.crm_list.name': 'Load CRM records',
  'ai_ui.tool.action_plan_start.description': 'Save the confirmed related-action plan.',
  'ai_ui.tool.web_fetch.name': 'Open web page',
  'ai_ui.tool.web_fetch.description': 'Fetch a page from the web.',
  'ai_ui.tool.web_search.name': 'Web search',
  'ai_ui.tool.web_search.description': 'Find fresh information on the web.',
  'ai_ui.tool.deep_research.name': 'Deep research',
  'ai_ui.tool.deep_research.description': 'Run a multi-step research across the web.',
  'ai_ui.tool.search_projects.name': 'Search projects',
  'ai_ui.tool.search_projects.description': 'Find projects by query and filters.',
  'ai_ui.tool.read_project.name': 'Read project',
  'ai_ui.tool.read_project.description': 'Read the project card with its links.',
  'ai_ui.tool.create_project.name': 'Create project',
  'ai_ui.tool.create_project.description': 'Prepare project creation for approval.',
  'ai_ui.tool.update_project.name': 'Update project',
  'ai_ui.tool.update_project.description': 'Prepare project updates for approval.',
  'ai_ui.tool.deal_summary.name': 'Deal summary',
  'ai_ui.tool.deal_summary.description': 'Run deal summary with the current CRM context.',
  'ai_ui.tool.deal_risk.name': 'Deal risk analysis',
  'ai_ui.tool.deal_risk.description': 'Run deal risk analysis with the current CRM context.',
  'ai_ui.tool.deal_call.name': 'Call preparation',
  'ai_ui.tool.deal_call.description': 'Run call preparation with the current CRM context.',
  'ai_ui.tool.deal_cockpit.name': 'Deal cockpit',
  'ai_ui.tool.deal_cockpit.description': 'Run deal cockpit with the current CRM context.',
  'ai_ui.tool.deal_plan.name': 'Action plan',
  'ai_ui.tool.deal_plan.description': 'Run action plan with the current CRM context.',
  'ai_ui.tool.touch_strategy.name': 'Touch strategy',
  'ai_ui.tool.touch_strategy.description': 'Propose a touch strategy for the current CRM deal.',
  'ai_ui.tool.deal_qualification.name': 'Deal qualification',
  'ai_ui.tool.deal_qualification.description':
    'Extract the qualification checklist for the current deal from its history.',
  'ai_ui.tool.update_deal_qualification.name': 'Deal qualification update',
  'ai_ui.tool.update_deal_qualification.description':
    'Replaces the deal qualification checklist; requires user approval.',
  'ai_ui.tool.add_note.name': 'Add note',
  'ai_ui.tool.add_note.description': 'Run add note with the current CRM context.',
  'ai_ui.tool.draft_email.name': 'Draft email',
  'ai_ui.tool.draft_email.description': 'Run draft email with the current CRM context.',
  'ai_ui.tool.send_email.name': 'Send email',
  'ai_ui.tool.send_email.description': 'Run send email with the current CRM context.',
  'ai_ui.tool.update_stage.name': 'Update stage',
  'ai_ui.tool.update_stage.description': 'Run update stage with the current CRM context.',
  'ai_ui.tool.create_tasks.name': 'Create tasks',
  'ai_ui.tool.create_tasks.description': 'Run create tasks with the current CRM context.',
  'ai_ui.tool.contact_history.name': 'Contact history',
  'ai_ui.tool.contact_history.description': 'Run contact history with the current CRM context.',
  'ai_ui.tool.manager_briefing.name': 'My day',
  'ai_ui.tool.manager_briefing.description': 'Build a daily overview for the current CRM context.',
  'ai_ui.tool.analyze_meeting_note.name': 'Analyze meeting note',
  'ai_ui.tool.analyze_meeting_note.description':
    'Break down the latest deal note without changing CRM data.',
  'ai_ui.tool.hot_leads.name': 'Hot leads',
  'ai_ui.tool.hot_leads.description': 'Run hot leads with the current CRM context.',
  'ai_ui.tool.run_scenario.name': 'Run scenario',
  'ai_ui.tool.run_scenario.description': 'Run run scenario with the current CRM context.',
  'ai_ui.tool.recent_activities.name': 'Recent activities',
  'ai_ui.tool.recent_activities.description': 'Fetch recent activities and events in CRM.',
  'ai_ui.tool.search_deals.name': 'Search deals',
  'ai_ui.tool.search_deals.description': 'Search and filter deals by parameters.',
  'ai_ui.tool.show_view.name': 'Display view',
  'ai_ui.tool.show_view.description': 'Build and render data view.',
  'ai_ui.tool.search_contacts.name': 'Search contacts',
  'ai_ui.tool.search_contacts.description': 'Search clients and contacts in CRM.',
  'ai_ui.tool.recent_memories.name': 'Assistant memory',
  'ai_ui.tool.recent_memories.description': 'Load context and saved preferences.',
  'ai_ui.tool.write_memory.name': 'Save memory',
  'ai_ui.tool.write_memory.description': 'Save key fact to long-term memory.',
  'ai_ui.tool.update_memory.name': 'Update memory',
  'ai_ui.tool.update_memory.description': 'Prepare a memory record update for confirmation.',
  'ai_ui.tool.delete_memory.name': 'Delete memory',
  'ai_ui.tool.delete_memory.description': 'Prepare memory record deletion for confirmation.',
  'ai_ui.tool.view_catalog.name': 'View catalog',
  'ai_ui.tool.view_catalog.description': 'Browse available data catalogs.',
  'ai_ui.tool.find_records.name': 'Find records',
  'ai_ui.tool.find_records.description': 'Search rows in CRM database.',
  'ai_ui.tool.build_view.name': 'Build report',
  'ai_ui.tool.build_view.description': 'Generate dynamic data table.',
  'ai_ui.tool.save_view.name': 'Save report',
  'ai_ui.tool.save_view.description': 'Save custom report view.',
  'ai_ui.tool.read_task.name': 'View task',
  'ai_ui.tool.read_task.description': 'View one task available to you.',
  'ai_ui.tool.create_task.name': 'Create task',
  'ai_ui.tool.create_task.description': 'Prepare a new task for confirmation.',
  'ai_ui.tool.update_task.name': 'Update task',
  'ai_ui.tool.update_task.description': 'Prepare task changes for confirmation.',
  'ai_ui.tool.delete_task.name': 'Delete task',
  'ai_ui.tool.delete_task.description': 'Prepare task deletion for confirmation.',
  'ai_ui.tool.set_task_status.name': 'Change task status',
  'ai_ui.tool.set_task_status.description': 'Prepare a task status change for confirmation.',
  'ai_ui.tool.assign_task.name': 'Assign task',
  'ai_ui.tool.assign_task.description': 'Prepare task assignment for confirmation.',
  'ai_ui.tool.link_task.name': 'Link task',
  'ai_ui.tool.link_task.description': 'Prepare linking a task to a record for confirmation.',
  'ai_ui.tool.unlink_task.name': 'Unlink task',
  'ai_ui.tool.unlink_task.description': 'Prepare removing a task link for confirmation.',
  'ai_ui.tool.set_task_due_date.name': 'Change task due date',
  'ai_ui.tool.set_task_due_date.description': 'Prepare a due-date change for confirmation.',
  'ai_ui.tool.read_note.name': 'View note',
  'ai_ui.tool.read_note.description': 'View one note available to you.',
  'ai_ui.tool.create_note.name': 'Create note',
  'ai_ui.tool.create_note.description': 'Prepare a new note for confirmation.',
  'ai_ui.tool.update_note.name': 'Update note',
  'ai_ui.tool.update_note.description': 'Prepare note changes for confirmation.',
  'ai_ui.tool.delete_note.name': 'Delete note',
  'ai_ui.tool.delete_note.description': 'Prepare note deletion for confirmation.',
  'ai_ui.tool.link_note.name': 'Link note',
  'ai_ui.tool.link_note.description': 'Prepare linking a note to a record for confirmation.',
  'ai_ui.tool.unlink_note.name': 'Unlink note',
  'ai_ui.tool.unlink_note.description': 'Prepare removing a note link for confirmation.',
  'ai_ui.tool.search_tasks.name': 'Search tasks',
  'ai_ui.tool.search_tasks.description': 'Find tasks by filters.',
  'ai_ui.tool.bulk_read_contacts.name': 'Read contacts',
  'ai_ui.tool.bulk_read_contacts.description': 'View selected contacts.',
  'ai_ui.tool.bulk_read_companies.name': 'Read companies',
  'ai_ui.tool.bulk_read_companies.description': 'View selected companies.',
  'ai_ui.tool.bulk_read_notes.name': 'Read notes',
  'ai_ui.tool.bulk_read_notes.description': 'View selected notes.',
  'ai_ui.tool.bulk_read_documents.name': 'Read documents',
  'ai_ui.tool.bulk_read_documents.description': 'View selected documents.',
  'ai_ui.tool.bulk_read_templates.name': 'Read templates',
  'ai_ui.tool.bulk_read_templates.description': 'View selected templates.',
  'ai_ui.tool.bulk_read_attachments.name': 'Read attachments',
  'ai_ui.tool.bulk_read_attachments.description': 'View selected attachments.',
  'ai_ui.tool.bulk_read_contact_interactions.name': 'Read interactions',
  'ai_ui.tool.bulk_read_contact_interactions.description': 'View selected contact interactions.',
  'ai_ui.tool.bulk_read_calendar_events.name': 'Read meetings',
  'ai_ui.tool.bulk_read_calendar_events.description': 'View selected meetings.',
  'ai_ui.tool.read_company.name': 'View company',
  'ai_ui.tool.read_company.description': 'View company details.',
  'ai_ui.tool.read_company_revenue.name': 'Company revenue',
  'ai_ui.tool.read_company_revenue.description':
    'Show company Won deal amounts separately by currency.',
  'ai_ui.tool.read_document.name': 'View document',
  'ai_ui.tool.read_document.description': 'View one document available to you.',
  'ai_ui.tool.read_attachment.name': 'View attachment',
  'ai_ui.tool.read_attachment.description': 'View attachment details.',
  'ai_ui.tool.read_attachment_content.name': 'Attachment content',
  'ai_ui.tool.read_attachment_content.description': 'Read the text content of an attachment.',
  'ai_ui.tool.read_attachment_image.name': 'View image',
  'ai_ui.tool.read_attachment_image.description': 'View an attachment image.',
  'ai_ui.tool.read_template.name': 'View template',
  'ai_ui.tool.read_template.description': 'View one template available to you.',
  'ai_ui.tool.read_calendar_event.name': 'View meeting',
  'ai_ui.tool.read_calendar_event.description': 'View one meeting available to you.',
  'ai_ui.tool.read_calendar_events.name': 'View meeting list',
  'ai_ui.tool.read_calendar_events.description': 'View meetings for a period.',
  'ai_ui.tool.list_attachments.name': 'List attachments',
  'ai_ui.tool.list_attachments.description': 'List attachments of a record.',
  'ai_ui.tool.list_imports.name': 'List imports',
  'ai_ui.tool.list_imports.description': 'List past imports.',
  'ai_ui.tool.preview_import.name': 'Preview import',
  'ai_ui.tool.preview_import.description': 'Parse an import file without writing data.',
  'ai_ui.tool.execute_import.name': 'Run import',
  'ai_ui.tool.execute_import.description': 'Prepare a data import for confirmation.',
  'ai_ui.tool.investigate_crm_context.name': 'Inspect CRM context',
  'ai_ui.tool.investigate_crm_context.description': 'Inspect workspace data for a request.',
  'ai_ui.tool.conversation_to_note.name': 'Note from conversation',
  'ai_ui.tool.conversation_to_note.description':
    'Prepare a note from the conversation history for confirmation.',
  'ai_ui.tool.document_to_note.name': 'Note from document',
  'ai_ui.tool.document_to_note.description': 'Prepare a note from a document for confirmation.',
  'ai_ui.tool.create_deal.name': 'Create deal',
  'ai_ui.tool.create_deal.description': 'Create a new deal in the pipeline.',
  'ai_ui.tool.update_deal.name': 'Update deal',
  'ai_ui.tool.update_deal.description': 'Update deal details.',
  'ai_ui.tool.delete_deal.name': 'Delete deal',
  'ai_ui.tool.delete_deal.description': 'Delete a deal from the workspace.',
  'ai_ui.tool.bulk_create_templates.name': 'Create templates',
  'ai_ui.tool.bulk_create_templates.description': 'Prepare new templates for confirmation.',
  'ai_ui.tool.bulk_update_templates.name': 'Update templates',
  'ai_ui.tool.bulk_update_templates.description': 'Prepare template changes for confirmation.',
  'ai_ui.tool.enrich_contact.name': 'Enrich contact',
  'ai_ui.tool.enrich_contact.description': 'Complete contact details from public sources.',
  'ai_ui.tool.get_sales_health.name': 'Sales health',
  'ai_ui.tool.get_sales_health.description': 'Show sales pipeline health.',
  'ai_ui.tool.generate_dashboard_widget.name': 'Dashboard widget',
  'ai_ui.tool.generate_dashboard_widget.description': 'Build a dashboard widget.',
  'ai_ui.tool.refresh_entity_context.name': 'Refresh context',
  'ai_ui.tool.refresh_entity_context.description': 'Refresh a record context for later steps.',
  'ai_ui.tool.propose_candidate_refinement.name': 'Refine selection',
  'ai_ui.tool.propose_candidate_refinement.description':
    'Suggest a refinement of the record selection.',
  'ai_ui.tool.delegate_deal_specialist.name': 'Deal specialist',
  'ai_ui.tool.delegate_deal_specialist.description': 'Hand the request to the deal specialist.',
  'ai_ui.tool.delegate_tasks_specialist.name': 'Tasks specialist',
  'ai_ui.tool.delegate_tasks_specialist.description': 'Hand the request to the tasks specialist.',
  'chat.manager_briefing.title': 'My day',
  'chat.manager_briefing.signal_count': {
    one: '{count} risk signal',
    other: '{count} risk signals',
  },
  'chat.manager_briefing.hot_leads': 'Hot leads',
  'chat.manager_briefing.overdue_tasks': 'Overdue tasks',
  'chat.manager_briefing.risk_deals': 'Deals at risk',
  'chat.manager_briefing.today_meetings': "Today's meetings",
  'chat.manager_briefing.priorities': 'Key priorities for today',
  'chat.manager_briefing.priority_meetings': "Prepare for today's meetings",
  'chat.manager_briefing.priority_overdue_tasks': 'Review overdue tasks',
  'chat.manager_briefing.priority_risk_deals': 'Review deals at risk',
  'chat.manager_briefing.priority_hot_leads': 'Choose the next step for hot leads',
  'chat.manager_briefing.reason_overdue_next_activity': 'Next action is overdue',
  'chat.manager_briefing.reason_missing_next_activity': 'No next action planned',
  'chat.manager_briefing.reason_stale_activity': 'No recent activity',
  'chat.manager_briefing.reason_overdue_task': 'There is an overdue task',
  'chat.manager_briefing.reason_due': 'Next action is due soon',
  'chat.manager_briefing.reason_high_value': 'High deal value',
  'chat.manager_briefing.pipeline_slice': 'Sales pipeline breakdown',
  'chat.manager_briefing.conversion': 'Conversion',
  'chat.manager_briefing.new': 'New',
  'chat.manager_briefing.in_progress': 'In progress',
  'chat.manager_briefing.contacted': 'Contacted',
  'chat.manager_briefing.negotiation': 'Negotiation',
  'chat.manager_briefing.won': 'Won',
  'chat.manager_briefing.lost': 'Lost',
  'chat.meeting_outcome.title': 'Meeting outcome',
  'chat.meeting_outcome.summary': 'Summary',
  'chat.meeting_outcome.decisions': 'Decisions and agreements',
  'chat.meeting_outcome.risks': 'Risks and open questions',
  'chat.meeting_outcome.next_actions': 'Next action candidates',
  'chat.meeting_outcome.read_only_note':
    'Read-only analysis. No CRM data was changed and no tasks were created.',
  'chat.meeting_outcome.no_note_missing':
    'This deal has no notes yet. Add a meeting note and try again.',
  'chat.meeting_outcome.no_note_empty':
    'The latest note of this deal is empty — nothing to analyze.',
  'chat.meeting_outcome.source_latest_note': 'Source: latest deal note',
  'chat.meeting_outcome.analysis_unavailable':
    'The note could not be analyzed: the AI service is unavailable right now. Please try again later.',
  'chat.meeting_outcome.note_too_long':
    'The note is too long to analyze. Shorten it or pick the meeting fragment, then try again.',
  'chat.meeting_outcome.empty_list': '—',
  'chat.meeting_outcome.selected_count': 'Selected: {selected} of {total}',
  'chat.meeting_outcome.select_action': 'Select action: {title}',
  'chat.meeting_outcome.create_selected_tasks': 'Create selected tasks',
  'chat.meeting_outcome.create_tasks_command': 'Create selected tasks from the meeting analysis',
  'chat.meeting_outcome.approval_hint': 'Tasks will be created only after you approve the request.',
  'chat.meeting_outcome.prepare_follow_up': 'Prepare follow-up',
  'chat.meeting_outcome.prepare_followup_command': 'Prepare a follow-up from the meeting analysis',
  'chat.sales_health.title': 'Sales health',
  'chat.sales_health.badge_readonly': 'Read-only',
  'chat.sales_health.badge_heuristic': 'CRM heuristic',
  'chat.sales_health.stats_active': 'Active deals',
  'chat.sales_health.stats_healthy': 'Healthy',
  'chat.sales_health.stats_attention': 'Need attention',
  'chat.sales_health.stats_critical': 'Critical',
  'chat.sales_health.money_pipeline': 'Pipeline amount',
  'chat.sales_health.money_expected': 'Expected revenue',
  'chat.sales_health.stages_title': 'Funnel by stage',
  'chat.sales_health.stage_New': 'New',
  'chat.sales_health.stage_Contacted': 'In progress',
  'chat.sales_health.stage_Negotiation': 'Negotiation',
  'chat.sales_health.attention_title': 'Deals requiring attention',
  'chat.sales_health.level_healthy': 'Healthy',
  'chat.sales_health.level_attention': 'Attention',
  'chat.sales_health.level_critical': 'Critical',
  'chat.sales_health.reason_overdue_next_activity': 'Next activity is overdue',
  'chat.sales_health.reason_missing_next_activity': 'Next activity is not scheduled',
  'chat.sales_health.reason_stale_activity': 'No recent activity',
  'chat.sales_health.reason_overdue_task': 'An overdue task exists',
  'chat.sales_health.reason_stage_age_over_norm': 'In the current stage longer than the norm',
  'chat.sales_health.reason_qualification_gaps': 'Qualification is not filled in',
  'chat.sales_health.reason_stage_new': 'Early funnel stage',
  'chat.sales_health.reason_stage_contacted': 'Contacted stage',
  'chat.sales_health.reason_stage_negotiation': 'Negotiation stage',
  'chat.sales_health.reason_zero_amount': 'Deal amount is missing',
  'chat.sales_health.reason_closed_won': 'Deal closed successfully',
  'chat.sales_health.reason_closed_lost': 'Deal closed as lost',
  'chat.sales_health.recommendation_fix_overdue_activity': 'Reschedule the overdue activity',
  'chat.sales_health.recommendation_close_overdue_tasks': 'Close the overdue tasks',
  'chat.sales_health.recommendation_plan_next_step': 'Plan the next step',
  'chat.sales_health.recommendation_follow_up': 'Reach out to the client',
  'chat.sales_health.recommendation_continue_pipeline': 'Continue working the pipeline',
  'chat.sales_health.recommendation_none': 'No action needed',
  'chat.sales_health.activity_scheduled_future': 'Step scheduled',
  'chat.sales_health.activity_overdue': 'Step overdue',
  'chat.sales_health.activity_missing': 'Step not set',
  'chat.sales_health.col_title': 'Deal',
  'chat.sales_health.col_stage': 'Stage',
  'chat.sales_health.col_amount': 'Amount',
  'chat.sales_health.col_probability': 'Probability',
  'chat.sales_health.col_next_action': 'Next step',
  'chat.sales_health.empty_no_deals':
    'No deals in the open pipeline yet — add the first one to see a forecast.',
  'chat.sales_health.empty_all_healthy':
    'Every open-pipeline deal is healthy — nothing needs attention right now.',
  'chat.sales_health.empty_no_risky': 'No deals require attention.',
  'chat.sales_health.disclaimer_readonly': 'Read-only card: no CRM records were changed.',
  'chat.sales_health.disclaimer_heuristic':
    'This is an explainable CRM heuristic (stage + risk signals), not an ML forecast.',
  'chat.touch_strategy.title': 'Touch strategy',
  'chat.touch_strategy.diagnosis_label': 'Deal diagnosis',
  'chat.touch_strategy.steps_title': 'Touch cadence',
  'chat.touch_strategy.channel_email': 'Email',
  'chat.touch_strategy.channel_call': 'Call',
  'chat.touch_strategy.channel_meeting': 'Meeting',
  'chat.touch_strategy.channel_telegram': 'Telegram',
  'chat.touch_strategy.day_offset': 'D+{n}',
  'chat.touch_strategy.draft_preview_show': 'show full draft',
  'chat.touch_strategy.draft_preview_hide': 'hide',
  'chat.touch_strategy.evidence': 'Signals behind the strategy',
  'chat.touch_strategy.preset_proposal_silent': 'Proposal follow-up',
  'chat.touch_strategy.preset_stale_silence': 'Revive stale deal',
  'chat.touch_strategy.preset_discovery': 'Discovery',
  'chat.touch_strategy.preset_no_next_step': 'Light cadence',
  'chat.touch_strategy.create_tasks': {
    one: 'Create {count} task',
    other: 'Create {count} tasks',
  },
  'chat.touch_strategy.decline': 'Decline',
  'chat.touch_strategy.status_pending': 'Approval received, verifying execution…',
  'chat.touch_strategy.status_executed': 'Tasks created',
  'chat.touch_strategy.status_declined': 'Strategy declined — no tasks were created',
  'chat.touch_strategy.status_guard': 'The strategy failed the fact-check and was not issued',
  'chat.touch_strategy.status_llm': 'Could not prepare the strategy, try again later',
  'chat.touch_strategy.status_persist': 'Could not register the strategy approval',
  'chat.touch_strategy.executed_at': 'at {time}',
  'chat.touch_strategy.cockpit_button': 'Propose strategy',
  'chat.touch_strategy.trigger':
    'Propose a touch strategy for deal {dealId}: what to do next to move it forward',
  'chat.touch_strategy.read_only': 'Read-only',
  'chat.touch_strategy.history_advanced': 'History has changed — the strategy may be outdated',
  'chat.qualification.title': 'Deal qualification',
  'chat.qualification.summary': 'Confirmed {confirmed} of {total}',
  'chat.qualification.status_missing_hint': 'The history explicitly says this is missing',
  'chat.qualification.apply': 'Apply',
  'chat.qualification.decline': 'Decline',
  'chat.qualification.status_pending': 'Approval received, verifying execution…',
  'chat.qualification.status_executed': 'Qualification updated',
  'chat.qualification.status_declined': 'Proposal declined — qualification unchanged',
  'chat.qualification.executed_at': 'at {time}',
  'chat.qualification.evidence_label': 'source: {text}',
  'chat.qualification.evidence_show': 'show',
  'chat.qualification.evidence_hide': 'hide',
  'chat.qualification.read_only': 'Read-only',
  'chat.qualification.status_llm': 'Could not extract the qualification, try again later',
  'chat.qualification.status_no_deal': 'Deal not found or not accessible',
  'ai_chat.session_sidebar.new_chat': 'New chat',
  'ai_chat.session_sidebar.search_placeholder': 'Search chats...',
  'ai_chat.session_sidebar.recent_chats': 'Recent chats',
  'ai_chat.session_sidebar.group_today': 'Today',
  'ai_chat.session_sidebar.group_yesterday': 'Yesterday',
  'ai_chat.session_sidebar.group_last_7_days': 'Previous 7 days',
  'ai_chat.session_sidebar.group_last_30_days': 'Previous 30 days',
  'ai_chat.session_sidebar.group_this_week': 'This week',
  'ai_chat.session_sidebar.group_earlier': 'Earlier',
  'ai_chat.session_sidebar.no_matches': 'No matches found',
  'ai_chat.session_sidebar.no_chats': 'No conversation history',
  'ai_chat.session_sidebar.empty_history': 'No conversation history',
  'ai_chat.session_sidebar.context_deal': 'Deal',
  'ai_chat.session_sidebar.context_contact': 'Contact',
  'ai_chat.session_sidebar.context_general': 'General chat',
  'ai_chat.session_sidebar.untitled_chat': 'New conversation',
  'ai_chat.session_sidebar.delete_confirm_title': 'Delete this chat?',
  'ai_chat.session_sidebar.yes': 'Yes',
  'ai_chat.session_sidebar.no': 'No',
  'ai_chat.session_sidebar.delete_chat': 'Delete chat',
  'ai_chat.session_sidebar.rename_chat': 'Rename chat',
  'ai_chat.session_sidebar.rename_failed': 'Failed to rename chat',
  'ai_chat.session_sidebar.demo_scenarios': 'Demo scenarios',
  'ai_chat.session_sidebar.engine_ready': 'Engine ready',
  'ai_chat.right_panel.title': 'Run details',
  'ai_chat.right_panel.session_outcomes': 'CRM Actions in Session',
  'ai_chat.right_panel.outcome_contact_created': 'Contact created: {name}',
  'ai_chat.right_panel.outcome_contact_updated': 'Contact updated: {name}',
  'ai_chat.right_panel.outcome_deal_created': 'Deal created: {title}',
  'ai_chat.right_panel.outcome_deal_stage_changed': 'Deal {title}: new stage {stage}',
  'ai_chat.right_panel.outcome_appointment_created': 'Meeting scheduled: {title}',
  'ai_chat.right_panel.outcome_task_created': 'Task created: {title}',
  'ai_chat.right_panel.outcome_interaction_logged': 'Logged interaction: {title}',
  'ai_chat.right_panel.via_action_plan': 'Via CRM Action Plan',
  'ai_chat.right_panel.view_entity': 'Open',
  'ai_chat.right_panel.user_request': 'User query',
  'ai_chat.right_panel.view_artifact': 'View artifact',
  'ai_chat.overlay.deal_details': 'Deal details',
  'ai_chat.overlay.open_contact': 'View contact',
  'ai_chat.overlay.open_deal': 'View deal',
  'ai_chat.action_plan.view_contact': 'View contact',
  'ai_chat.action_plan.view_deal': 'View deal',
  'ai_chat.action_plan.title': 'Requested actions',
  'ai_chat.action_plan.approve': 'Confirm action',
  'ai_chat.action_plan.reject': 'Reject',
  'ai_chat.action_plan.undo': 'Undo result',
  'ai_chat.action_plan.empty_value': '—',
  'ai_chat.action_plan.blocked_dependency': 'Waiting for previous action',
  'ai_chat.action_plan.stale_details': 'The data has changed since this plan was drafted',
  'ai_chat.action_plan.error.duplicate_email':
    'A contact with this email already exists — use another address',
  'ai_chat.action_plan.error.duplicate_phone':
    'A contact with this phone already exists — use another number',
  'ai_chat.action_plan.error.duplicate': 'This record already exists',
  'ai_chat.action_plan.error.validation':
    'The data did not pass validation: check the phone (international format) and required fields',
  'ai_chat.action_plan.error.handler':
    'The action could not be completed — change the data or try again',
  'ai_chat.action_plan.error.dependency':
    'This step did not run because the previous action failed',
  'ai_chat.action_plan.error.stale':
    'The record changed after the plan was drafted — ask the assistant to refresh it',
  'ai_chat.action_plan.decide_failed':
    'Failed to apply the decision for this plan item. Please try again.',
  'ai_chat.action_plan.undo_failed': 'Failed to undo the action. Please try again.',
  'ai_chat.action_plan.action.create_company': 'Create company',
  'ai_chat.action_plan.action.create_contact': 'Create contact',
  'ai_chat.action_plan.action.create_deal': 'Create deal',
  'ai_chat.action_plan.action.create_task': 'Create task',
  'ai_chat.action_plan.action.create_calendar_event': 'Schedule appointment',
  'ai_chat.action_plan.action.create_contact_interaction': 'Log a contact interaction',
  'ai_chat.action_plan.action.unspecified': 'CRM action',
  'ai_chat.action_plan.entity.company': 'Company',
  'ai_chat.action_plan.entity.contact': 'Contact',
  'ai_chat.action_plan.entity.deal': 'Deal',
  'ai_chat.action_plan.entity.task': 'Task',
  'ai_chat.action_plan.entity.note': 'Note',
  'ai_chat.action_plan.entity.calendar_event': 'Meeting',
  'ai_chat.action_plan.entity.contact_interaction': 'Interaction',
  'ai_chat.action_plan.status.blocked': 'Blocked',
  'ai_chat.action_plan.status.pending': 'Awaiting confirmation',
  'ai_chat.action_plan.status.approved': 'Approved',
  'ai_chat.action_plan.status.rejected': 'Rejected',
  'ai_chat.action_plan.status.succeeded': 'Done',
  'ai_chat.action_plan.status.failed': 'Failed',
  'ai_chat.action_plan.status.cancelled': 'Cancelled',
  'ai_chat.action_plan.status.undo_pending': 'Undoing',
  'ai_chat.action_plan.status.undone': 'Undone',
  'ai_chat.action_plan.status.stale': 'Outdated',
  'ai_chat.action_plan.field.name': 'Name',
  'ai_chat.action_plan.field.first_name': 'First name',
  'ai_chat.action_plan.field.last_name': 'Last name',
  'ai_chat.action_plan.field.phone': 'Phone',
  'ai_chat.action_plan.field.email': 'Email',
  'ai_chat.action_plan.field.title': 'Title',
  'ai_chat.action_plan.field.amount': 'Amount',
  'ai_chat.action_plan.field.stage': 'Stage',
  'ai_chat.action_plan.field.company': 'Company',
  'ai_chat.action_plan.field.contact': 'Contact',
  'ai_chat.action_plan.field.deal': 'Deal',
  'ai_chat.action_plan.field.due_at': 'Due date',
  'ai_chat.action_plan.field.description': 'Description',
  'ai_chat.action_plan.field.priority': 'Priority',
  'ai_chat.action_plan.field.starts_at': 'Starts',
  'ai_chat.action_plan.field.ends_at': 'Ends',
  'ai_chat.action_plan.field.timezone': 'Timezone',
  'ai_chat.action_plan.field.location': 'Location',
  'ai_chat.action_plan.field.type': 'Type',
  'ai_chat.action_plan.field.subject': 'Subject',
  'ai_chat.action_plan.field.body': 'Content',
  'ai_chat.action_plan.field.channel': 'Channel',
  'ai_chat.action_plan.field.occurred_at': 'When',
  'ai_chat.right_panel.activities': 'Activities',
  'ai_chat.right_panel.no_activities': 'No activities yet',
  'ai_chat.right_panel.empty_activities': 'No activities yet',
  'ai_chat.right_panel.checkpoints': 'Checkpoints',
  'ai_chat.right_panel.artifacts': 'Artifacts',
  'ai_chat.right_panel.no_artifacts': 'No artifacts created yet',
  'ai_chat.right_panel.details': 'Conversation details',
  'ai_chat.right_panel.toggle_panel': 'Details panel',
  'ai_chat.right_panel.user_prompt': 'User query',
  'ai_chat.right_panel.tool_call': 'Tool call',
  'ai_chat.right_panel.agent_response': 'Agent response',
  'ai_chat.right_panel.approval_required': 'Approval required',
  'ai_chat.right_panel.turn_title': 'Conversation Step',
  'ai_chat.right_panel.tools_executed': {
    one: 'tool run',
    few: 'tools run',
    many: 'tools run',
    other: 'tools run',
  },
  'ai_chat.right_panel.business_scenarios': 'Business Playbooks',
  'ai_chat.right_panel.active_context': 'Active Context',
  'ai_chat.right_panel.scenario_my_day': '☀️ My day',
  'ai_chat.right_panel.scenario_my_day_desc': 'Meetings, tasks, hot leads, and deals at risk',
  'ai_chat.right_panel.scenario_hot_leads': '🔥 Today’s Hot Leads',
  'ai_chat.right_panel.scenario_hot_leads_desc': 'Find inactive leads and prepare follow-ups',
  'ai_chat.right_panel.scenario_deal_risks': '⚠️ Pipeline Risk Audit',
  'ai_chat.right_panel.scenario_deal_risks_desc': 'Inspect stalled stages and lost deal signals',
  'ai_chat.right_panel.scenario_follow_up': '✉️ Draft Follow-ups',
  'ai_chat.right_panel.scenario_follow_up_desc': 'Generate personalized client draft emails',
  'ai_chat.right_panel.scenario_daily_plan': '📋 Daily Action Plan',
  'ai_chat.right_panel.scenario_daily_plan_desc': 'Aggregate and prioritize manager tasks',
  'ai_chat.right_panel.scenario_extract_tasks': '✨ Extract Tasks from Note',
  'ai_chat.right_panel.scenario_extract_tasks_desc':
    'Extract actionable tasks and create proposals from note/meeting summary',
  'ai_chat.right_panel.context_overdue_tasks': {
    one: 'Review overdue task — {count}',
    other: 'Review overdue tasks — {count}',
  },
  'ai_chat.right_panel.context_overdue_tasks_desc': 'Show the tasks and suggest an execution order',
  'ai_chat.right_panel.context_risk_deals': {
    one: 'Review deal at risk — {count}',
    other: 'Review deals at risk — {count}',
  },
  'ai_chat.right_panel.context_risk_deals_desc': 'Suggest safe next steps for these deals',
  'ai_chat.right_panel.context_hot_leads': {
    one: 'Prepare a hot-lead follow-up — {count}',
    other: 'Prepare hot-lead follow-ups — {count}',
  },
  'ai_chat.right_panel.context_hot_leads_desc': 'Draft emails without sending them automatically',
  'ai_chat.overlay.deal_title': 'Deal preview',
  'ai_chat.overlay.contact_title': 'Contact preview',
  'ai_chat.overlay.contact_details': 'Contact details',
  'ai_chat.overlay.empty_details': 'No details selected',
  'ai_chat.overlay.open_full_page': 'Open card',
  'ai_chat.overlay.load_failed': 'Could not load the data',
  'ai_chat.overlay.stage': 'Stage',
  'ai_chat.overlay.amount': 'Amount',
  'ai_chat.overlay.company': 'Company',
  'ai_chat.overlay.contact': 'Contact person',
  'ai_chat.overlay.next_step': 'Next step',
  'ai_chat.overlay.close': 'Close',
  'ai_chat.overlay.probability': 'Probability',
  'ai_chat.overlay.created_at': 'Created',
  'ai_chat.overlay.expected_close': 'Expected close',
  'ai_chat.overlay.manager': 'Assignee',
  'ai_chat.overlay.source': 'Source',
  'ai_chat.overlay.quick_actions': 'AI Actions',
  'ai_chat.overlay.action_audit_risk': 'Audit deal risk',
  'ai_chat.overlay.action_draft_email': 'Draft follow-up',
  'ai_chat.overlay.action_create_tasks': 'Create task plan',
  'ai_chat.overlay.action_email': 'Email',
  'ai_chat.overlay.action_note': 'Note',
  'ai_chat.overlay.action_task': 'Task',
  'ai_chat.overlay.action_call': 'Call',
  'ai_chat.overlay.general_info': 'General information',
  'ai_chat.overlay.additional': 'Additional',
  'ai_chat.overlay.created_label': 'Created:',
  'ai_chat.overlay.open_full_card': 'Open full card',
  'ai_chat.overlay.open_contact_profile': 'Open contact profile',
  'ai_chat.overlay.contacts': 'Contacts',
  'ai_chat.overlay.phone': 'Phone',
  'ai_chat.overlay.email': 'Email',
  'ai_chat.tool_calls.actions_done': '{count} actions executed',
  'ai_chat.tool_calls.steps': '{count} agent steps',
  'ai_chat.tool_calls.errors': 'errors: {count}',
  'ai_chat.agent.responding': 'Answering:',
  'ai_chat.agent.chat_assistant': 'CRM assistant',
  'ai_chat.agent.deal_specialist': 'Deal specialist',
  'ai_chat.agent.tasks_specialist': 'Tasks/Calendar specialist',
  'ai_chat.agent.views_builder': 'Views specialist',
  'ai_chat.actions.pin_note_prompt': 'Attach the selected answer as a note to the selected deal.',
  'ai_chat.actions.create_tasks_prompt': 'Create CRM tasks from the selected answer.',
  'ai_chat.actions.dashboard_prompt': 'Create a dashboard widget from the selected answer.',
  'ai_chat.overlay.recent_notes': 'Notes & Activity',
  'ai_chat.overlay.no_notes': 'No notes yet',
  'ai_chat.widget.collapse': 'Collapse',
  'ai_chat.widget.expand': 'Details',
  'ai_chat.widget.tool_executed': 'Tool executed',
  'ai_chat.suggestions.hot_leads': '🔥 Hot leads',
  'ai_chat.suggestions.risk_audit': '⚠️ Risk audit',
  'ai_chat.suggestions.follow_up': '✉️ Follow-up email',
  'ai_chat.suggestions.daily_tasks': '📋 Daily tasks',
  'ai_chat.suggestions.extract_tasks': '✨ Extract Tasks',
  'ai_chat.welcome.title': 'How can I accelerate your business today?',
  'ai_chat.welcome.try_asking': 'Try asking',
  'ai_chat.welcome.subtitle':
    'GovardOS AI Assistant is ready to analyze your pipeline, draft client communications, and monitor deal risks',
  'ai_chat.welcome.pipeline_audit_title': 'Pipeline Express Audit',
  'ai_chat.welcome.pipeline_audit_desc':
    'Identify stalled stages, win probability, and deal churn risks',
  'ai_chat.welcome.hot_leads_title': 'Today’s Hot Leads',
  'ai_chat.welcome.hot_leads_desc':
    'Clients with no recent touchpoints ready for conversion or call',
  'ai_chat.welcome.follow_up_title': 'Follow-up Assistant',
  'ai_chat.welcome.follow_up_desc':
    'Generate personalized email drafts with safety confirmation gates',
  'ai_chat.welcome.manager_brief_title': 'Executive Sales Brief',
  'ai_chat.welcome.manager_brief_desc': 'Sales, risk and priority briefing for the sales manager',
  'ai_chat.slash.title': 'Quick Commands',
  'ai_chat.slash.hint_prefix': 'type',
  'ai_chat.slash.hint_suffix': 'in the input field',
  'ai_chat.slash.lead': 'Find today’s hot leads',
  'ai_chat.slash.risk': 'Run pipeline risk audit',
  'ai_chat.slash.email': 'Draft follow-up email',
  'ai_chat.slash.task': 'Generate daily task plan',
  'ai_chat.slash.brief': 'Generate executive briefing',
  'ai_chat.right_panel.active_deal_default': 'Deal in progress',
  'ai_chat.right_panel.active_contact_default': 'Contact',
  'ai_chat.right_panel.active_risk_deal_default': 'Deal in focus',
  'ai_chat.prompt.hot_leads': 'Find today’s hot leads and propose an action plan',
  'ai_chat.prompt.my_day': 'Build my day',
  'ai_chat.prompt.my_day_meetings':
    'Prepare me for today’s meetings from the open My day overview: build a short read-only preparation plan for each meeting (time, linked deal and contact when present) and never invent missing data; do not create or change anything in CRM',
  'ai_chat.meetings_prep.title': 'Meeting preparation for today ({count}):',
  'ai_chat.meetings_prep.no_meetings': 'No meetings today. No CRM records were changed.',
  'ai_chat.meetings_prep.load_error':
    'Could not load today’s meetings from the day briefing. No CRM records were changed.',
  'ai_chat.meetings_prep.meeting_line': '{index}. “{title}” — {interval}.',
  'ai_chat.meetings_prep.linked': 'Linked: {links}.',
  'ai_chat.meetings_prep.linked_none': 'no linked deal or contact',
  'ai_chat.meetings_prep.linked_deal': 'deal “{title}”',
  'ai_chat.meetings_prep.linked_contact': 'contact {name}',
  'ai_chat.meetings_prep.goals_title': 'Conversation goals:',
  'ai_chat.meetings_prep.goal1': 'clarify the current situation and the client’s expectations',
  'ai_chat.meetings_prep.goal2': 'discuss the next steps and deadlines',
  'ai_chat.meetings_prep.goal3': 'record the agreed outcomes in CRM after the meeting',
  'ai_chat.meetings_prep.no_crm_changes': 'No CRM records were changed.',
  'ai_chat.meetings_prep.interval_unavailable': 'time unavailable',
  'ai_chat.prompt.my_day_overdue_tasks':
    'Review the overdue tasks from my briefing and suggest an execution order',
  'ai_chat.prompt.my_day_risk_deals':
    'Review the deals at risk from my briefing and suggest safe next steps',
  'ai_chat.prompt.my_day_hot_leads':
    'Prepare a follow-up plan for the hot leads from my briefing without sending emails',
  'ai_chat.prompt.deal_risks': 'Analyze risks across current pipeline deals',
  'ai_chat.prompt.pipeline_audit': 'Analyze risks and stalled deals in the current pipeline',
  'ai_chat.prompt.follow_up': 'Draft personalized client follow-up emails without sending',
  'ai_chat.prompt.daily_plan': 'Aggregate today’s tasks and prioritize manager actions',
  'ai_chat.prompt.extract_tasks':
    'Extract actionable tasks from this note and create an action plan',
  'ai_chat.prompt.executive_brief':
    'Generate executive briefing on current deals and pipeline conversion',
  'ai_chat.actions.pin_note': 'Pin as deal note',
  'ai_chat.actions.create_tasks': 'Create tasks',
  'ai_chat.actions.dashboard': 'Add to dashboard',
  'ai_chat.actions.copy': 'Copy response',
  'ai_chat.actions.copied': 'Copied to clipboard',
  'ai_chat.actions.remember': 'Remember',
  'ai_chat.actions.remembered': 'Saved',
  'ai_chat.actions.regenerate': 'Regenerate',
  'ai_chat.actions.edit': 'Edit',
  'ai_chat.actions.save': 'Save',
  'ai_chat.actions.cancel': 'Cancel',
  'ai_chat.show_deal_cockpit': 'Show Deal Cockpit',
  'ai_chat.all_tasks': 'All Tasks',
  'ai_chat.task_details': 'Task Details',
  'ai_chat.execution_stream': 'Task #{id} · AI Execution Stream',
  'ai_chat.feedback_placeholder':
    'Leave feedback to guide the agent — your comments shape the next run...',
  'ai_chat.send_feedback': 'Send feedback',
  'ai_chat.task_board.open_scenario': 'Open scenario',
  'ai_chat.task_board.loading': 'Loading tasks...',
  'ai_chat.task_board.in_progress': 'In Progress',
  'ai_chat.task_board.pending_review': 'Pending Review',
  'ai_chat.task_board.history': 'Task History / Backlog',
  'ai_chat.task_board.no_archived_tasks': 'No archived tasks',
  'ai_chat.task_board.brief': 'Brief',
  'ai_chat.task_board.default_brief': 'Agent execution brief & notes',
  'ai_chat.task_board.delete_title': 'Delete task?',
  'ai_chat.task_board.delete': 'Delete task',
  'ai_chat.task_board.yes': 'Yes',
  'ai_chat.task_board.no': 'No',
  'ai_chat.task_board.screenshot_data': 'screenshot data',
  'ai_chat.task_input.fill_demo': 'Fill in the demo prompt for a screenshot',
  'ai_chat.task_input.file': 'File',
  'ai_chat.task_input.placeholder':
    'Type a task or instruction... Use @ to mention contacts or deals',
  'ai_chat.task_input.attach_context_file': 'Attach CRM context file',
  'ai_chat.task_input.attach_file': 'Attach file',
  'ai_chat.task_input.web_search': 'Web search',
  'ai_chat.task_input.toggle_web_search': 'Toggle web search',
  'ai_chat.task_input.agent_tools': 'Agent tools',
  'ai_chat.task_input.toggle_agent_tools': 'Toggle agent tools',
  'ai_chat.task_input.tool.deal_risk': 'Deal risk',
  'ai_chat.task_input.tool.follow_up': 'Follow-up draft',
  'ai_chat.task_input.web_search_enabled': 'Web search enabled',
  'ai_chat.task_input.prompt.deal_risk': 'Review the deal risk and suggest the next step',
  'ai_chat.task_input.prompt.follow_up': 'Prepare a follow-up email without sending it',
  'ai_chat.task_input.prompt.risk_analysis': 'Analyze risks across current deals',
  'ai_chat.task_input.prompt.hot_leads': 'Show hot leads from the last week',
  'ai_chat.task_input.prompt.action_plan': 'Create an action plan for new clients',
  'ai_chat.task_input.suggestion.risk_analysis': 'Deal risk analysis',
  'ai_chat.task_input.suggestion.hot_leads': 'Hot leads',
  'ai_chat.task_input.suggestion.action_plan': 'CRM action plan',
  'ai_chat.artifact.copied': 'Copied',
  'ai_chat.artifact.copy': 'Copy',
  'ai_chat.artifact.export': 'Export',
  'ai_chat.artifact.preview': 'Preview',
  'ai_chat.artifact.source': 'Source code',
  'ai_chat.artifact.type_label': '{type} artifact',
  'ai_chat.artifact.close_canvas': 'Close canvas',
  'ai_chat.artifact.html_preview': 'HTML preview',
  'ai_chat.artifact.type_doc': 'Markdown Document',
  'ai_chat.artifact.type_html': 'HTML Widget',
  'ai_chat.artifact.type_mermaid': 'Process Diagram',
  'ai_chat.artifact.type_todo': 'Task Checklist',
  'ai_chat.artifact.lines': 'lines',
  'ai_chat.artifact.download': 'Download file',
  'ai_chat.artifact.open_side_canvas': 'Open in side canvas',
  'ai_chat.artifact.open_in_canvas_mode': 'Open full canvas',
  'ai_chat.artifact.expand': 'Expand',
  'ai_chat.artifact.collapse': 'Collapse',
  'ai_chat.artifact.no_tasks': 'No actionable tasks were found in the artifact.',
  'ai_chat.artifact.extraction_failed':
    'I could not extract verified task proposals from the artifact. No tasks were created.',
  'ai_chat.artifact.truncated': '[truncated: {kept} of {total} characters]',
  'ai_chat.artifact.attach_note': 'Save as note',
  'ai_chat.artifact.create_crm_tasks': 'Create tasks in CRM',
  'ai_chat.artifact.action_note_prefix': 'Save this artifact as a deal note',
  'ai_chat.artifact.action_tasks_prefix': 'Generate CRM tasks based on artifact',
  'ai_chat.common.open_canvas': 'Open in canvas',
  'ai_chat.todo.default_title': 'Task execution plan',
  'ai_chat.todo.progress': 'Execution progress',
  'ai_chat.todo.completed_count': '{completed} of {total} ({percent}%)',
  'ai_chat.mermaid.default_title': 'CRM process diagram',
  'ai_chat.mermaid.render_error': 'Could not render the Mermaid diagram',
  'ai_chat.mermaid.code': 'Code',
  'ai_chat.mermaid.syntax_error': 'Mermaid syntax error',
  'ai_chat.demo_cockpit.state.pinned': 'Docked',
  'ai_chat.demo_cockpit.title': 'Deal cockpit',
  'ai_chat.demo_cockpit.short_mode': 'Short mode',
  'ai_chat.demo_cockpit.state.floating': 'Floating',
  'ai_chat.demo_cockpit.actions.expand': 'Expand Deal Cockpit',
  'ai_chat.demo_cockpit.actions.collapse': 'Collapse Deal Cockpit',
  'ai_chat.demo_cockpit.actions.full': 'Open full Deal Cockpit',
  'ai_chat.demo_cockpit.actions.unpin_hint': 'Undock widget and make it floating',
  'ai_chat.demo_cockpit.actions.pin_hint': 'Dock widget in the panel',
  'ai_chat.demo_cockpit.actions.unpin': 'Undock widget',
  'ai_chat.demo_cockpit.actions.pin': 'Dock widget',
  'ai_chat.demo_cockpit.actions.hide': 'Hide widget',
  'ai_chat.demo_cockpit.sections.health': 'Deal health',
  'ai_chat.demo_cockpit.sections.next_step': 'Next step',
  'ai_chat.demo_cockpit.sections.next_action': 'Next action',
  'ai_chat.demo_cockpit.sections.activity_signal': 'Activity signal',
  'ai_chat.demo_cockpit.sections.best_next_step': 'Best next step',
  'ai_chat.demo_cockpit.sections.tasks': 'Tasks',
  'ai_chat.demo_cockpit.metrics.amount': 'Amount',
  'ai_chat.demo_cockpit.metrics.tasks': 'Tasks',
  'ai_chat.demo_cockpit.metrics.open_tasks': '{count} open',
  'ai_chat.demo_cockpit.metrics.overdue': 'Overdue',
  'ai_chat.demo_cockpit.activity.next': 'Next activity',
  'ai_chat.demo_cockpit.activity.last': 'Last activity',
  'ai_chat.demo_cockpit.priority.low': 'Low',
  'ai_chat.demo_cockpit.priority.medium': 'Medium',
  'ai_chat.demo_cockpit.priority.high': 'High',
  'ai_chat.demo_cockpit.disclaimer': 'Local demo data for screenshots. CRM data is not changed.',
  'ai_chat.task_brief.checklist.request': 'Understand the manager request',
  'ai_chat.task_brief.checklist.context': 'Review CRM context',
  'ai_chat.task_brief.checklist.artifact': 'Create a useful artifact',
  'ai_chat.task_brief.checklist.approval': 'Keep changes behind approval',
  'ai_chat.task_brief.default_artifact_title': 'Agent workflow map',
  'ai_chat.task_brief.default_artifact_content':
    'graph TD\nA[Request]-->B[CRM tools]\nB-->C[Artifact]\nC-->D[Approval]',
  'ai_chat.task_brief.default_summary':
    'The agent prepares a CRM result: analyzes the request, gathers context, and shows a safe next step.',
  'ai_chat.task_brief.task_number': 'Task #{id}',
  'ai_chat.task_brief.in_progress': 'In Progress',
  'ai_chat.task_brief.stop': 'Stop task',
  'ai_chat.task_brief.requirements': 'Requirements & Context',
  'ai_chat.task_brief.instructions': 'Instructions',
  'ai_chat.task_brief.add_subtask': 'Add sub-task',
  'ai_chat.task_brief.artifacts': 'Artifacts',
  'ai_chat.task_brief.activities': 'Activities',
  'ai_chat.task_brief.created_by_user': 'Task created by User',
  'ai_chat.task_brief.just_now': 'Just now',
  'ai_chat.task_brief.agent_started': 'Agent started execution stream',
  'ai_chat.task_brief.seconds_ago': '{count}s ago',
  'ai_chat.typing': 'AI is thinking...',
  'ai_chat.auto_approve.label': 'Auto approve',
  'ai_chat.auto_approve.tooltip':
    'Automatically approve safe agent actions (notes, links). Destructive actions always require confirmation.',
  'ai_chat.auto_approve.update_failed': 'Failed to update auto-approve setting',
  'ai_chat.tool_debug.label': 'Tool call debug',
  'ai_chat.tool_debug.hint':
    'For the working team: show raw tool calls and their arguments. Regular users do not need this.',
  'ai_chat.composer.hint_enter': 'Enter to send · Shift+Enter for a new line',
  'ai_chat.composer.slash_hint': '/ — commands',
  'ai_chat.composer.attach_file': 'Attach file',
  'ai_chat.composer.drop_file_here': 'Drop file here',
  'ai_chat.context_chips.attach': 'Attach entity',
  'ai_chat.context_chips.search': 'Search...',
  'ai_chat.context_chips.empty': 'Nothing found',
  'ai_chat.context_chips.remove': 'Remove',
  'ai_chat.context_chips.max_reached': 'Up to 8 entities',
  'ai_chat.context_chips.back': 'Back',
  'ai_chat.context_chips.deal': 'Deal',
  'ai_chat.context_chips.contact': 'Contact',
  'ai_chat.context_chips.company': 'Company',
  'ai_chat.context_chips.task': 'Task',
  'ai_chat.context_chips.note': 'Note',
  'ai_chat.context_chips.user': 'User',
  'ai_chat.mention.placeholder': 'Mention entity',
  'ai_chat.mention.empty': 'Nothing found',
  'ai_chat.model_selector.label': 'Model and gateway',
  'ai_chat.model_selector.choose_available': 'Choose an available model',
  'ai_chat.model_selector.unavailable_hint':
    'This provider is currently unavailable. Choose OpenRouter or OpenCode to continue the conversation.',
  'ai_chat.model_selector.provider': 'Provider',
  'ai_chat.model_selector.model': 'Model',
  'ai_chat.model_selector.neuraldeep': 'NeuralDeep · RU',
  'ai_chat.model_selector.openrouter': 'OpenRouter',
  'ai_chat.model_selector.badge.deepseek/deepseek-v4.1-flash': 'Low cost',
  'ai_chat.model_selector.badge.google/gemini-3.5-flash-lite': 'Fast',
  'ai_chat.model_selector.badge.openai/gpt-5.6-terra': 'Balanced',
  'ai_chat.model_selector.badge.~deepseek/deepseek-v4-flash-latest': 'Low cost',
  'ai_chat.model_selector.badge.minimax/minimax-m3': 'Low cost',
  'ai_chat.model_selector.badge.openai/gpt-5.4-mini': 'Quality',
  'ai_chat.model_selector.opencode': 'OpenCode Zen · Space Bunny',
  'ai_chat.model_selector.govard': 'Govard · DeepSeek v4.1 Flash',
  'ai_chat.error.title': 'Response error',
  'ai_chat.error.retry': 'Retry',
  'ai_chat.error.cancelled_recoverable':
    'The response was stopped. The outcome is unconfirmed — retrying will safely check the state.',
  'ai_chat.error.unconfirmed_outcome':
    'The outcome of this request is unconfirmed: the connection dropped after CRM changes may have already started. A retry checks the server state and resumes the original request.',
  'ai_chat.error.indeterminate_result':
    'The retry returned the same server error and the turn outcome remains indeterminate: the system may have already saved a change. Check the CRM before sending the request again.',
  'ai_chat.error.cancelled_outcome':
    'The request was cancelled. The outcome is unconfirmed: CRM changes may have already started — check the CRM before sending the request again.',
  'ai_chat.error.deadline_exceeded':
    'I did not manage to answer within the allotted time. Try simplifying the request or splitting it into parts.',
  'ai_chat.error.approval_decide_failed':
    'Failed to apply the approval decision. Please try again.',
  'ai_chat.error.request_failed': 'Chat request failed',
  'ai_chat.error.turn_failed': 'Chat turn failed',
  'ai_chat.error.not_ready': 'The assistant is not ready yet — try again in a moment',
  'ai_chat.error.busy': 'The assistant is still answering — wait for the turn to finish',
  'ai_chat.client_action.applied': 'Opening as requested by the assistant',
  'ai_chat.client_action.unsupported':
    'The assistant requested a transition that is not supported yet',
  'ai_chat.cockpit.title': 'AI assistant',
  'ai_chat.cockpit.context_none': 'Current section',
  'ai_chat.cockpit.context_value': '{type}: {value}',
  'ai_chat.cockpit.close': 'Close the assistant',
  'ai_chat.cockpit.actions_group_label': 'Quick actions',
  'ai_chat.cockpit.local_action_applied': 'Applying the selected action',
  'ai_chat.cockpit.view.kanban': 'Kanban',
  'ai_chat.cockpit.view.list': 'List',
  'ai_chat.cockpit.view.cards': 'Cards',
  'ai_chat.cockpit.filter.deals': 'With deals',
  'ai_chat.cockpit.filter.email': 'From email',
  'ai_chat.cockpit.navigate.deals': 'To deals',
  'ai_chat.cockpit.navigate.contacts': 'To contacts',
  'ai_chat.reasoning.thinking': 'Thinking...',
  'ai_chat.reasoning.thinking_elapsed': 'Thinking... {seconds}s',
  'ai_chat.markdown.mermaid_loading': 'Mermaid diagram is rendering…',
  'ai_chat.markdown.table_scroll': 'Response table (horizontal scroll)',
  'ai_chat.error.copy_failed': 'Failed to copy the text',
  'ai_chat.error.remember_failed': 'Failed to save to memory',
  'ai_chat.error.upload_failed': 'Failed to upload the file',
  'ai_chat.error.upload_needs_context':
    'Attachments are only available in a specific deal or contact chat',
  'ai_chat.file_input.conversation_required':
    'Send a message first — a file can be attached to your next message',
  'ai_chat.file_input.attachment.chip': 'File: {fileName} · {format}',
  'ai_chat.file_input.pending.label': 'Attached to the next message: {fileName}',
  'ai_chat.file_input.pending.remove': 'Remove file',
  'ai_chat.file_input.preview.title': 'File preview',
  'ai_chat.file_input.preview.rows': {
    one: '{rows} row',
    other: '{rows} rows',
  },
  'ai_chat.file_input.preview.columns': 'Columns',
  'ai_chat.file_input.preview.mapping': 'Detected field mapping',
  'ai_chat.file_input.preview.mapping_empty': 'No fields detected',
  'ai_chat.file_input.preview.sample': 'Sample rows',
  'ai_chat.file_input.error.legacy_office':
    'Legacy Office format (.doc/.ppt/.xls) is not supported — re-save the file in a modern format',
  'ai_chat.file_input.error.image_not_supported':
    'Images are not supported as assistant input — paste the text or attach a document instead',
  'ai_chat.file_input.error.empty_content': 'The file is empty or has no extractable text',
  'ai_chat.file_input.error.unsupported_content_type':
    'Unsupported file format — use TXT, MD, CSV, TSV, JSON, PDF, DOCX, PPTX or XLSX',
  'ai_chat.voice_input.start': 'Voice input',
  'ai_chat.voice_input.stop': 'Stop recording',
  'ai_chat.voice_input.listening': 'Listening...',
  'ai_chat.voice_input.unsupported': 'Voice input is not supported in your browser',
  'ai_chat.session_sidebar.pinned_chats': 'Pinned chats',
  'ai_chat.session_sidebar.pin_chat': 'Pin conversation',
  'ai_chat.session_sidebar.unpin_chat': 'Unpin conversation',
  'command_menu.close': 'Close',
  'command_menu.search_placeholder': 'Search deals, contacts, tasks and commands...',
  'command_menu.no_results': 'No matching results',
  'command_menu.navigate': 'Navigate',
  'command_menu.select': 'Select',
  'command_menu.goto_deals': 'Sales pipeline and kanban',
  'command_menu.goto_contacts': 'Customer directory & companies',
  'command_menu.goto_tasks': 'Tasks and todo items',
  'command_menu.goto_meetings': 'Meetings and calendar',
  'command_menu.goto_chat': 'GovardOS AI Assistant',
  'command_menu.goto_templates': 'Document & email templates',
  'command_menu.goto_dashboard': 'Executive briefing & metrics',
  'command_menu.goto_settings': 'CRM settings and profile',
  'command_menu.create_deal': 'Create Deal',
  'command_menu.create_deal_desc': 'Add a new deal to pipeline',
  'command_menu.create_contact': 'Create Contact',
  'command_menu.create_contact_desc': 'Add customer to database',
  'command_menu.switch_language': 'Switch interface language',
  'command_menu.hot_leads_desc': 'Find deals requiring urgent follow-up',
  'command_menu.risk_audit_desc': 'Audit stuck and stale deals',
  'command_menu.follow_up_desc': 'Generate personalized email drafts',
  'command_menu.create_task': 'Create Task',
  'command_menu.create_task_desc': 'Add a new task to your todo list',
  'command_menu.goto_projects': 'Projects and teamwork',
  'command_menu.goto_companies': 'Company directory and links',
  'command_menu.search_results': 'Search results',
  'command_menu.commands': 'Commands',
  'command_menu.searching': 'Searching…',
  'command_menu.entity_deal': 'Deal',
  'command_menu.entity_contact': 'Contact',
  'command_menu.entity_company': 'Company',
  'command_menu.entity_task': 'Task',
  'command_menu.entity_project': 'Project',
  'deal_health.title': 'Deal Health Index',
  'deal_health.status_good': 'Good',
  'deal_health.status_warning': 'Warning',
  'deal_health.status_critical': 'High Risk',
  'deal_health.desc_good': 'Normal engagement, high probability of winning.',
  'deal_health.desc_warning': 'Follow-up required, no contact response for >3 days.',
  'deal_health.desc_critical': 'Stalled deal, high risk of losing customer.',
  'shortcuts.title': 'Keyboard Shortcuts',
  'shortcuts.subtitle': 'Navigate and manage CRM at full speed',
  'shortcuts.group_global': 'Global',
  'shortcuts.group_navigation': 'Navigation',
  'shortcuts.group_actions': 'Actions',
  'shortcuts.command_menu': 'Command Menu',
  'shortcuts.ai_copilot': 'AI chat',
  'shortcuts.cheatsheet': 'Shortcuts Cheatsheet',
  'shortcuts.goto_deals': 'Go to Deals',
  'shortcuts.goto_contacts': 'Go to Contacts',
  'shortcuts.goto_tasks': 'Go to Tasks',
  'shortcuts.goto_analytics': 'Go to dashboard analytics',
  'shortcuts.create_deal': 'Create Deal',
  'shortcuts.quick_note': 'Quick Note',
  'revenue_goal.title': 'Monthly Revenue Goal',
  'revenue_goal.forecast_title': 'AI Revenue Forecast',
  'revenue_goal.forecast_desc':
    'Forecast calculated from active negotiation pipeline and historical win rate: {amount} ₽',
  'revenue_goal.forecast_badge': 'AI Forecast',
  'revenue_goal.win_rate': 'Win rate',
  'smart_tags.hot': 'Hot',
  'smart_tags.vip': 'VIP',
  'smart_tags.high_value': 'High Value',
  'smart_tags.stalled': 'Stalled',
  'smart_tags.fast_track': 'Fast Track',
  'smart_followup.title': 'AI Smart Follow-up',
  'smart_followup.widget_title': 'AI Follow-up Feed',
  'smart_followup.pending_badge': 'pending follow-ups',
  'smart_followup.days_silent': 'days silent',
  'smart_followup.open_card': 'Open deal card',
  'smart_followup.action_btn': 'Follow-up',
  'smart_followup.defaults.stale_1.title': 'Equipment rollout for salon network',
  'smart_followup.defaults.stale_1.contact_name': 'Elena Smirnova',
  'smart_followup.defaults.stale_1.prompt':
    'Write a polite follow-up to Elena Smirnova for the 450,000 ₽ deal and suggest a call this week.',
  'smart_followup.defaults.stale_2.title': 'Annual maintenance contract',
  'smart_followup.defaults.stale_2.contact_name': 'Dmitry Ivanov',
  'smart_followup.defaults.stale_2.prompt':
    'Prepare a short reminder for Dmitry Ivanov about approving the commercial proposal for annual maintenance.',
  'smart_followup.defaults.stale_3.title': 'CRM rollout for branch office',
  'smart_followup.defaults.stale_3.contact_name': 'Anna Kuznetsova',
  'smart_followup.defaults.stale_3.prompt':
    'Generate a follow-up for Anna Kuznetsova focused on the 10% discount if the deal closes before month end.',

  // Projects (roadmap F3-4) — list page.
  'features.features.projects.pages.projectspage.проекты': 'Projects',
  'features.features.projects.pages.projectspage.подзаголовок':
    'Portfolio work of the team: project tasks, notes and meetings live here.',
  'features.features.projects.pages.projectspage.новый_проект': 'New project',
  'features.features.projects.pages.projectspage.поиск': 'Search projects',
  'features.features.projects.pages.projectspage.фильтр_по_статусу': 'Status',
  'features.features.projects.pages.projectspage.не_удалось_загрузить_проекты':
    'Failed to load projects',
  'features.features.projects.pages.projectspage.проектов_нет':
    'No projects yet. Create the first one with «New project».',
  'features.features.projects.pages.projectspage.название': 'Name',
  'features.features.projects.pages.projectspage.статус': 'Status',
  'features.features.projects.pages.projectspage.владелец': 'Owner',
  'features.features.projects.pages.projectspage.срок': 'Due date',
  'features.features.projects.pages.projectspage.задачи': 'Tasks',
  'features.features.projects.pages.projectspage.всего_проектов': 'Total projects',
  'features.features.projects.pages.projectspage.в_работе': 'In progress',
  'features.features.projects.pages.projectspage.завершено': 'Completed',
  // Projects — form modal.
  'features.features.projects.components.projectformmodal.сохранить': 'Save',
  'features.features.projects.components.projectformmodal.создать_проект': 'Create project',
  'features.features.projects.components.projectformmodal.редактировать_проект': 'Edit project',
  'features.features.projects.components.projectformmodal.новый_проект': 'New project',
  'features.features.projects.components.projectformmodal.название': 'Name',
  'features.features.projects.components.projectformmodal.название_обязательно':
    'Enter the project name',
  'features.features.projects.components.projectformmodal.статус': 'Status',
  'features.features.projects.components.projectformmodal.владелец': 'Owner',
  'features.features.projects.components.projectformmodal.участники': 'Members',
  'features.features.projects.components.projectformmodal.описание': 'Description',
  'features.features.projects.components.projectformmodal.начало': 'Start date',
  'features.features.projects.components.projectformmodal.срок': 'Due date',
  // Projects — card page.
  'features.features.projects.pages.projectcardpage.не_удалось_загрузить_проект':
    'Failed to load project',
  'features.features.projects.pages.projectcardpage.к_проектам': 'Back to projects',
  'features.features.projects.pages.projectcardpage.редактировать': 'Edit',
  'features.features.projects.pages.projectcardpage.удалить_проект': 'Delete project?',
  'features.features.projects.pages.projectcardpage.задачи_встречи_и_заметки_останутся_но_отвяжутся_от_проекта':
    'Tasks, meetings and notes stay, but are unlinked from the project.',
  'features.features.projects.pages.projectcardpage.владелец': 'Owner',
  'features.features.projects.pages.projectcardpage.начало': 'Start',
  'features.features.projects.pages.projectcardpage.срок': 'Due date',
  'features.features.projects.pages.projectcardpage.участники': 'Members',
  'features.features.projects.pages.projectcardpage.задачи': 'Tasks',
  'features.features.projects.pages.projectcardpage.встречи': 'Meetings',
  'features.features.projects.pages.projectcardpage.детали': 'Details',
  'features.features.projects.pages.projectcardpage.описание': 'Description',
  'features.features.projects.pages.projectcardpage.описания_нет': 'No description.',
  'features.features.projects.pages.projectcardpage.выберите_участников': 'Select members',
  'features.features.projects.pages.projectcardpage.сохранить': 'Save',
  'features.features.projects.pages.projectcardpage.участников_нет':
    'No members yet — add the first one.',
  'features.features.projects.pages.projectcardpage.статус': 'Status',
  'features.features.projects.pages.projectcardpage.заметки': 'Notes',
  // Projects — card tabs.
  'features.features.projects.components.projecttaskstab.задачи_проекта': 'Project tasks: {p0}',
  'features.features.projects.components.projecttaskstab.новая_задача': 'New task',
  'features.features.projects.components.projecttaskstab.задач_нет':
    'No tasks yet — create the first one.',
  'features.features.projects.components.projectnotestab.заметки_проекта': 'Project notes: {p0}',
  'features.features.projects.components.projectnotestab.новая_заметка': 'New note',
  'features.features.projects.components.projectnotestab.заметок_нет':
    'No notes yet — create the first one.',
  'features.features.projects.components.projectnotestab.создать': 'Create',
  'features.features.projects.components.projectnotestab.текст': 'Text',
  'features.features.projects.components.projectmeetingstab.встречи_проекта':
    'Project meetings: {p0}',
  'features.features.projects.components.projectmeetingstab.новая_встреча': 'New meeting',
  'features.features.projects.components.projectmeetingstab.встреч_нет':
    'No meetings yet — schedule the first one.',
  'features.features.projects.components.projectmeetingstab.запланирована': 'Scheduled',
  'features.features.projects.components.projectmeetingstab.завершена': 'Completed',
  'features.features.projects.components.projectmeetingstab.отменена': 'Cancelled',
  'imports.title': 'Excel Import / Export',
  'imports.error_title': 'The import failed',
  'imports.entity': 'Entity:',
  'imports.upload_hint': 'Drag an xlsx file here or click to select',
  'imports.back': 'Back',
  'imports.column_mapping': 'Column mapping',
  'imports.skip_column': '— skip —',
  'imports.result': 'Import result',
  'imports.export': 'Export',
  'imports.subtitle':
    'Upload an xlsx file (up to 10MB), map the columns and run the import. Export — up to 1000 rows.',
  'imports.step_upload': 'Upload',
  'imports.step_preview': 'Preview',
  'imports.step_mapping': 'Mapping',
  'imports.step_result': 'Result',
  'imports.upload_and_preview': 'Upload and show preview',
  'imports.next_to_mapping': 'Next to mapping',
  'imports.mapping_hint':
    'Choose which entity field matches each Excel column. Empty — the column is skipped.',
  'imports.save_mapping': 'Save mapping',
  'imports.run_import': 'Run import',
  'imports.created': 'Created:',
  'imports.skipped': 'Skipped (duplicates):',
  'imports.errors': 'Errors:',
  'imports.col_row': 'Row',
  'imports.col_error': 'Error',
  'imports.new_import': 'New import',
  'imports.export_contacts': 'Export contacts',
  'imports.export_companies': 'Export companies',
  'imports.export_deals': 'Export deals',
  'imports.entity.contacts': 'Contacts',
  'imports.entity.companies': 'Companies',
  'imports.entity.deals': 'Deals',
  'imports.field.firstName': 'First name',
  'imports.field.lastName': 'Last name',
  'imports.field.email': 'Email',
  'imports.field.phone': 'Phone',
  'imports.field.company': 'Company',
  'imports.field.role': 'Role',
  'imports.field.tags_comma': 'Tags (comma-separated)',
  'imports.field.notes': 'Notes',
  'imports.field.name': 'Name',
  'imports.field.domain': 'Domain',
  'imports.field.industry': 'Industry',
  'imports.field.website': 'Website',
  'imports.field.description': 'Description',
  'imports.field.tags': 'Tags',
  'imports.field.title': 'Title',
  'imports.field.amount': 'Amount',
  'imports.field.stage': 'Stage',
  'imports.field.currency': 'Currency',
  'snippets.open': 'Open',
  'snippets.deal_risk.loss_risk': 'Loss risk:',
  'snippets.entity_feed.row_hint': 'Click a row for details',
  'snippets.email_draft.subject_prefix': 'Subject',
  'chat.meeting_fallback': 'Meeting',
  'chat.task_fallback': 'Task',
  // deal_risk: deterministic engine signals (machine code + params) and
  // recommendations, localized in the snippets with the engine text as fallback.
  'chat.deal_risk.days_unit': {
    one: 'day',
    other: 'days',
  },
  'chat.deal_risk.signal.missing_next_activity': 'The next activity for the deal is not scheduled.',
  'chat.deal_risk.signal.overdue_next_activity': {
    one: 'The next activity is {days} day overdue.',
    other: 'The next activity is {days} days overdue.',
  },
  'chat.deal_risk.signal.stale_activity': {
    zero: 'No activity has been recorded for this deal yet.',
    one: 'No new activity for {days} day already.',
    other: 'No new activity for {days} days already.',
  },
  'chat.deal_risk.signal.stage_age_over_norm':
    'The deal has been in the "{stage}" stage longer than the norm: {days} {daysWord} against a norm of {norm} {normWord}.',
  'chat.deal_risk.signal.qualification_gaps':
    'Closing checklist: {gaps} of {total} items are not confirmed.',
  'chat.deal_risk.signal.overdue_task': 'Overdue task: {title}.',
  'chat.deal_risk.recommendation.follow_current_plan.title': 'Follow the current plan',
  'chat.deal_risk.recommendation.follow_current_plan.description':
    'The deal currently shows no clear risk signals. The next step is already scheduled.',
  'chat.deal_risk.recommendation.prepare_followup_email.title': 'Prepare a follow-up email',
  'chat.deal_risk.recommendation.prepare_followup_email.description':
    'Briefly check the client status, confirm their interest, and suggest a convenient next step. The email will not be sent without a separate confirmation.',
  'chat.deal_risk.recommendation.contact_client_no_email.title': 'Contact the client',
  'chat.deal_risk.recommendation.contact_client_no_email.description':
    'The contact has no email for a follow-up. Agree on a convenient communication channel and record the next step.',
  'chat.deal_risk.recommendation.closed_no_followup.title': 'The deal is already closed',
  'chat.deal_risk.recommendation.closed_no_followup.description':
    'A closed deal needs no loss-risk follow-up.',
  'artifacts.diagram_title': 'Process diagram',
  'artifacts.html_widget_title': 'Interactive HTML widget',
  'artifacts.markdown_doc': 'Markdown document',
  'artifacts.action_plan': 'Action plan',
  'artifacts.project_brief': 'Project brief',
  'artifacts.meeting_summary': 'Meeting summary',
  'artifacts.analytics_report': 'Analytical report',
  'artifacts.document_fallback': 'Document',
  'notes.tpl_summary': '📋 **Meeting summary:**\n- Discussed: \n- Agreed: ',
  'notes.tpl_decision': '🎯 **Decision:** ',
  'notes.tpl_task': '⚡ **Task:** ',
  'notes.ai_extract_tasks_prompt': 'Turn this note into tasks:\n\n{body}',
  'copilot.hot_leads': 'Hot leads',
  'copilot.parse_error': 'Failed to parse the tool result.',
  'copilot.no_leads': 'No leads found',
  'copilot.flag_off': 'AI chat (PoC) is disabled. Enable the flag',
  'copilot.flag_off_suffix': 'and restart the frontend.',
  'notes.templates': 'Templates:',
  'settings.ai.system_prompt': 'System prompt',
  'settings.ai.system_prompt_append_placeholder':
    'e.g. Always reply in Russian, be brief, use a friendly tone...',
  'settings.ai.system_prompt_override_placeholder':
    'Full system prompt replacement — leave empty in 99% of cases',
  'settings.ai.model_and_tools': 'Model and tools',
  'settings.ai.model': 'Model',
  'settings.ai.allowed_tools': 'Allowed tools (enabledTools)',
  'settings.ai.allowed_tools_placeholder':
    'search_deals, create_task, mcp_notion_search ... (comma-separated, empty = all)',
  'settings.ai.skills': 'Skills',
  'settings.ai.saved': 'Saved — the agent will pick it up on the next turn',
  'settings.ai.delete_skill': 'Delete skill?',
  'settings.ai.skill_name_placeholder': 'Skill name (e.g. beauty-architect)',
  'settings.ai.skill_description_placeholder': 'Description (optional)',
  'settings.ai.skill_instructions_placeholder':
    'Instructions — what the skill does, how it replies',
  'settings.ai.skill_triggers_placeholder':
    'Comma-separated triggers (e.g. beauty, salon, booking)',
  'settings.ai.skill_tool_allowlist_placeholder':
    'Comma-separated toolAllowlist (e.g. search_deals, create_task)',
  'settings.ai.delete_mcp': 'Delete MCP server?',
  'settings.ai.mcp_name_placeholder': 'Server name (e.g. notion, figma, custom-api)',
  'settings.ai.mcp_headers_placeholder': 'headersRef — env variable name',
  'settings.ai.system_prompt_description':
    'Appended after the CRM_SYSTEM_PROMPT core. Cannot override safety rules and approval discipline. Override is a full replacement (careful).',
  'settings.ai.append_label': 'Append (recommended)',
  'settings.ai.override_label': 'Override (expert)',
  'settings.ai.allowed_tools_description':
    'Restricts the tool registry to an allowlist. MCP tools use the mcp_ prefix.',
  'settings.ai.skills_description':
    'A skill is a named instruction package. Activated by the phrase "use skill X" or a trigger. If toolAllowlist is set, the agent sees only those tools on that turn.',
  'settings.ai.skills_empty':
    'No skills yet — add the first one for the "custom agent in 30 seconds" demo',
  'settings.ai.triggers_prefix': 'triggers:',
  'settings.ai.add_skill': 'Add skill',
  'settings.ai.mcp_message': 'MCP — Model Context Protocol: external tools over http/sse',
  'settings.ai.mcp_description':
    'Name → url/tools/list → discovery. Calling mcp_{server}_{tool} goes through approval (destructive). Secret — via env + headersRef (variable name), not in JSON.',
  'settings.ai.mcp_empty': 'No MCP servers yet',
  'settings.ai.add_mcp': 'Add MCP server',
  'settings.ai.save': 'Save',

  // ─── Platform admin panel (P0: dashboard + users) ─────────────────────────────
  'admin.dashboard.title': 'Admin panel',
  'admin.dashboard.subtitle': 'Platform overview: accounts, activity, workers, and mail queue',
  'admin.dashboard.reload': 'Refresh',
  'admin.dashboard.period_label': 'LLM spend period',
  'admin.dashboard.period_days': 'Last {days} days',
  'admin.dashboard.kpi_users': 'Users',
  'admin.dashboard.kpi_users_24h': '+{count} in 24 hours',
  'admin.dashboard.kpi_workspaces': 'Workspaces',
  'admin.dashboard.kpi_deals': 'Deals',
  'admin.dashboard.kpi_messages_24h': 'Messages (24h)',
  'admin.dashboard.kpi_tokens_24h': '{count} tokens',
  'admin.dashboard.llm_spend_title': 'LLM spend',
  'admin.dashboard.llm_spend_period': 'for {days} days · {messages} messages · {tokens} tokens',
  'admin.dashboard.workers_title': 'Workers',
  'admin.dashboard.load_error': 'Failed to load the platform overview',

  'admin.workers.scenario_runner': 'Scenario runner',
  'admin.workers.telegram_inbound': 'Telegram inbound',
  'admin.workers.telegram_delivery': 'Telegram delivery',
  'admin.workers.mail_outbox': 'Mail outbox',
  'admin.workers.external_calendar_sync': 'External calendar sync',
  'admin.workers.status_healthy': 'running',
  'admin.workers.status_degraded': 'degraded',
  'admin.workers.status_stopped': 'stopped',
  'admin.workers.status_failed': 'failed',
  'admin.workers.status_starting': 'starting',
  'admin.workers.ticks': 'ticks',
  'admin.workers.completed': 'completed',
  'admin.workers.errors': 'errors',
  'admin.workers.last_tick': 'last tick',

  'admin.outbox.title': 'Mail queue',
  'admin.outbox.empty': 'The mail queue is empty',
  'admin.outbox.status_pending': 'pending',
  'admin.outbox.status_sending': 'sending',
  'admin.outbox.status_sent': 'sent',
  'admin.outbox.status_delivered': 'delivered',
  'admin.outbox.status_failed': 'failed',
  'admin.outbox.status_bounced': 'bounced',
  'admin.outbox.status_spam_complaint': 'spam complaints',

  'admin.users.title': 'Users',
  'admin.users.subtitle': '{visible} of {total} users',
  'admin.users.reload': 'Refresh',
  'admin.users.search_label': 'Search users by email or name',
  'admin.users.search_placeholder': 'Search by email or name…',
  'admin.users.status_filter_label': 'Status filter',
  'admin.users.filter_all': 'All',
  'admin.users.filter_verified': 'Verified',
  'admin.users.filter_unverified': 'Unverified',
  'admin.users.filter_blocked': 'Blocked',
  'admin.users.filter_admins': 'Platform admins',
  'admin.users.col_email': 'EMAIL',
  'admin.users.col_name': 'NAME',
  'admin.users.col_status': 'STATUS',
  'admin.users.col_verified': 'EMAIL VERIFIED',
  'admin.users.col_blocked': 'BLOCKED',
  'admin.users.col_platform_role': 'ROLE',
  'admin.users.col_workspaces': 'WORKSPACES',
  'admin.users.col_created': 'CREATED',
  'admin.users.col_last_activity': 'LAST ACTIVITY',
  'admin.users.col_actions': 'ACTIONS',
  'admin.users.status_verified': 'verified',
  'admin.users.status_unverified': 'unverified',
  'admin.users.status_blocked': 'blocked',
  'admin.users.status_active': 'active',
  'admin.users.role_admin': 'admin',
  'admin.users.role_user': 'user',
  'admin.users.empty': 'No users yet',
  'admin.users.empty_search': 'Nothing found for this search',
  'admin.users.load_error': 'Failed to load users',
  'admin.users.action_verify': 'Verify email',
  'admin.users.confirm_verify': 'Mark {email} as verified?',
  'admin.users.action_block': 'Block',
  'admin.users.confirm_block':
    'Block {email}? Active sessions will be revoked and login will be denied.',
  'admin.users.block_reason_label': 'Block reason (optional)',
  'admin.users.block_reason_placeholder': 'Reason for the audit log…',
  'admin.users.action_unblock': 'Unblock',
  'admin.users.confirm_unblock': 'Unblock the user and allow login again?',
  'admin.users.action_send_reset': 'Send password reset',
  'admin.users.confirm_send_reset': 'A password reset email will be sent to {email}.',
  'admin.users.action_promote': 'Grant admin',
  'admin.users.confirm_promote': 'Grant this user platform admin access?',
  'admin.users.action_demote': 'Revoke admin',
  'admin.users.confirm_demote': 'Revoke platform admin access from this user?',
  'admin.users.detail_title': 'User details',
  'admin.users.detail_empty': 'Select a user to see details',
  'admin.users.detail_memberships': 'Workspace memberships',
  'admin.users.detail_no_memberships': 'No workspace memberships',
  'admin.users.detail_sessions': 'Active sessions',
  'admin.users.detail_no_sessions': 'No active sessions',
  'admin.users.session_device': 'Device',
  'admin.users.session_unknown_device': 'Unknown device',
  'admin.users.session_ip': 'IP',
  'admin.users.session_last_used': 'Last used',
  'admin.users.session_expires': 'Expires',

  // ─── Platform admin (P1: workspaces) ────────────────────────────────────────
  'admin.workspaces.title': 'Workspaces',
  'admin.workspaces.subtitle': '{visible} of {total} workspaces',
  'admin.workspaces.reload': 'Reload',
  'admin.workspaces.search_label': 'Search workspaces by name or slug',
  'admin.workspaces.search_placeholder': 'Search by name or slug…',
  'admin.workspaces.col_name': 'NAME',
  'admin.workspaces.col_owner': 'OWNER',
  'admin.workspaces.col_members': 'MEMBERS',
  'admin.workspaces.col_deals': 'DEALS',
  'admin.workspaces.col_spend': 'LLM SPEND',
  'admin.workspaces.col_kind': 'KIND',
  'admin.workspaces.col_status': 'STATUS',
  'admin.workspaces.col_created': 'CREATED',
  'admin.workspaces.col_member_user': 'MEMBER',
  'admin.workspaces.col_member_role': 'ROLE',
  'admin.workspaces.col_member_status': 'STATUS',
  'admin.workspaces.col_member_joined': 'JOINED',
  'admin.workspaces.kind_business': 'business',
  'admin.workspaces.kind_personal': 'personal',
  'admin.workspaces.status_active': 'active',
  'admin.workspaces.status_blocked': 'blocked',
  'admin.workspaces.empty': 'No workspaces yet',
  'admin.workspaces.empty_search': 'Nothing found for this query',
  'admin.workspaces.load_error': 'Failed to load workspaces',
  'admin.workspaces.detail_empty': 'Select a workspace to see details',
  'admin.workspaces.detail_plan': 'Plan',
  'admin.workspaces.detail_timezone': 'Timezone',
  'admin.workspaces.detail_created': 'Created',
  'admin.workspaces.detail_members': 'Members',
  'admin.workspaces.detail_no_members': 'No members',
  'admin.workspaces.detail_spend': 'LLM spend',
  'admin.workspaces.counter_deals': 'Deals',
  'admin.workspaces.counter_contacts': 'Contacts',
  'admin.workspaces.counter_tasks': 'Tasks',
  'admin.workspaces.counter_messages': 'Messages',
  'admin.workspaces.counter_active_members': 'Active',
  'admin.workspaces.action_block': 'Block',
  'admin.workspaces.confirm_block':
    'Block "{name}"? Members lose access and background jobs stop. Data is kept.',
  'admin.workspaces.block_reason_label': 'Block reason (optional)',
  'admin.workspaces.block_reason_placeholder': 'Reason for the audit log…',
  'admin.workspaces.action_unblock': 'Unblock',
  'admin.workspaces.confirm_unblock':
    'Unblock the workspace? Members regain access and workers resume.',
  'admin.workspaces.detail_plan_limits': '{tokens} tokens/mo · {storage}',

  // ─── Platform admin (P0: plans) ──────────────────────────────────────────────
  'admin.plans.title': 'Plans',
  'admin.plans.subtitle': 'Plans total: {total}',
  'admin.plans.reload': 'Reload',
  'admin.plans.create': 'Add plan',
  'admin.plans.col_plan': 'PLAN',
  'admin.plans.col_price': 'PRICE',
  'admin.plans.col_cost': 'COST',
  'admin.plans.col_tokens': 'TOKENS/MO',
  'admin.plans.col_storage': 'STORAGE',
  'admin.plans.col_period': 'PERIOD',
  'admin.plans.col_order': 'ORDER',
  'admin.plans.col_status': 'STATUS',
  'admin.plans.col_actions': 'ACTIONS',
  'admin.plans.tokens_tooltip': 'Monthly LLM token limit',
  'admin.plans.period_monthly': 'monthly',
  'admin.plans.status_active': 'active',
  'admin.plans.status_inactive': 'deactivated',
  'admin.plans.empty': 'No plans yet',
  'admin.plans.load_error': 'Failed to load plans',
  'admin.plans.action_edit': 'Edit plan "{name}"',
  'admin.plans.action_edit_short': 'Edit',
  'admin.plans.action_deactivate': 'Deactivate',
  'admin.plans.action_deactivate_short': 'Deactivate',
  'admin.plans.confirm_deactivate':
    'Deactivate plan "{name}"? Existing workspaces keep it; the row can be re-enabled later.',
  'admin.plans.action_activate': 'Enable',
  'admin.plans.deactivated': 'Plan deactivated',
  'admin.plans.activated': 'Plan enabled',
  'admin.plans.saved': 'Plan saved',
  'admin.plans.created': 'Plan created',
  'admin.plans.create_title': 'New plan',
  'admin.plans.edit_title': 'Edit plan',
  'admin.plans.save': 'Save',
  'admin.plans.field_code': 'Code',
  'admin.plans.code_hint': 'Lowercase letters, digits and dashes; fixed after creation',
  'admin.plans.code_locked_hint': 'The code is immutable — workspaces reference it',
  'admin.plans.code_required': 'Enter a plan code',
  'admin.plans.code_pattern': 'Lowercase letters, digits and dashes only',
  'admin.plans.field_name': 'Name',
  'admin.plans.name_placeholder': 'Pro',
  'admin.plans.name_required': 'Enter a name',
  'admin.plans.field_price': 'Price, $/mo',
  'admin.plans.field_cost': 'Cost, $/mo',
  'admin.plans.field_tokens': 'Monthly token limit',
  'admin.plans.field_storage': 'Storage',
  'admin.plans.storage_unit': 'GB',
  'admin.plans.field_order': 'Sort order',
  'admin.plans.field_required': 'This field is required',
  'admin.plans.error_code_exists': 'A plan with this code already exists',
  'admin.plans.error_save_failed': 'Failed to save the plan',

  // ─── Platform admin (P1: LLM monitoring) ────────────────────────────────────
  'admin.llm.title': 'LLM spend',
  'admin.llm.subtitle': 'Period: {from} — {to}',
  'admin.llm.reload': 'Reload',
  'admin.llm.period_label': 'LLM spend period',
  'admin.llm.period_days': 'Last {days} days',
  'admin.llm.period_custom': 'Custom range',
  'admin.llm.range_label': 'Date range',
  'admin.llm.kpi_spend': 'Spend in period',
  'admin.llm.kpi_tokens': 'Tokens',
  'admin.llm.kpi_messages': 'Messages',
  'admin.llm.tab_by_workspace': 'By workspaces',
  'admin.llm.tab_by_profile': 'By profiles',
  'admin.llm.tab_top_conversations': 'Top conversations',
  'admin.llm.col_workspace': 'WORKSPACE',
  'admin.llm.col_profile': 'PROFILE',
  'admin.llm.col_conversations': 'CONVERSATIONS',
  'admin.llm.col_messages': 'MESSAGES',
  'admin.llm.col_tokens': 'TOKENS',
  'admin.llm.col_cost': 'SPEND',
  'admin.llm.col_conversation': 'CONVERSATION',
  'admin.llm.col_user': 'USER',
  'admin.llm.col_last_message': 'LAST MESSAGE',
  'admin.llm.unassigned': 'no workspace',
  'admin.llm.unassigned_hint': 'Messages recorded before workspace scoping existed',
  'admin.llm.untitled': 'Untitled',
  'admin.llm.empty': 'No data for the selected period',
  'admin.llm.load_error': 'Failed to load LLM aggregations',
  'admin.llm.profile.neuraldeep': 'neuraldeep',
  'admin.llm.profile.openrouter': 'openrouter',
  'admin.llm.profile.govard': 'govard',
  'admin.llm.profile.opencode': 'opencode',

  // ─── Platform admin panel (P2: mail and audit) ───────────────────────────────
  'admin.common.period_label': 'Period',
  'admin.common.period_all': 'All time',
  'admin.common.period_24h': '24 hours',
  'admin.common.period_7d': '7 days',
  'admin.common.period_30d': '30 days',

  'admin.mail.title': 'Mail queue',
  'admin.mail.subtitle': '{visible} of {total} messages',
  'admin.mail.reload': 'Refresh',
  'admin.mail.load_error': 'Failed to load the mail queue',
  'admin.mail.search_label': 'Search messages by email or subject',
  'admin.mail.search_placeholder': 'Search by email or subject…',
  'admin.mail.status_filter_label': 'Status filter',
  'admin.mail.kind_filter_label': 'Kind filter',
  'admin.mail.filter_all': 'All',
  'admin.mail.empty': 'No messages yet',
  'admin.mail.empty_search': 'Nothing found for this search',
  'admin.mail.col_subject': 'SUBJECT',
  'admin.mail.col_to': 'RECIPIENT',
  'admin.mail.col_kind': 'KIND',
  'admin.mail.col_status': 'STATUS',
  'admin.mail.col_attempts': 'ATTEMPTS',
  'admin.mail.col_available_at': 'AVAILABLE AT',
  'admin.mail.col_last_error': 'LAST ERROR',
  'admin.mail.col_sent_at': 'SENT',
  'admin.mail.col_actions': 'ACTIONS',
  'admin.mail.kind.meeting_invited': 'Meeting invitation',
  'admin.mail.kind.meeting_updated': 'Meeting update',
  'admin.mail.kind.meeting_cancelled': 'Meeting cancellation',
  'admin.mail.kind.workspace_invited': 'Workspace invitation',
  'admin.mail.kind.password_reset': 'Password reset',
  'admin.mail.kind.email_verification': 'Email verification',
  'admin.mail.kind.agent_email': 'Agent email',
  'admin.mail.detail_title': 'Message details',
  'admin.mail.detail_empty': 'Select a message to see details',
  'admin.mail.detail_to': 'Recipient',
  'admin.mail.detail_workspace': 'Workspace',
  'admin.mail.detail_kind': 'Kind',
  'admin.mail.detail_status': 'Status',
  'admin.mail.detail_attempts': 'Attempts',
  'admin.mail.detail_available_at': 'Available from',
  'admin.mail.detail_last_error': 'Last error',
  'admin.mail.detail_sent_at': 'Sent',
  'admin.mail.detail_delivered_at': 'Delivered',
  'admin.mail.detail_provider_id': 'Provider message ID',
  'admin.mail.detail_dedupe_key': 'Dedupe key',
  'admin.mail.detail_created_at': 'Created',
  'admin.mail.detail_updated_at': 'Updated',
  'admin.mail.retry': 'Retry',
  'admin.mail.retry_confirm': 'Requeue this message for sending?',
  'admin.mail.retry_queued': 'The message is back in the queue',
  'admin.mail.retry_invalid_status': 'Retry is only available for failed or bounced messages',

  'admin.audit.title': 'Audit log',
  'admin.audit.subtitle': '{visible} of {total} entries',
  'admin.audit.reload': 'Refresh',
  'admin.audit.load_error': 'Failed to load the audit log',
  'admin.audit.action_filter_label': 'Action filter',
  'admin.audit.filter_all': 'All',
  'admin.audit.empty': 'No entries yet',
  'admin.audit.empty_search': 'Nothing found for this search',
  'admin.audit.col_time': 'TIME',
  'admin.audit.col_actor': 'ACTOR',
  'admin.audit.col_action': 'ACTION',
  'admin.audit.col_target': 'TARGET',
  'admin.audit.col_metadata': 'METADATA',
  'admin.audit.action.user_verify': 'Email verification',
  'admin.audit.action.user_block': 'User blocked',
  'admin.audit.action.user_unblock': 'User unblocked',
  'admin.audit.action.user_send_reset': 'Password reset sent',
  'admin.audit.action.user_platform_role': 'Platform role changed',
  'admin.audit.action.workspace_block': 'Workspace blocked',
  'admin.audit.action.workspace_unblock': 'Workspace unblocked',
  'admin.audit.action.mail_retry': 'Mail retried',
  'admin.audit.action.plan_config_create': 'Plan created',
  'admin.audit.action.plan_config_update': 'Plan updated',
  'admin.audit.action.plan_config_deactivate': 'Plan deactivated',

  'admin.errors.action_failed': 'Action failed. Try again.',
  'admin.errors.last_admin_demote': 'Cannot demote the last platform admin.',
  'admin.errors.not_platform_admin': 'Platform admin access is required.',
};
